
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref1d2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref1d2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aPfka", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7e1a8de1463f8dc5$export$ffb0004e005737fa, (v) => $7e1a8de1463f8dc5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7e1a8de1463f8dc5$export$34b9dba7ce09269b, (v) => $7e1a8de1463f8dc5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7e1a8de1463f8dc5$export$25062201e9e25d76, (v) => $7e1a8de1463f8dc5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e1a8de1463f8dc5$export$ffb0004e005737fa;
var $7e1a8de1463f8dc5$export$34b9dba7ce09269b;
var $7e1a8de1463f8dc5$export$25062201e9e25d76;
"use strict";

var $aqdBs = parcelRequire("aqdBs");
var $7e1a8de1463f8dc5$var$k = Symbol.for("react.element"), $7e1a8de1463f8dc5$var$l = Symbol.for("react.fragment"), $7e1a8de1463f8dc5$var$m = Object.prototype.hasOwnProperty, $7e1a8de1463f8dc5$var$n = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7e1a8de1463f8dc5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7e1a8de1463f8dc5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7e1a8de1463f8dc5$var$m.call(a, b) && !$7e1a8de1463f8dc5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7e1a8de1463f8dc5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7e1a8de1463f8dc5$var$n.current
    };
}
$7e1a8de1463f8dc5$export$ffb0004e005737fa = $7e1a8de1463f8dc5$var$l;
$7e1a8de1463f8dc5$export$34b9dba7ce09269b = $7e1a8de1463f8dc5$var$q;
$7e1a8de1463f8dc5$export$25062201e9e25d76 = $7e1a8de1463f8dc5$var$q;

});
parcelRegister("aqdBs", function(module, exports) {
"use strict";

module.exports = (parcelRequire("WCsmQ"));

});
parcelRegister("WCsmQ", function(module, exports) {

$parcel$export(module.exports, "Children", () => $0b033f8fda7971e0$export$dca3b0875bd9a954, (v) => $0b033f8fda7971e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0b033f8fda7971e0$export$16fa2f45be04daa8, (v) => $0b033f8fda7971e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0b033f8fda7971e0$export$ffb0004e005737fa, (v) => $0b033f8fda7971e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0b033f8fda7971e0$export$e2c29f18771995cb, (v) => $0b033f8fda7971e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0b033f8fda7971e0$export$221d75b3f55bb0bd, (v) => $0b033f8fda7971e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0b033f8fda7971e0$export$5f8d39834fd61797, (v) => $0b033f8fda7971e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0b033f8fda7971e0$export$74bf444e3cd11ea5, (v) => $0b033f8fda7971e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b033f8fda7971e0$export$ae55be85d98224ed, (v) => $0b033f8fda7971e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0b033f8fda7971e0$export$3ba232387fd5d6dd, (v) => $0b033f8fda7971e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0b033f8fda7971e0$export$e530037191fcd5d7, (v) => $0b033f8fda7971e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0b033f8fda7971e0$export$fd42f52fd3ae1109, (v) => $0b033f8fda7971e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0b033f8fda7971e0$export$c8a8987d4410bf2d, (v) => $0b033f8fda7971e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0b033f8fda7971e0$export$d38cd72104c1f0e9, (v) => $0b033f8fda7971e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0b033f8fda7971e0$export$7d1e3a5e95ceca43, (v) => $0b033f8fda7971e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0b033f8fda7971e0$export$257a8862b851cb5b, (v) => $0b033f8fda7971e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0b033f8fda7971e0$export$a8257692ac88316c, (v) => $0b033f8fda7971e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0b033f8fda7971e0$export$488013bae63b21da, (v) => $0b033f8fda7971e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0b033f8fda7971e0$export$7c73462e0d25e514, (v) => $0b033f8fda7971e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0b033f8fda7971e0$export$7568632d0d33d16d, (v) => $0b033f8fda7971e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0b033f8fda7971e0$export$88948ce120ea2619, (v) => $0b033f8fda7971e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0b033f8fda7971e0$export$35808ee640e87ca7, (v) => $0b033f8fda7971e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0b033f8fda7971e0$export$fae74005e78b1a27, (v) => $0b033f8fda7971e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e, (v) => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0b033f8fda7971e0$export$6a7bc4e911dc01cf, (v) => $0b033f8fda7971e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0b033f8fda7971e0$export$6d9c69b0de29b591, (v) => $0b033f8fda7971e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0b033f8fda7971e0$export$f680877a34711e37, (v) => $0b033f8fda7971e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0b033f8fda7971e0$export$d5a552a76deda3c2, (v) => $0b033f8fda7971e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0b033f8fda7971e0$export$aaabe4eda9ed9969, (v) => $0b033f8fda7971e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0b033f8fda7971e0$export$e5c5a5f917a5871c, (v) => $0b033f8fda7971e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0b033f8fda7971e0$export$1538c33de8887b59, (v) => $0b033f8fda7971e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0b033f8fda7971e0$export$13e3392192263954, (v) => $0b033f8fda7971e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0b033f8fda7971e0$export$b8f5890fc79d6aca, (v) => $0b033f8fda7971e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0b033f8fda7971e0$export$60241385465d0a34, (v) => $0b033f8fda7971e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0b033f8fda7971e0$export$306c0aa65ff9ec16, (v) => $0b033f8fda7971e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0b033f8fda7971e0$export$7b286972b8d8ccbf, (v) => $0b033f8fda7971e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0b033f8fda7971e0$export$83d89fbfd8236492, (v) => $0b033f8fda7971e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b033f8fda7971e0$export$dca3b0875bd9a954;
var $0b033f8fda7971e0$export$16fa2f45be04daa8;
var $0b033f8fda7971e0$export$ffb0004e005737fa;
var $0b033f8fda7971e0$export$e2c29f18771995cb;
var $0b033f8fda7971e0$export$221d75b3f55bb0bd;
var $0b033f8fda7971e0$export$5f8d39834fd61797;
var $0b033f8fda7971e0$export$74bf444e3cd11ea5;
var $0b033f8fda7971e0$export$ae55be85d98224ed;
var $0b033f8fda7971e0$export$3ba232387fd5d6dd;
var $0b033f8fda7971e0$export$e530037191fcd5d7;
var $0b033f8fda7971e0$export$fd42f52fd3ae1109;
var $0b033f8fda7971e0$export$c8a8987d4410bf2d;
var $0b033f8fda7971e0$export$d38cd72104c1f0e9;
var $0b033f8fda7971e0$export$7d1e3a5e95ceca43;
var $0b033f8fda7971e0$export$257a8862b851cb5b;
var $0b033f8fda7971e0$export$a8257692ac88316c;
var $0b033f8fda7971e0$export$488013bae63b21da;
var $0b033f8fda7971e0$export$7c73462e0d25e514;
var $0b033f8fda7971e0$export$7568632d0d33d16d;
var $0b033f8fda7971e0$export$88948ce120ea2619;
var $0b033f8fda7971e0$export$35808ee640e87ca7;
var $0b033f8fda7971e0$export$fae74005e78b1a27;
var $0b033f8fda7971e0$export$dc8fbce3eb94dc1e;
var $0b033f8fda7971e0$export$6a7bc4e911dc01cf;
var $0b033f8fda7971e0$export$6d9c69b0de29b591;
var $0b033f8fda7971e0$export$f680877a34711e37;
var $0b033f8fda7971e0$export$d5a552a76deda3c2;
var $0b033f8fda7971e0$export$aaabe4eda9ed9969;
var $0b033f8fda7971e0$export$e5c5a5f917a5871c;
var $0b033f8fda7971e0$export$1538c33de8887b59;
var $0b033f8fda7971e0$export$13e3392192263954;
var $0b033f8fda7971e0$export$b8f5890fc79d6aca;
var $0b033f8fda7971e0$export$60241385465d0a34;
var $0b033f8fda7971e0$export$306c0aa65ff9ec16;
var $0b033f8fda7971e0$export$7b286972b8d8ccbf;
var $0b033f8fda7971e0$export$83d89fbfd8236492;
"use strict";
var $0b033f8fda7971e0$var$l = Symbol.for("react.element"), $0b033f8fda7971e0$var$n = Symbol.for("react.portal"), $0b033f8fda7971e0$var$p = Symbol.for("react.fragment"), $0b033f8fda7971e0$var$q = Symbol.for("react.strict_mode"), $0b033f8fda7971e0$var$r = Symbol.for("react.profiler"), $0b033f8fda7971e0$var$t = Symbol.for("react.provider"), $0b033f8fda7971e0$var$u = Symbol.for("react.context"), $0b033f8fda7971e0$var$v = Symbol.for("react.forward_ref"), $0b033f8fda7971e0$var$w = Symbol.for("react.suspense"), $0b033f8fda7971e0$var$x = Symbol.for("react.memo"), $0b033f8fda7971e0$var$y = Symbol.for("react.lazy"), $0b033f8fda7971e0$var$z = Symbol.iterator;
function $0b033f8fda7971e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b033f8fda7971e0$var$z && a[$0b033f8fda7971e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b033f8fda7971e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0b033f8fda7971e0$var$C = Object.assign, $0b033f8fda7971e0$var$D = {};
function $0b033f8fda7971e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
$0b033f8fda7971e0$var$E.prototype.isReactComponent = {};
$0b033f8fda7971e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0b033f8fda7971e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0b033f8fda7971e0$var$F() {}
$0b033f8fda7971e0$var$F.prototype = $0b033f8fda7971e0$var$E.prototype;
function $0b033f8fda7971e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
var $0b033f8fda7971e0$var$H = $0b033f8fda7971e0$var$G.prototype = new $0b033f8fda7971e0$var$F;
$0b033f8fda7971e0$var$H.constructor = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$var$C($0b033f8fda7971e0$var$H, $0b033f8fda7971e0$var$E.prototype);
$0b033f8fda7971e0$var$H.isPureReactComponent = !0;
var $0b033f8fda7971e0$var$I = Array.isArray, $0b033f8fda7971e0$var$J = Object.prototype.hasOwnProperty, $0b033f8fda7971e0$var$K = {
    current: null
}, $0b033f8fda7971e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0b033f8fda7971e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0b033f8fda7971e0$var$J.call(b, d) && !$0b033f8fda7971e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0b033f8fda7971e0$var$K.current
    };
}
function $0b033f8fda7971e0$var$N(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0b033f8fda7971e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0b033f8fda7971e0$var$l;
}
function $0b033f8fda7971e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0b033f8fda7971e0$var$P = /\/+/g;
function $0b033f8fda7971e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0b033f8fda7971e0$var$escape("" + a.key) : b.toString(36);
}
function $0b033f8fda7971e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0b033f8fda7971e0$var$l:
                case $0b033f8fda7971e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0b033f8fda7971e0$var$Q(h, 0) : d, $0b033f8fda7971e0$var$I(c) ? (e = "", null != a && (e = a.replace($0b033f8fda7971e0$var$P, "$&/") + "/"), $0b033f8fda7971e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0b033f8fda7971e0$var$O(c) && (c = $0b033f8fda7971e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0b033f8fda7971e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0b033f8fda7971e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0b033f8fda7971e0$var$Q(k, g);
        h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    }
    else if (f = $0b033f8fda7971e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0b033f8fda7971e0$var$Q(k, g++), h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0b033f8fda7971e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0b033f8fda7971e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0b033f8fda7971e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0b033f8fda7971e0$var$U = {
    current: null
}, $0b033f8fda7971e0$var$V = {
    transition: null
}, $0b033f8fda7971e0$var$W = {
    ReactCurrentDispatcher: $0b033f8fda7971e0$var$U,
    ReactCurrentBatchConfig: $0b033f8fda7971e0$var$V,
    ReactCurrentOwner: $0b033f8fda7971e0$var$K
};
function $0b033f8fda7971e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0b033f8fda7971e0$export$dca3b0875bd9a954 = {
    map: $0b033f8fda7971e0$var$S,
    forEach: function(a, b, e) {
        $0b033f8fda7971e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0b033f8fda7971e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0b033f8fda7971e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0b033f8fda7971e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0b033f8fda7971e0$export$16fa2f45be04daa8 = $0b033f8fda7971e0$var$E;
$0b033f8fda7971e0$export$ffb0004e005737fa = $0b033f8fda7971e0$var$p;
$0b033f8fda7971e0$export$e2c29f18771995cb = $0b033f8fda7971e0$var$r;
$0b033f8fda7971e0$export$221d75b3f55bb0bd = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$export$5f8d39834fd61797 = $0b033f8fda7971e0$var$q;
$0b033f8fda7971e0$export$74bf444e3cd11ea5 = $0b033f8fda7971e0$var$w;
$0b033f8fda7971e0$export$ae55be85d98224ed = $0b033f8fda7971e0$var$W;
$0b033f8fda7971e0$export$3ba232387fd5d6dd = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0b033f8fda7971e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0b033f8fda7971e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0b033f8fda7971e0$var$J.call(b, f) && !$0b033f8fda7971e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0b033f8fda7971e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0b033f8fda7971e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0b033f8fda7971e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0b033f8fda7971e0$export$c8a8987d4410bf2d = $0b033f8fda7971e0$var$M;
$0b033f8fda7971e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $0b033f8fda7971e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0b033f8fda7971e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0b033f8fda7971e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$v,
        render: a
    };
};
$0b033f8fda7971e0$export$a8257692ac88316c = $0b033f8fda7971e0$var$O;
$0b033f8fda7971e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0b033f8fda7971e0$var$T
    };
};
$0b033f8fda7971e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0b033f8fda7971e0$export$7568632d0d33d16d = function(a) {
    var b = $0b033f8fda7971e0$var$V.transition;
    $0b033f8fda7971e0$var$V.transition = {};
    try {
        a();
    } finally{
        $0b033f8fda7971e0$var$V.transition = b;
    }
};
$0b033f8fda7971e0$export$88948ce120ea2619 = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$35808ee640e87ca7 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useCallback(a, b);
};
$0b033f8fda7971e0$export$fae74005e78b1a27 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useContext(a);
};
$0b033f8fda7971e0$export$dc8fbce3eb94dc1e = function() {};
$0b033f8fda7971e0$export$6a7bc4e911dc01cf = function(a) {
    return $0b033f8fda7971e0$var$U.current.useDeferredValue(a);
};
$0b033f8fda7971e0$export$6d9c69b0de29b591 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useEffect(a, b);
};
$0b033f8fda7971e0$export$f680877a34711e37 = function() {
    return $0b033f8fda7971e0$var$U.current.useId();
};
$0b033f8fda7971e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useImperativeHandle(a, b, e);
};
$0b033f8fda7971e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useInsertionEffect(a, b);
};
$0b033f8fda7971e0$export$e5c5a5f917a5871c = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useLayoutEffect(a, b);
};
$0b033f8fda7971e0$export$1538c33de8887b59 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useMemo(a, b);
};
$0b033f8fda7971e0$export$13e3392192263954 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useReducer(a, b, e);
};
$0b033f8fda7971e0$export$b8f5890fc79d6aca = function(a) {
    return $0b033f8fda7971e0$var$U.current.useRef(a);
};
$0b033f8fda7971e0$export$60241385465d0a34 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useState(a);
};
$0b033f8fda7971e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useSyncExternalStore(a, b, e);
};
$0b033f8fda7971e0$export$7b286972b8d8ccbf = function() {
    return $0b033f8fda7971e0$var$U.current.useTransition();
};
$0b033f8fda7971e0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("l8cRS", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $f62453a6e3b4559e$export$ae55be85d98224ed, (v) => $f62453a6e3b4559e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $f62453a6e3b4559e$export$d39a5bbd09211389, (v) => $f62453a6e3b4559e$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $f62453a6e3b4559e$export$882461b6382ed46c, (v) => $f62453a6e3b4559e$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $f62453a6e3b4559e$export$466bfc07425424d5, (v) => $f62453a6e3b4559e$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $f62453a6e3b4559e$export$cd75ccfd720a3cd4, (v) => $f62453a6e3b4559e$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $f62453a6e3b4559e$export$fa8d919ba61d84db, (v) => $f62453a6e3b4559e$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $f62453a6e3b4559e$export$757ceba2d55c277e, (v) => $f62453a6e3b4559e$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $f62453a6e3b4559e$export$b3890eb0ae9dca99, (v) => $f62453a6e3b4559e$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $f62453a6e3b4559e$export$502457920280e6be, (v) => $f62453a6e3b4559e$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $f62453a6e3b4559e$export$c78a37762a8d58e1, (v) => $f62453a6e3b4559e$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $f62453a6e3b4559e$export$dc54d992c10e8a18, (v) => $f62453a6e3b4559e$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $f62453a6e3b4559e$export$83d89fbfd8236492, (v) => $f62453a6e3b4559e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f62453a6e3b4559e$export$ae55be85d98224ed;
var $f62453a6e3b4559e$export$d39a5bbd09211389;
var $f62453a6e3b4559e$export$882461b6382ed46c;
var $f62453a6e3b4559e$export$466bfc07425424d5;
var $f62453a6e3b4559e$export$cd75ccfd720a3cd4;
var $f62453a6e3b4559e$export$fa8d919ba61d84db;
var $f62453a6e3b4559e$export$757ceba2d55c277e;
var $f62453a6e3b4559e$export$b3890eb0ae9dca99;
var $f62453a6e3b4559e$export$502457920280e6be;
var $f62453a6e3b4559e$export$c78a37762a8d58e1;
var $f62453a6e3b4559e$export$dc54d992c10e8a18;
var $f62453a6e3b4559e$export$83d89fbfd8236492;
"use strict";

var $aqdBs = parcelRequire("aqdBs");

var $7zDBh = parcelRequire("7zDBh");
function $f62453a6e3b4559e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f62453a6e3b4559e$var$da = new Set, $f62453a6e3b4559e$var$ea = {};
function $f62453a6e3b4559e$var$fa(a, b) {
    $f62453a6e3b4559e$var$ha(a, b);
    $f62453a6e3b4559e$var$ha(a + "Capture", b);
}
function $f62453a6e3b4559e$var$ha(a, b) {
    $f62453a6e3b4559e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$da.add(b[a]);
}
var $f62453a6e3b4559e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f62453a6e3b4559e$var$ja = Object.prototype.hasOwnProperty, $f62453a6e3b4559e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f62453a6e3b4559e$var$la = {}, $f62453a6e3b4559e$var$ma = {};
function $f62453a6e3b4559e$var$oa(a) {
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$ma, a)) return !0;
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$la, a)) return !1;
    if ($f62453a6e3b4559e$var$ka.test(a)) return $f62453a6e3b4559e$var$ma[a] = !0;
    $f62453a6e3b4559e$var$la[a] = !0;
    return !1;
}
function $f62453a6e3b4559e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f62453a6e3b4559e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f62453a6e3b4559e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f62453a6e3b4559e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f62453a6e3b4559e$var$ra = /[\-:]([a-z])/g;
function $f62453a6e3b4559e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f62453a6e3b4559e$var$z.xlinkHref = new $f62453a6e3b4559e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f62453a6e3b4559e$var$ta(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$z.hasOwnProperty(b) ? $f62453a6e3b4559e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f62453a6e3b4559e$var$qa(b, c, e, d) && (c = null), d || null === e ? $f62453a6e3b4559e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f62453a6e3b4559e$var$ua = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f62453a6e3b4559e$var$va = Symbol.for("react.element"), $f62453a6e3b4559e$var$wa = Symbol.for("react.portal"), $f62453a6e3b4559e$var$ya = Symbol.for("react.fragment"), $f62453a6e3b4559e$var$za = Symbol.for("react.strict_mode"), $f62453a6e3b4559e$var$Aa = Symbol.for("react.profiler"), $f62453a6e3b4559e$var$Ba = Symbol.for("react.provider"), $f62453a6e3b4559e$var$Ca = Symbol.for("react.context"), $f62453a6e3b4559e$var$Da = Symbol.for("react.forward_ref"), $f62453a6e3b4559e$var$Ea = Symbol.for("react.suspense"), $f62453a6e3b4559e$var$Fa = Symbol.for("react.suspense_list"), $f62453a6e3b4559e$var$Ga = Symbol.for("react.memo"), $f62453a6e3b4559e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f62453a6e3b4559e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f62453a6e3b4559e$var$Ja = Symbol.iterator;
function $f62453a6e3b4559e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f62453a6e3b4559e$var$Ja && a[$f62453a6e3b4559e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f62453a6e3b4559e$var$A = Object.assign, $f62453a6e3b4559e$var$La;
function $f62453a6e3b4559e$var$Ma(a) {
    if (void 0 === $f62453a6e3b4559e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f62453a6e3b4559e$var$La = b && b[1] || "";
    }
    return "\n" + $f62453a6e3b4559e$var$La + a;
}
var $f62453a6e3b4559e$var$Na = !1;
function $f62453a6e3b4559e$var$Oa(a, b) {
    if (!a || $f62453a6e3b4559e$var$Na) return "";
    $f62453a6e3b4559e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f62453a6e3b4559e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f62453a6e3b4559e$var$Ma(a) : "";
}
function $f62453a6e3b4559e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f62453a6e3b4559e$var$Ma(a.type);
        case 16:
            return $f62453a6e3b4559e$var$Ma("Lazy");
        case 13:
            return $f62453a6e3b4559e$var$Ma("Suspense");
        case 19:
            return $f62453a6e3b4559e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !1), a;
        case 11:
            return a = $f62453a6e3b4559e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f62453a6e3b4559e$var$ya:
            return "Fragment";
        case $f62453a6e3b4559e$var$wa:
            return "Portal";
        case $f62453a6e3b4559e$var$Aa:
            return "Profiler";
        case $f62453a6e3b4559e$var$za:
            return "StrictMode";
        case $f62453a6e3b4559e$var$Ea:
            return "Suspense";
        case $f62453a6e3b4559e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f62453a6e3b4559e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f62453a6e3b4559e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f62453a6e3b4559e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f62453a6e3b4559e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f62453a6e3b4559e$var$Qa(a.type) || "Memo";
        case $f62453a6e3b4559e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f62453a6e3b4559e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f62453a6e3b4559e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f62453a6e3b4559e$var$Qa(b);
        case 8:
            return b === $f62453a6e3b4559e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f62453a6e3b4559e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f62453a6e3b4559e$var$Ua(a) {
    var b = $f62453a6e3b4559e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f62453a6e3b4559e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f62453a6e3b4559e$var$Ua(a));
}
function $f62453a6e3b4559e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f62453a6e3b4559e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f62453a6e3b4559e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f62453a6e3b4559e$var$Ya(a, b) {
    var c = b.checked;
    return $f62453a6e3b4559e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f62453a6e3b4559e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f62453a6e3b4559e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f62453a6e3b4559e$var$ab(a, b) {
    b = b.checked;
    null != b && $f62453a6e3b4559e$var$ta(a, "checked", b, !1);
}
function $f62453a6e3b4559e$var$bb(a, b) {
    $f62453a6e3b4559e$var$ab(a, b);
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f62453a6e3b4559e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f62453a6e3b4559e$var$cb(a, b.type, $f62453a6e3b4559e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f62453a6e3b4559e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f62453a6e3b4559e$var$cb(a, b, c) {
    if ("number" !== b || $f62453a6e3b4559e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f62453a6e3b4559e$var$eb = Array.isArray;
function $f62453a6e3b4559e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f62453a6e3b4559e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f62453a6e3b4559e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f62453a6e3b4559e$var$p(91));
    return $f62453a6e3b4559e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f62453a6e3b4559e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f62453a6e3b4559e$var$p(92));
            if ($f62453a6e3b4559e$var$eb(c)) {
                if (1 < c.length) throw Error($f62453a6e3b4559e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f62453a6e3b4559e$var$Sa(c)
    };
}
function $f62453a6e3b4559e$var$ib(a, b) {
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = $f62453a6e3b4559e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f62453a6e3b4559e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f62453a6e3b4559e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f62453a6e3b4559e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f62453a6e3b4559e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f62453a6e3b4559e$var$mb, $f62453a6e3b4559e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f62453a6e3b4559e$var$mb = $f62453a6e3b4559e$var$mb || document.createElement("div");
        $f62453a6e3b4559e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f62453a6e3b4559e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f62453a6e3b4559e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f62453a6e3b4559e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f62453a6e3b4559e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f62453a6e3b4559e$var$pb).forEach(function(a) {
    $f62453a6e3b4559e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f62453a6e3b4559e$var$pb[b] = $f62453a6e3b4559e$var$pb[a];
    });
});
function $f62453a6e3b4559e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f62453a6e3b4559e$var$pb.hasOwnProperty(a) && $f62453a6e3b4559e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f62453a6e3b4559e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f62453a6e3b4559e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f62453a6e3b4559e$var$tb = $f62453a6e3b4559e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f62453a6e3b4559e$var$ub(a, b) {
    if (b) {
        if ($f62453a6e3b4559e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f62453a6e3b4559e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f62453a6e3b4559e$var$p(62));
    }
}
function $f62453a6e3b4559e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f62453a6e3b4559e$var$wb = null;
function $f62453a6e3b4559e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f62453a6e3b4559e$var$yb = null, $f62453a6e3b4559e$var$zb = null, $f62453a6e3b4559e$var$Ab = null;
function $f62453a6e3b4559e$var$Bb(a) {
    if (a = $f62453a6e3b4559e$var$Cb(a)) {
        if ("function" !== typeof $f62453a6e3b4559e$var$yb) throw Error($f62453a6e3b4559e$var$p(280));
        var b = a.stateNode;
        b && (b = $f62453a6e3b4559e$var$Db(b), $f62453a6e3b4559e$var$yb(a.stateNode, a.type, b));
    }
}
function $f62453a6e3b4559e$var$Eb(a) {
    $f62453a6e3b4559e$var$zb ? $f62453a6e3b4559e$var$Ab ? $f62453a6e3b4559e$var$Ab.push(a) : $f62453a6e3b4559e$var$Ab = [
        a
    ] : $f62453a6e3b4559e$var$zb = a;
}
function $f62453a6e3b4559e$var$Fb() {
    if ($f62453a6e3b4559e$var$zb) {
        var a = $f62453a6e3b4559e$var$zb, b = $f62453a6e3b4559e$var$Ab;
        $f62453a6e3b4559e$var$Ab = $f62453a6e3b4559e$var$zb = null;
        $f62453a6e3b4559e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$Bb(b[a]);
    }
}
function $f62453a6e3b4559e$var$Gb(a, b) {
    return a(b);
}
function $f62453a6e3b4559e$var$Hb() {}
var $f62453a6e3b4559e$var$Ib = !1;
function $f62453a6e3b4559e$var$Jb(a, b, c) {
    if ($f62453a6e3b4559e$var$Ib) return a(b, c);
    $f62453a6e3b4559e$var$Ib = !0;
    try {
        return $f62453a6e3b4559e$var$Gb(a, b, c);
    } finally{
        if ($f62453a6e3b4559e$var$Ib = !1, null !== $f62453a6e3b4559e$var$zb || null !== $f62453a6e3b4559e$var$Ab) $f62453a6e3b4559e$var$Hb(), $f62453a6e3b4559e$var$Fb();
    }
}
function $f62453a6e3b4559e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f62453a6e3b4559e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f62453a6e3b4559e$var$p(231, b, typeof c));
    return c;
}
var $f62453a6e3b4559e$var$Lb = !1;
if ($f62453a6e3b4559e$var$ia) try {
    var $f62453a6e3b4559e$var$Mb = {};
    Object.defineProperty($f62453a6e3b4559e$var$Mb, "passive", {
        get: function() {
            $f62453a6e3b4559e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
    window.removeEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
} catch (a) {
    $f62453a6e3b4559e$var$Lb = !1;
}
function $f62453a6e3b4559e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f62453a6e3b4559e$var$Ob = !1, $f62453a6e3b4559e$var$Pb = null, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, $f62453a6e3b4559e$var$Sb = {
    onError: function(a) {
        $f62453a6e3b4559e$var$Ob = !0;
        $f62453a6e3b4559e$var$Pb = a;
    }
};
function $f62453a6e3b4559e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Ob = !1;
    $f62453a6e3b4559e$var$Pb = null;
    $f62453a6e3b4559e$var$Nb.apply($f62453a6e3b4559e$var$Sb, arguments);
}
function $f62453a6e3b4559e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Tb.apply(this, arguments);
    if ($f62453a6e3b4559e$var$Ob) {
        if ($f62453a6e3b4559e$var$Ob) {
            var l = $f62453a6e3b4559e$var$Pb;
            $f62453a6e3b4559e$var$Ob = !1;
            $f62453a6e3b4559e$var$Pb = null;
        } else throw Error($f62453a6e3b4559e$var$p(198));
        $f62453a6e3b4559e$var$Qb || ($f62453a6e3b4559e$var$Qb = !0, $f62453a6e3b4559e$var$Rb = l);
    }
}
function $f62453a6e3b4559e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f62453a6e3b4559e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f62453a6e3b4559e$var$Xb(a) {
    if ($f62453a6e3b4559e$var$Vb(a) !== a) throw Error($f62453a6e3b4559e$var$p(188));
}
function $f62453a6e3b4559e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f62453a6e3b4559e$var$Vb(a);
        if (null === b) throw Error($f62453a6e3b4559e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f62453a6e3b4559e$var$Xb(e), a;
                if (f === d) return $f62453a6e3b4559e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f62453a6e3b4559e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f62453a6e3b4559e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f62453a6e3b4559e$var$p(190));
    }
    if (3 !== c.tag) throw Error($f62453a6e3b4559e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f62453a6e3b4559e$var$Zb(a) {
    a = $f62453a6e3b4559e$var$Yb(a);
    return null !== a ? $f62453a6e3b4559e$var$$b(a) : null;
}
function $f62453a6e3b4559e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f62453a6e3b4559e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$ac = $7zDBh.unstable_scheduleCallback, $f62453a6e3b4559e$var$bc = $7zDBh.unstable_cancelCallback, $f62453a6e3b4559e$var$cc = $7zDBh.unstable_shouldYield, $f62453a6e3b4559e$var$dc = $7zDBh.unstable_requestPaint, $f62453a6e3b4559e$var$B = $7zDBh.unstable_now, $f62453a6e3b4559e$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $f62453a6e3b4559e$var$fc = $7zDBh.unstable_ImmediatePriority, $f62453a6e3b4559e$var$gc = $7zDBh.unstable_UserBlockingPriority, $f62453a6e3b4559e$var$hc = $7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$ic = $7zDBh.unstable_LowPriority, $f62453a6e3b4559e$var$jc = $7zDBh.unstable_IdlePriority, $f62453a6e3b4559e$var$kc = null, $f62453a6e3b4559e$var$lc = null;
function $f62453a6e3b4559e$var$mc(a) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberRoot) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberRoot($f62453a6e3b4559e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f62453a6e3b4559e$var$oc = Math.clz32 ? Math.clz32 : $f62453a6e3b4559e$var$nc, $f62453a6e3b4559e$var$pc = Math.log, $f62453a6e3b4559e$var$qc = Math.LN2;
function $f62453a6e3b4559e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f62453a6e3b4559e$var$pc(a) / $f62453a6e3b4559e$var$qc | 0) | 0;
}
var $f62453a6e3b4559e$var$rc = 64, $f62453a6e3b4559e$var$sc = 4194304;
function $f62453a6e3b4559e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f62453a6e3b4559e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f62453a6e3b4559e$var$tc(h) : (f &= g, 0 !== f && (d = $f62453a6e3b4559e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f62453a6e3b4559e$var$tc(g) : 0 !== f && (d = $f62453a6e3b4559e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f62453a6e3b4559e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f62453a6e3b4559e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f62453a6e3b4559e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f62453a6e3b4559e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f62453a6e3b4559e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f62453a6e3b4559e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f62453a6e3b4559e$var$yc() {
    var a = $f62453a6e3b4559e$var$rc;
    $f62453a6e3b4559e$var$rc <<= 1;
    0 === ($f62453a6e3b4559e$var$rc & 4194240) && ($f62453a6e3b4559e$var$rc = 64);
    return a;
}
function $f62453a6e3b4559e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f62453a6e3b4559e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f62453a6e3b4559e$var$oc(b);
    a[b] = c;
}
function $f62453a6e3b4559e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f62453a6e3b4559e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f62453a6e3b4559e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f62453a6e3b4559e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f62453a6e3b4559e$var$C = 0;
function $f62453a6e3b4559e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f62453a6e3b4559e$var$Ec, $f62453a6e3b4559e$var$Fc, $f62453a6e3b4559e$var$Gc, $f62453a6e3b4559e$var$Hc, $f62453a6e3b4559e$var$Ic, $f62453a6e3b4559e$var$Jc = !1, $f62453a6e3b4559e$var$Kc = [], $f62453a6e3b4559e$var$Lc = null, $f62453a6e3b4559e$var$Mc = null, $f62453a6e3b4559e$var$Nc = null, $f62453a6e3b4559e$var$Oc = new Map, $f62453a6e3b4559e$var$Pc = new Map, $f62453a6e3b4559e$var$Qc = [], $f62453a6e3b4559e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f62453a6e3b4559e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f62453a6e3b4559e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f62453a6e3b4559e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f62453a6e3b4559e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f62453a6e3b4559e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f62453a6e3b4559e$var$Pc.delete(b.pointerId);
    }
}
function $f62453a6e3b4559e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f62453a6e3b4559e$var$Cb(b), null !== b && $f62453a6e3b4559e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f62453a6e3b4559e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f62453a6e3b4559e$var$Lc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f62453a6e3b4559e$var$Mc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f62453a6e3b4559e$var$Nc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f62453a6e3b4559e$var$Oc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f62453a6e3b4559e$var$Pc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f62453a6e3b4559e$var$Vc(a) {
    var b = $f62453a6e3b4559e$var$Wc(a.target);
    if (null !== b) {
        var c = $f62453a6e3b4559e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f62453a6e3b4559e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f62453a6e3b4559e$var$Ic(a.priority, function() {
                        $f62453a6e3b4559e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f62453a6e3b4559e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f62453a6e3b4559e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f62453a6e3b4559e$var$wb = d;
            c.target.dispatchEvent(d);
            $f62453a6e3b4559e$var$wb = null;
        } else return b = $f62453a6e3b4559e$var$Cb(c), null !== b && $f62453a6e3b4559e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f62453a6e3b4559e$var$Zc(a, b, c) {
    $f62453a6e3b4559e$var$Xc(a) && c.delete(b);
}
function $f62453a6e3b4559e$var$$c() {
    $f62453a6e3b4559e$var$Jc = !1;
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Lc) && ($f62453a6e3b4559e$var$Lc = null);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Mc) && ($f62453a6e3b4559e$var$Mc = null);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Nc) && ($f62453a6e3b4559e$var$Nc = null);
    $f62453a6e3b4559e$var$Oc.forEach($f62453a6e3b4559e$var$Zc);
    $f62453a6e3b4559e$var$Pc.forEach($f62453a6e3b4559e$var$Zc);
}
function $f62453a6e3b4559e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f62453a6e3b4559e$var$Jc || ($f62453a6e3b4559e$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$$c)));
}
function $f62453a6e3b4559e$var$bd(a) {
    function b(b) {
        return $f62453a6e3b4559e$var$ad(b, a);
    }
    if (0 < $f62453a6e3b4559e$var$Kc.length) {
        $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Kc[0], a);
        for(var c = 1; c < $f62453a6e3b4559e$var$Kc.length; c++){
            var d = $f62453a6e3b4559e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Lc, a);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Mc, a);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Nc, a);
    $f62453a6e3b4559e$var$Oc.forEach(b);
    $f62453a6e3b4559e$var$Pc.forEach(b);
    for(c = 0; c < $f62453a6e3b4559e$var$Qc.length; c++)d = $f62453a6e3b4559e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f62453a6e3b4559e$var$Qc.length && (c = $f62453a6e3b4559e$var$Qc[0], null === c.blockedOn);)$f62453a6e3b4559e$var$Vc(c), null === c.blockedOn && $f62453a6e3b4559e$var$Qc.shift();
}
var $f62453a6e3b4559e$var$cd = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$dd = !0;
function $f62453a6e3b4559e$var$ed(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$gd(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 4, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$fd(a, b, c, d) {
    if ($f62453a6e3b4559e$var$dd) {
        var e = $f62453a6e3b4559e$var$Yc(a, b, c, d);
        if (null === e) $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c), $f62453a6e3b4559e$var$Sc(a, d);
        else if ($f62453a6e3b4559e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f62453a6e3b4559e$var$Sc(a, d), b & 4 && -1 < $f62453a6e3b4559e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f62453a6e3b4559e$var$Cb(e);
                null !== f && $f62453a6e3b4559e$var$Ec(f);
                f = $f62453a6e3b4559e$var$Yc(a, b, c, d);
                null === f && $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f62453a6e3b4559e$var$hd(a, b, d, null, c);
    }
}
var $f62453a6e3b4559e$var$id = null;
function $f62453a6e3b4559e$var$Yc(a, b, c, d) {
    $f62453a6e3b4559e$var$id = null;
    a = $f62453a6e3b4559e$var$xb(d);
    a = $f62453a6e3b4559e$var$Wc(a);
    if (null !== a) {
        if (b = $f62453a6e3b4559e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f62453a6e3b4559e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f62453a6e3b4559e$var$id = a;
    return null;
}
function $f62453a6e3b4559e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f62453a6e3b4559e$var$ec()){
                case $f62453a6e3b4559e$var$fc:
                    return 1;
                case $f62453a6e3b4559e$var$gc:
                    return 4;
                case $f62453a6e3b4559e$var$hc:
                case $f62453a6e3b4559e$var$ic:
                    return 16;
                case $f62453a6e3b4559e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ld = null, $f62453a6e3b4559e$var$md = null;
function $f62453a6e3b4559e$var$nd() {
    if ($f62453a6e3b4559e$var$md) return $f62453a6e3b4559e$var$md;
    var a, b = $f62453a6e3b4559e$var$ld, c = b.length, d, e = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f62453a6e3b4559e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f62453a6e3b4559e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f62453a6e3b4559e$var$pd() {
    return !0;
}
function $f62453a6e3b4559e$var$qd() {
    return !1;
}
function $f62453a6e3b4559e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f62453a6e3b4559e$var$pd : $f62453a6e3b4559e$var$qd;
        this.isPropagationStopped = $f62453a6e3b4559e$var$qd;
        return this;
    }
    $f62453a6e3b4559e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f62453a6e3b4559e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f62453a6e3b4559e$var$pd);
        },
        persist: function() {},
        isPersistent: $f62453a6e3b4559e$var$pd
    });
    return b;
}
var $f62453a6e3b4559e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f62453a6e3b4559e$var$td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$sd), $f62453a6e3b4559e$var$ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    view: 0,
    detail: 0
}), $f62453a6e3b4559e$var$vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$ud), $f62453a6e3b4559e$var$wd, $f62453a6e3b4559e$var$xd, $f62453a6e3b4559e$var$yd, $f62453a6e3b4559e$var$Ad = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f62453a6e3b4559e$var$yd && ($f62453a6e3b4559e$var$yd && "mousemove" === a.type ? ($f62453a6e3b4559e$var$wd = a.screenX - $f62453a6e3b4559e$var$yd.screenX, $f62453a6e3b4559e$var$xd = a.screenY - $f62453a6e3b4559e$var$yd.screenY) : $f62453a6e3b4559e$var$xd = $f62453a6e3b4559e$var$wd = 0, $f62453a6e3b4559e$var$yd = a);
        return $f62453a6e3b4559e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f62453a6e3b4559e$var$xd;
    }
}), $f62453a6e3b4559e$var$Bd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ad), $f62453a6e3b4559e$var$Cd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    dataTransfer: 0
}), $f62453a6e3b4559e$var$Dd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Cd), $f62453a6e3b4559e$var$Ed = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    relatedTarget: 0
}), $f62453a6e3b4559e$var$Fd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ed), $f62453a6e3b4559e$var$Gd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Hd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Gd), $f62453a6e3b4559e$var$Id = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f62453a6e3b4559e$var$Jd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Id), $f62453a6e3b4559e$var$Kd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    data: 0
}), $f62453a6e3b4559e$var$Ld = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Kd), $f62453a6e3b4559e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f62453a6e3b4559e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f62453a6e3b4559e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f62453a6e3b4559e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f62453a6e3b4559e$var$Od[a]) ? !!b[a] : !1;
}
function $f62453a6e3b4559e$var$zd() {
    return $f62453a6e3b4559e$var$Pd;
}
var $f62453a6e3b4559e$var$Qd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f62453a6e3b4559e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f62453a6e3b4559e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f62453a6e3b4559e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f62453a6e3b4559e$var$Rd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Qd), $f62453a6e3b4559e$var$Sd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f62453a6e3b4559e$var$Td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Sd), $f62453a6e3b4559e$var$Ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd
}), $f62453a6e3b4559e$var$Vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ud), $f62453a6e3b4559e$var$Wd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Xd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Wd), $f62453a6e3b4559e$var$Yd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f62453a6e3b4559e$var$Zd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Yd), $f62453a6e3b4559e$var$$d = [
    9,
    13,
    27,
    32
], $f62453a6e3b4559e$var$ae = $f62453a6e3b4559e$var$ia && "CompositionEvent" in window, $f62453a6e3b4559e$var$be = null;
$f62453a6e3b4559e$var$ia && "documentMode" in document && ($f62453a6e3b4559e$var$be = document.documentMode);
var $f62453a6e3b4559e$var$ce = $f62453a6e3b4559e$var$ia && "TextEvent" in window && !$f62453a6e3b4559e$var$be, $f62453a6e3b4559e$var$de = $f62453a6e3b4559e$var$ia && (!$f62453a6e3b4559e$var$ae || $f62453a6e3b4559e$var$be && 8 < $f62453a6e3b4559e$var$be && 11 >= $f62453a6e3b4559e$var$be), $f62453a6e3b4559e$var$ee = String.fromCharCode(32), $f62453a6e3b4559e$var$fe = !1;
function $f62453a6e3b4559e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f62453a6e3b4559e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f62453a6e3b4559e$var$ie = !1;
function $f62453a6e3b4559e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f62453a6e3b4559e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f62453a6e3b4559e$var$fe = !0;
            return $f62453a6e3b4559e$var$ee;
        case "textInput":
            return a = b.data, a === $f62453a6e3b4559e$var$ee && $f62453a6e3b4559e$var$fe ? null : a;
        default:
            return null;
    }
}
function $f62453a6e3b4559e$var$ke(a, b) {
    if ($f62453a6e3b4559e$var$ie) return "compositionend" === a || !$f62453a6e3b4559e$var$ae && $f62453a6e3b4559e$var$ge(a, b) ? (a = $f62453a6e3b4559e$var$nd(), $f62453a6e3b4559e$var$md = $f62453a6e3b4559e$var$ld = $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f62453a6e3b4559e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f62453a6e3b4559e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f62453a6e3b4559e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f62453a6e3b4559e$var$ne(a, b, c, d) {
    $f62453a6e3b4559e$var$Eb(d);
    b = $f62453a6e3b4559e$var$oe(b, "onChange");
    0 < b.length && (c = new $f62453a6e3b4559e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f62453a6e3b4559e$var$pe = null, $f62453a6e3b4559e$var$qe = null;
function $f62453a6e3b4559e$var$re(a) {
    $f62453a6e3b4559e$var$se(a, 0);
}
function $f62453a6e3b4559e$var$te(a) {
    var b = $f62453a6e3b4559e$var$ue(a);
    if ($f62453a6e3b4559e$var$Wa(b)) return a;
}
function $f62453a6e3b4559e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f62453a6e3b4559e$var$we = !1;
if ($f62453a6e3b4559e$var$ia) {
    var $f62453a6e3b4559e$var$xe;
    if ($f62453a6e3b4559e$var$ia) {
        var $f62453a6e3b4559e$var$ye = "oninput" in document;
        if (!$f62453a6e3b4559e$var$ye) {
            var $f62453a6e3b4559e$var$ze = document.createElement("div");
            $f62453a6e3b4559e$var$ze.setAttribute("oninput", "return;");
            $f62453a6e3b4559e$var$ye = "function" === typeof $f62453a6e3b4559e$var$ze.oninput;
        }
        $f62453a6e3b4559e$var$xe = $f62453a6e3b4559e$var$ye;
    } else $f62453a6e3b4559e$var$xe = !1;
    $f62453a6e3b4559e$var$we = $f62453a6e3b4559e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f62453a6e3b4559e$var$Ae() {
    $f62453a6e3b4559e$var$pe && ($f62453a6e3b4559e$var$pe.detachEvent("onpropertychange", $f62453a6e3b4559e$var$Be), $f62453a6e3b4559e$var$qe = $f62453a6e3b4559e$var$pe = null);
}
function $f62453a6e3b4559e$var$Be(a) {
    if ("value" === a.propertyName && $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe)) {
        var b = [];
        $f62453a6e3b4559e$var$ne(b, $f62453a6e3b4559e$var$qe, a, $f62453a6e3b4559e$var$xb(a));
        $f62453a6e3b4559e$var$Jb($f62453a6e3b4559e$var$re, b);
    }
}
function $f62453a6e3b4559e$var$Ce(a, b, c) {
    "focusin" === a ? ($f62453a6e3b4559e$var$Ae(), $f62453a6e3b4559e$var$pe = b, $f62453a6e3b4559e$var$qe = c, $f62453a6e3b4559e$var$pe.attachEvent("onpropertychange", $f62453a6e3b4559e$var$Be)) : "focusout" === a && $f62453a6e3b4559e$var$Ae();
}
function $f62453a6e3b4559e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe);
}
function $f62453a6e3b4559e$var$Ee(a, b) {
    if ("click" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f62453a6e3b4559e$var$He = "function" === typeof Object.is ? Object.is : $f62453a6e3b4559e$var$Ge;
function $f62453a6e3b4559e$var$Ie(a, b) {
    if ($f62453a6e3b4559e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f62453a6e3b4559e$var$ja.call(b, e) || !$f62453a6e3b4559e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f62453a6e3b4559e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f62453a6e3b4559e$var$Ke(a, b) {
    var c = $f62453a6e3b4559e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f62453a6e3b4559e$var$Je(c);
    }
}
function $f62453a6e3b4559e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f62453a6e3b4559e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f62453a6e3b4559e$var$Me() {
    for(var a = window, b = $f62453a6e3b4559e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f62453a6e3b4559e$var$Xa(a.document);
    }
    return b;
}
function $f62453a6e3b4559e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f62453a6e3b4559e$var$Oe(a) {
    var b = $f62453a6e3b4559e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f62453a6e3b4559e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f62453a6e3b4559e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f62453a6e3b4559e$var$Ke(c, f);
                var g = $f62453a6e3b4559e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f62453a6e3b4559e$var$Pe = $f62453a6e3b4559e$var$ia && "documentMode" in document && 11 >= document.documentMode, $f62453a6e3b4559e$var$Qe = null, $f62453a6e3b4559e$var$Re = null, $f62453a6e3b4559e$var$Se = null, $f62453a6e3b4559e$var$Te = !1;
function $f62453a6e3b4559e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f62453a6e3b4559e$var$Te || null == $f62453a6e3b4559e$var$Qe || $f62453a6e3b4559e$var$Qe !== $f62453a6e3b4559e$var$Xa(d) || (d = $f62453a6e3b4559e$var$Qe, "selectionStart" in d && $f62453a6e3b4559e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f62453a6e3b4559e$var$Se && $f62453a6e3b4559e$var$Ie($f62453a6e3b4559e$var$Se, d) || ($f62453a6e3b4559e$var$Se = d, d = $f62453a6e3b4559e$var$oe($f62453a6e3b4559e$var$Re, "onSelect"), 0 < d.length && (b = new $f62453a6e3b4559e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f62453a6e3b4559e$var$Qe)));
}
function $f62453a6e3b4559e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f62453a6e3b4559e$var$We = {
    animationend: $f62453a6e3b4559e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f62453a6e3b4559e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f62453a6e3b4559e$var$Ve("Animation", "AnimationStart"),
    transitionend: $f62453a6e3b4559e$var$Ve("Transition", "TransitionEnd")
}, $f62453a6e3b4559e$var$Xe = {}, $f62453a6e3b4559e$var$Ye = {};
$f62453a6e3b4559e$var$ia && ($f62453a6e3b4559e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f62453a6e3b4559e$var$We.animationend.animation, delete $f62453a6e3b4559e$var$We.animationiteration.animation, delete $f62453a6e3b4559e$var$We.animationstart.animation), "TransitionEvent" in window || delete $f62453a6e3b4559e$var$We.transitionend.transition);
function $f62453a6e3b4559e$var$Ze(a) {
    if ($f62453a6e3b4559e$var$Xe[a]) return $f62453a6e3b4559e$var$Xe[a];
    if (!$f62453a6e3b4559e$var$We[a]) return a;
    var b = $f62453a6e3b4559e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f62453a6e3b4559e$var$Ye) return $f62453a6e3b4559e$var$Xe[a] = b[c];
    return a;
}
var $f62453a6e3b4559e$var$$e = $f62453a6e3b4559e$var$Ze("animationend"), $f62453a6e3b4559e$var$af = $f62453a6e3b4559e$var$Ze("animationiteration"), $f62453a6e3b4559e$var$bf = $f62453a6e3b4559e$var$Ze("animationstart"), $f62453a6e3b4559e$var$cf = $f62453a6e3b4559e$var$Ze("transitionend"), $f62453a6e3b4559e$var$df = new Map, $f62453a6e3b4559e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f62453a6e3b4559e$var$ff(a, b) {
    $f62453a6e3b4559e$var$df.set(a, b);
    $f62453a6e3b4559e$var$fa(b, [
        a
    ]);
}
for(var $f62453a6e3b4559e$var$gf = 0; $f62453a6e3b4559e$var$gf < $f62453a6e3b4559e$var$ef.length; $f62453a6e3b4559e$var$gf++){
    var $f62453a6e3b4559e$var$hf = $f62453a6e3b4559e$var$ef[$f62453a6e3b4559e$var$gf], $f62453a6e3b4559e$var$jf = $f62453a6e3b4559e$var$hf.toLowerCase(), $f62453a6e3b4559e$var$kf = $f62453a6e3b4559e$var$hf[0].toUpperCase() + $f62453a6e3b4559e$var$hf.slice(1);
    $f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$jf, "on" + $f62453a6e3b4559e$var$kf);
}
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$$e, "onAnimationEnd");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$af, "onAnimationIteration");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$bf, "onAnimationStart");
$f62453a6e3b4559e$var$ff("dblclick", "onDoubleClick");
$f62453a6e3b4559e$var$ff("focusin", "onFocus");
$f62453a6e3b4559e$var$ff("focusout", "onBlur");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$cf, "onTransitionEnd");
$f62453a6e3b4559e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f62453a6e3b4559e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f62453a6e3b4559e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f62453a6e3b4559e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f62453a6e3b4559e$var$lf));
function $f62453a6e3b4559e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f62453a6e3b4559e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f62453a6e3b4559e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f62453a6e3b4559e$var$Qb) throw a = $f62453a6e3b4559e$var$Rb, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, a;
}
function $f62453a6e3b4559e$var$D(a, b) {
    var c = b[$f62453a6e3b4559e$var$of];
    void 0 === c && (c = b[$f62453a6e3b4559e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f62453a6e3b4559e$var$pf(b, a, 2, !1), c.add(d));
}
function $f62453a6e3b4559e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f62453a6e3b4559e$var$pf(c, a, d, b);
}
var $f62453a6e3b4559e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f62453a6e3b4559e$var$sf(a) {
    if (!a[$f62453a6e3b4559e$var$rf]) {
        a[$f62453a6e3b4559e$var$rf] = !0;
        $f62453a6e3b4559e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f62453a6e3b4559e$var$mf.has(b) || $f62453a6e3b4559e$var$qf(b, !1, a), $f62453a6e3b4559e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f62453a6e3b4559e$var$rf] || (b[$f62453a6e3b4559e$var$rf] = !0, $f62453a6e3b4559e$var$qf("selectionchange", !1, b));
    }
}
function $f62453a6e3b4559e$var$pf(a, b, c, d) {
    switch($f62453a6e3b4559e$var$jd(b)){
        case 1:
            var e = $f62453a6e3b4559e$var$ed;
            break;
        case 4:
            e = $f62453a6e3b4559e$var$gd;
            break;
        default:
            e = $f62453a6e3b4559e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f62453a6e3b4559e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f62453a6e3b4559e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f62453a6e3b4559e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f62453a6e3b4559e$var$Jb(function() {
        var d = f, e = $f62453a6e3b4559e$var$xb(c), g = [];
        a: {
            var h = $f62453a6e3b4559e$var$df.get(a);
            if (void 0 !== h) {
                var k = $f62453a6e3b4559e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f62453a6e3b4559e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f62453a6e3b4559e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f62453a6e3b4559e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f62453a6e3b4559e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f62453a6e3b4559e$var$Vd;
                        break;
                    case $f62453a6e3b4559e$var$$e:
                    case $f62453a6e3b4559e$var$af:
                    case $f62453a6e3b4559e$var$bf:
                        k = $f62453a6e3b4559e$var$Hd;
                        break;
                    case $f62453a6e3b4559e$var$cf:
                        k = $f62453a6e3b4559e$var$Xd;
                        break;
                    case "scroll":
                        k = $f62453a6e3b4559e$var$vd;
                        break;
                    case "wheel":
                        k = $f62453a6e3b4559e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f62453a6e3b4559e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f62453a6e3b4559e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f62453a6e3b4559e$var$Kb(w, x), null != F && t.push($f62453a6e3b4559e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f62453a6e3b4559e$var$wb && (n = c.relatedTarget || c.fromElement) && ($f62453a6e3b4559e$var$Wc(n) || n[$f62453a6e3b4559e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f62453a6e3b4559e$var$Wc(n) : null, null !== n && (J = $f62453a6e3b4559e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f62453a6e3b4559e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f62453a6e3b4559e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f62453a6e3b4559e$var$ue(k);
                        u = null == n ? h : $f62453a6e3b4559e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f62453a6e3b4559e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f62453a6e3b4559e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f62453a6e3b4559e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f62453a6e3b4559e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f62453a6e3b4559e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f62453a6e3b4559e$var$vf(t);
                                x = $f62453a6e3b4559e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f62453a6e3b4559e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f62453a6e3b4559e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f62453a6e3b4559e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f62453a6e3b4559e$var$ve;
                else if ($f62453a6e3b4559e$var$me(h)) {
                    if ($f62453a6e3b4559e$var$we) na = $f62453a6e3b4559e$var$Fe;
                    else {
                        na = $f62453a6e3b4559e$var$De;
                        var xa = $f62453a6e3b4559e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f62453a6e3b4559e$var$Ee);
                if (na && (na = na(a, d))) {
                    $f62453a6e3b4559e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f62453a6e3b4559e$var$cb(h, "number", h.value);
            }
            xa = d ? $f62453a6e3b4559e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f62453a6e3b4559e$var$me(xa) || "true" === xa.contentEditable) $f62453a6e3b4559e$var$Qe = xa, $f62453a6e3b4559e$var$Re = d, $f62453a6e3b4559e$var$Se = null;
                    break;
                case "focusout":
                    $f62453a6e3b4559e$var$Se = $f62453a6e3b4559e$var$Re = $f62453a6e3b4559e$var$Qe = null;
                    break;
                case "mousedown":
                    $f62453a6e3b4559e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f62453a6e3b4559e$var$Te = !1;
                    $f62453a6e3b4559e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f62453a6e3b4559e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f62453a6e3b4559e$var$Ue(g, c, e);
            }
            var $a;
            if ($f62453a6e3b4559e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f62453a6e3b4559e$var$ie ? $f62453a6e3b4559e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f62453a6e3b4559e$var$de && "ko" !== c.locale && ($f62453a6e3b4559e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f62453a6e3b4559e$var$ie && ($a = $f62453a6e3b4559e$var$nd()) : ($f62453a6e3b4559e$var$kd = e, $f62453a6e3b4559e$var$ld = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, $f62453a6e3b4559e$var$ie = !0)), xa = $f62453a6e3b4559e$var$oe(d, ba), 0 < xa.length && (ba = new $f62453a6e3b4559e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f62453a6e3b4559e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f62453a6e3b4559e$var$ce ? $f62453a6e3b4559e$var$je(a, c) : $f62453a6e3b4559e$var$ke(a, c)) d = $f62453a6e3b4559e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f62453a6e3b4559e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f62453a6e3b4559e$var$se(g, b);
    });
}
function $f62453a6e3b4559e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f62453a6e3b4559e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f62453a6e3b4559e$var$Kb(a, c), null != f && d.unshift($f62453a6e3b4559e$var$tf(a, f, e)), f = $f62453a6e3b4559e$var$Kb(a, b), null != f && d.push($f62453a6e3b4559e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f62453a6e3b4559e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f62453a6e3b4559e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.unshift($f62453a6e3b4559e$var$tf(c, k, h))) : e || (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.push($f62453a6e3b4559e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f62453a6e3b4559e$var$xf = /\r\n?/g, $f62453a6e3b4559e$var$yf = /\u0000|\uFFFD/g;
function $f62453a6e3b4559e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f62453a6e3b4559e$var$xf, "\n").replace($f62453a6e3b4559e$var$yf, "");
}
function $f62453a6e3b4559e$var$Af(a, b, c) {
    b = $f62453a6e3b4559e$var$zf(b);
    if ($f62453a6e3b4559e$var$zf(a) !== b && c) throw Error($f62453a6e3b4559e$var$p(425));
}
function $f62453a6e3b4559e$var$Bf() {}
var $f62453a6e3b4559e$var$Cf = null, $f62453a6e3b4559e$var$Df = null;
function $f62453a6e3b4559e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f62453a6e3b4559e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f62453a6e3b4559e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f62453a6e3b4559e$var$Hf = "function" === typeof Promise ? Promise : void 0, $f62453a6e3b4559e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f62453a6e3b4559e$var$Hf ? function(a) {
    return $f62453a6e3b4559e$var$Hf.resolve(null).then(a).catch($f62453a6e3b4559e$var$If);
} : $f62453a6e3b4559e$var$Ff;
function $f62453a6e3b4559e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f62453a6e3b4559e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f62453a6e3b4559e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f62453a6e3b4559e$var$bd(b);
}
function $f62453a6e3b4559e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f62453a6e3b4559e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Nf = Math.random().toString(36).slice(2), $f62453a6e3b4559e$var$Of = "__reactFiber$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Pf = "__reactProps$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$uf = "__reactContainer$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$of = "__reactEvents$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Qf = "__reactListeners$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Rf = "__reactHandles$" + $f62453a6e3b4559e$var$Nf;
function $f62453a6e3b4559e$var$Wc(a) {
    var b = a[$f62453a6e3b4559e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f62453a6e3b4559e$var$uf] || c[$f62453a6e3b4559e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f62453a6e3b4559e$var$Mf(a); null !== a;){
                if (c = a[$f62453a6e3b4559e$var$Of]) return c;
                a = $f62453a6e3b4559e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f62453a6e3b4559e$var$Cb(a) {
    a = a[$f62453a6e3b4559e$var$Of] || a[$f62453a6e3b4559e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f62453a6e3b4559e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f62453a6e3b4559e$var$p(33));
}
function $f62453a6e3b4559e$var$Db(a) {
    return a[$f62453a6e3b4559e$var$Pf] || null;
}
var $f62453a6e3b4559e$var$Sf = [], $f62453a6e3b4559e$var$Tf = -1;
function $f62453a6e3b4559e$var$Uf(a) {
    return {
        current: a
    };
}
function $f62453a6e3b4559e$var$E(a) {
    0 > $f62453a6e3b4559e$var$Tf || (a.current = $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf], $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = null, $f62453a6e3b4559e$var$Tf--);
}
function $f62453a6e3b4559e$var$G(a, b) {
    $f62453a6e3b4559e$var$Tf++;
    $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = a.current;
    a.current = b;
}
var $f62453a6e3b4559e$var$Vf = {}, $f62453a6e3b4559e$var$H = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$Vf), $f62453a6e3b4559e$var$Wf = $f62453a6e3b4559e$var$Uf(!1), $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$Vf;
function $f62453a6e3b4559e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f62453a6e3b4559e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f62453a6e3b4559e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f62453a6e3b4559e$var$$f() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
}
function $f62453a6e3b4559e$var$ag(a, b, c) {
    if ($f62453a6e3b4559e$var$H.current !== $f62453a6e3b4559e$var$Vf) throw Error($f62453a6e3b4559e$var$p(168));
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
function $f62453a6e3b4559e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f62453a6e3b4559e$var$p(108, $f62453a6e3b4559e$var$Ra(a) || "Unknown", e));
    return $f62453a6e3b4559e$var$A({}, c, d);
}
function $f62453a6e3b4559e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f62453a6e3b4559e$var$Vf;
    $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$H.current;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, $f62453a6e3b4559e$var$Wf.current);
    return !0;
}
function $f62453a6e3b4559e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f62453a6e3b4559e$var$p(169));
    c ? (a = $f62453a6e3b4559e$var$bg(a, b, $f62453a6e3b4559e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a)) : $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
var $f62453a6e3b4559e$var$eg = null, $f62453a6e3b4559e$var$fg = !1, $f62453a6e3b4559e$var$gg = !1;
function $f62453a6e3b4559e$var$hg(a) {
    null === $f62453a6e3b4559e$var$eg ? $f62453a6e3b4559e$var$eg = [
        a
    ] : $f62453a6e3b4559e$var$eg.push(a);
}
function $f62453a6e3b4559e$var$ig(a) {
    $f62453a6e3b4559e$var$fg = !0;
    $f62453a6e3b4559e$var$hg(a);
}
function $f62453a6e3b4559e$var$jg() {
    if (!$f62453a6e3b4559e$var$gg && null !== $f62453a6e3b4559e$var$eg) {
        $f62453a6e3b4559e$var$gg = !0;
        var a = 0, b = $f62453a6e3b4559e$var$C;
        try {
            var c = $f62453a6e3b4559e$var$eg;
            for($f62453a6e3b4559e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f62453a6e3b4559e$var$eg = null;
            $f62453a6e3b4559e$var$fg = !1;
        } catch (e) {
            throw null !== $f62453a6e3b4559e$var$eg && ($f62453a6e3b4559e$var$eg = $f62453a6e3b4559e$var$eg.slice(a + 1)), $f62453a6e3b4559e$var$ac($f62453a6e3b4559e$var$fc, $f62453a6e3b4559e$var$jg), e;
        } finally{
            $f62453a6e3b4559e$var$C = b, $f62453a6e3b4559e$var$gg = !1;
        }
    }
    return null;
}
var $f62453a6e3b4559e$var$kg = [], $f62453a6e3b4559e$var$lg = 0, $f62453a6e3b4559e$var$mg = null, $f62453a6e3b4559e$var$ng = 0, $f62453a6e3b4559e$var$og = [], $f62453a6e3b4559e$var$pg = 0, $f62453a6e3b4559e$var$qg = null, $f62453a6e3b4559e$var$rg = 1, $f62453a6e3b4559e$var$sg = "";
function $f62453a6e3b4559e$var$tg(a, b) {
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$ng;
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$mg;
    $f62453a6e3b4559e$var$mg = a;
    $f62453a6e3b4559e$var$ng = b;
}
function $f62453a6e3b4559e$var$ug(a, b, c) {
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg;
    $f62453a6e3b4559e$var$qg = a;
    var d = $f62453a6e3b4559e$var$rg;
    a = $f62453a6e3b4559e$var$sg;
    var e = 32 - $f62453a6e3b4559e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f62453a6e3b4559e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f62453a6e3b4559e$var$rg = 1 << 32 - $f62453a6e3b4559e$var$oc(b) + e | c << e | d;
        $f62453a6e3b4559e$var$sg = f + a;
    } else $f62453a6e3b4559e$var$rg = 1 << f | c << e | d, $f62453a6e3b4559e$var$sg = a;
}
function $f62453a6e3b4559e$var$vg(a) {
    null !== a.return && ($f62453a6e3b4559e$var$tg(a, 1), $f62453a6e3b4559e$var$ug(a, 1, 0));
}
function $f62453a6e3b4559e$var$wg(a) {
    for(; a === $f62453a6e3b4559e$var$mg;)$f62453a6e3b4559e$var$mg = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null, $f62453a6e3b4559e$var$ng = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null;
    for(; a === $f62453a6e3b4559e$var$qg;)$f62453a6e3b4559e$var$qg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$sg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$rg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null;
}
var $f62453a6e3b4559e$var$xg = null, $f62453a6e3b4559e$var$yg = null, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$zg = null;
function $f62453a6e3b4559e$var$Ag(a, b) {
    var c = $f62453a6e3b4559e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f62453a6e3b4559e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f62453a6e3b4559e$var$qg ? {
                id: $f62453a6e3b4559e$var$rg,
                overflow: $f62453a6e3b4559e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f62453a6e3b4559e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f62453a6e3b4559e$var$Eg(a) {
    if ($f62453a6e3b4559e$var$I) {
        var b = $f62453a6e3b4559e$var$yg;
        if (b) {
            var c = b;
            if (!$f62453a6e3b4559e$var$Cg(a, b)) {
                if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
                b = $f62453a6e3b4559e$var$Lf(c.nextSibling);
                var d = $f62453a6e3b4559e$var$xg;
                b && $f62453a6e3b4559e$var$Cg(a, b) ? $f62453a6e3b4559e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$xg = a);
            }
        } else {
            if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f62453a6e3b4559e$var$I = !1;
            $f62453a6e3b4559e$var$xg = a;
        }
    }
}
function $f62453a6e3b4559e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f62453a6e3b4559e$var$xg = a;
}
function $f62453a6e3b4559e$var$Gg(a) {
    if (a !== $f62453a6e3b4559e$var$xg) return !1;
    if (!$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$Fg(a), $f62453a6e3b4559e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f62453a6e3b4559e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f62453a6e3b4559e$var$yg)) {
        if ($f62453a6e3b4559e$var$Dg(a)) throw $f62453a6e3b4559e$var$Hg(), Error($f62453a6e3b4559e$var$p(418));
        for(; b;)$f62453a6e3b4559e$var$Ag(a, b), b = $f62453a6e3b4559e$var$Lf(b.nextSibling);
    }
    $f62453a6e3b4559e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f62453a6e3b4559e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f62453a6e3b4559e$var$yg = null;
        }
    } else $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg ? $f62453a6e3b4559e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f62453a6e3b4559e$var$Hg() {
    for(var a = $f62453a6e3b4559e$var$yg; a;)a = $f62453a6e3b4559e$var$Lf(a.nextSibling);
}
function $f62453a6e3b4559e$var$Ig() {
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg = null;
    $f62453a6e3b4559e$var$I = !1;
}
function $f62453a6e3b4559e$var$Jg(a) {
    null === $f62453a6e3b4559e$var$zg ? $f62453a6e3b4559e$var$zg = [
        a
    ] : $f62453a6e3b4559e$var$zg.push(a);
}
var $f62453a6e3b4559e$var$Kg = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig;
function $f62453a6e3b4559e$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f62453a6e3b4559e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f62453a6e3b4559e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f62453a6e3b4559e$var$p(284));
        if (!c._owner) throw Error($f62453a6e3b4559e$var$p(290, a));
    }
    return a;
}
function $f62453a6e3b4559e$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f62453a6e3b4559e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f62453a6e3b4559e$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $f62453a6e3b4559e$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f62453a6e3b4559e$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f62453a6e3b4559e$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f62453a6e3b4559e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $f62453a6e3b4559e$var$Lg(a, b, c), d.return = a, d;
        d = $f62453a6e3b4559e$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f62453a6e3b4559e$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f62453a6e3b4559e$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f62453a6e3b4559e$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f62453a6e3b4559e$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c = $f62453a6e3b4559e$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $f62453a6e3b4559e$var$Lg(a, null, b), c.return = a, c;
                case $f62453a6e3b4559e$var$wa:
                    return b = $f62453a6e3b4559e$var$Sg(b, a.mode, c), b.return = a, b;
                case $f62453a6e3b4559e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f62453a6e3b4559e$var$eb(b) || $f62453a6e3b4559e$var$Ka(b)) return b = $f62453a6e3b4559e$var$Tg(b, a.mode, c, null), b.return = a, b;
            $f62453a6e3b4559e$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f62453a6e3b4559e$var$eb(c) || $f62453a6e3b4559e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f62453a6e3b4559e$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f62453a6e3b4559e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f62453a6e3b4559e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f62453a6e3b4559e$var$eb(d) || $f62453a6e3b4559e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f62453a6e3b4559e$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f62453a6e3b4559e$var$Ka(h);
        if ("function" !== typeof l) throw Error($f62453a6e3b4559e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f62453a6e3b4559e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f62453a6e3b4559e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f62453a6e3b4559e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f62453a6e3b4559e$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f62453a6e3b4559e$var$ya ? (d = $f62453a6e3b4559e$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f62453a6e3b4559e$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $f62453a6e3b4559e$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f62453a6e3b4559e$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f62453a6e3b4559e$var$eb(f)) return n(a, d, f, h);
            if ($f62453a6e3b4559e$var$Ka(f)) return t(a, d, f, h);
            $f62453a6e3b4559e$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f62453a6e3b4559e$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f62453a6e3b4559e$var$Ug = $f62453a6e3b4559e$var$Og(!0), $f62453a6e3b4559e$var$Vg = $f62453a6e3b4559e$var$Og(!1), $f62453a6e3b4559e$var$Wg = $f62453a6e3b4559e$var$Uf(null), $f62453a6e3b4559e$var$Xg = null, $f62453a6e3b4559e$var$Yg = null, $f62453a6e3b4559e$var$Zg = null;
function $f62453a6e3b4559e$var$$g() {
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Xg = null;
}
function $f62453a6e3b4559e$var$ah(a) {
    var b = $f62453a6e3b4559e$var$Wg.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wg);
    a._currentValue = b;
}
function $f62453a6e3b4559e$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f62453a6e3b4559e$var$ch(a, b) {
    $f62453a6e3b4559e$var$Xg = a;
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f62453a6e3b4559e$var$dh = !0), a.firstContext = null);
}
function $f62453a6e3b4559e$var$eh(a) {
    var b = a._currentValue;
    if ($f62453a6e3b4559e$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f62453a6e3b4559e$var$Yg) {
            if (null === $f62453a6e3b4559e$var$Xg) throw Error($f62453a6e3b4559e$var$p(308));
            $f62453a6e3b4559e$var$Yg = a;
            $f62453a6e3b4559e$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Yg.next = a;
    }
    return b;
}
var $f62453a6e3b4559e$var$fh = null;
function $f62453a6e3b4559e$var$gh(a) {
    null === $f62453a6e3b4559e$var$fh ? $f62453a6e3b4559e$var$fh = [
        a
    ] : $f62453a6e3b4559e$var$fh.push(a);
}
function $f62453a6e3b4559e$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f62453a6e3b4559e$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f62453a6e3b4559e$var$ih(a, d);
}
function $f62453a6e3b4559e$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f62453a6e3b4559e$var$jh = !1;
function $f62453a6e3b4559e$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f62453a6e3b4559e$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f62453a6e3b4559e$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f62453a6e3b4559e$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f62453a6e3b4559e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f62453a6e3b4559e$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f62453a6e3b4559e$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f62453a6e3b4559e$var$ih(a, c);
}
function $f62453a6e3b4559e$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
function $f62453a6e3b4559e$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f62453a6e3b4559e$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $f62453a6e3b4559e$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f62453a6e3b4559e$var$A({}, q, r);
                            break a;
                        case 2:
                            $f62453a6e3b4559e$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f62453a6e3b4559e$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f62453a6e3b4559e$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f62453a6e3b4559e$var$p(191, e));
            e.call(d);
        }
    }
}
var $f62453a6e3b4559e$var$th = {}, $f62453a6e3b4559e$var$uh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$vh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$wh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th);
function $f62453a6e3b4559e$var$xh(a) {
    if (a === $f62453a6e3b4559e$var$th) throw Error($f62453a6e3b4559e$var$p(174));
    return a;
}
function $f62453a6e3b4559e$var$yh(a, b) {
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$wh, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, $f62453a6e3b4559e$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f62453a6e3b4559e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f62453a6e3b4559e$var$lb(b, a);
    }
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, b);
}
function $f62453a6e3b4559e$var$zh() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$wh);
}
function $f62453a6e3b4559e$var$Ah(a) {
    $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
    var b = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
    var c = $f62453a6e3b4559e$var$lb(b, a.type);
    b !== c && ($f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, c));
}
function $f62453a6e3b4559e$var$Bh(a) {
    $f62453a6e3b4559e$var$vh.current === a && ($f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh));
}
var $f62453a6e3b4559e$var$L = $f62453a6e3b4559e$var$Uf(0);
function $f62453a6e3b4559e$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Dh = [];
function $f62453a6e3b4559e$var$Eh() {
    for(var a = 0; a < $f62453a6e3b4559e$var$Dh.length; a++)$f62453a6e3b4559e$var$Dh[a]._workInProgressVersionPrimary = null;
    $f62453a6e3b4559e$var$Dh.length = 0;
}
var $f62453a6e3b4559e$var$Fh = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$Gh = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$Hh = 0, $f62453a6e3b4559e$var$M = null, $f62453a6e3b4559e$var$N = null, $f62453a6e3b4559e$var$O = null, $f62453a6e3b4559e$var$Ih = !1, $f62453a6e3b4559e$var$Jh = !1, $f62453a6e3b4559e$var$Kh = 0, $f62453a6e3b4559e$var$Lh = 0;
function $f62453a6e3b4559e$var$P() {
    throw Error($f62453a6e3b4559e$var$p(321));
}
function $f62453a6e3b4559e$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f62453a6e3b4559e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f62453a6e3b4559e$var$Nh(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$Hh = f;
    $f62453a6e3b4559e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f62453a6e3b4559e$var$Fh.current = null === a || null === a.memoizedState ? $f62453a6e3b4559e$var$Oh : $f62453a6e3b4559e$var$Ph;
    a = c(d, e);
    if ($f62453a6e3b4559e$var$Jh) {
        f = 0;
        do {
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            if (25 <= f) throw Error($f62453a6e3b4559e$var$p(301));
            f += 1;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = null;
            b.updateQueue = null;
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Qh;
            a = c(d, e);
        }while ($f62453a6e3b4559e$var$Jh);
    }
    $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
    b = null !== $f62453a6e3b4559e$var$N && null !== $f62453a6e3b4559e$var$N.next;
    $f62453a6e3b4559e$var$Hh = 0;
    $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
    $f62453a6e3b4559e$var$Ih = !1;
    if (b) throw Error($f62453a6e3b4559e$var$p(300));
    return a;
}
function $f62453a6e3b4559e$var$Sh() {
    var a = 0 !== $f62453a6e3b4559e$var$Kh;
    $f62453a6e3b4559e$var$Kh = 0;
    return a;
}
function $f62453a6e3b4559e$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Uh() {
    if (null === $f62453a6e3b4559e$var$N) {
        var a = $f62453a6e3b4559e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f62453a6e3b4559e$var$N.next;
    var b = null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState : $f62453a6e3b4559e$var$O.next;
    if (null !== b) $f62453a6e3b4559e$var$O = b, $f62453a6e3b4559e$var$N = a;
    else {
        if (null === a) throw Error($f62453a6e3b4559e$var$p(310));
        $f62453a6e3b4559e$var$N = a;
        a = {
            memoizedState: $f62453a6e3b4559e$var$N.memoizedState,
            baseState: $f62453a6e3b4559e$var$N.baseState,
            baseQueue: $f62453a6e3b4559e$var$N.baseQueue,
            queue: $f62453a6e3b4559e$var$N.queue,
            next: null
        };
        null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    }
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f62453a6e3b4559e$var$Wh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f62453a6e3b4559e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f62453a6e3b4559e$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f62453a6e3b4559e$var$M.lanes |= m;
                $f62453a6e3b4559e$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f62453a6e3b4559e$var$He(d, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f62453a6e3b4559e$var$M.lanes |= f, $f62453a6e3b4559e$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f62453a6e3b4559e$var$Xh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f62453a6e3b4559e$var$He(f, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f62453a6e3b4559e$var$Yh() {}
function $f62453a6e3b4559e$var$Zh(a, b) {
    var c = $f62453a6e3b4559e$var$M, d = $f62453a6e3b4559e$var$Uh(), e = b(), f = !$f62453a6e3b4559e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f62453a6e3b4559e$var$dh = !0);
    d = d.queue;
    $f62453a6e3b4559e$var$$h($f62453a6e3b4559e$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f62453a6e3b4559e$var$O && $f62453a6e3b4559e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
        0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(c, b, e);
    }
    return e;
}
function $f62453a6e3b4559e$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f62453a6e3b4559e$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
}
function $f62453a6e3b4559e$var$ai(a, b, c) {
    return c(function() {
        $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
    });
}
function $f62453a6e3b4559e$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f62453a6e3b4559e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f62453a6e3b4559e$var$fi(a) {
    var b = $f62453a6e3b4559e$var$ih(a, 1);
    null !== b && $f62453a6e3b4559e$var$gi(b, a, 1, -1);
}
function $f62453a6e3b4559e$var$hi(a) {
    var b = $f62453a6e3b4559e$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f62453a6e3b4559e$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f62453a6e3b4559e$var$ii.bind(null, $f62453a6e3b4559e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f62453a6e3b4559e$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f62453a6e3b4559e$var$ji() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$ki(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Th();
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f62453a6e3b4559e$var$li(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f62453a6e3b4559e$var$N) {
        var g = $f62453a6e3b4559e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $f62453a6e3b4559e$var$Mh(d, g.deps)) {
            e.memoizedState = $f62453a6e3b4559e$var$bi(b, c, f, d);
            return;
        }
    }
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, f, d);
}
function $f62453a6e3b4559e$var$mi(a, b) {
    return $f62453a6e3b4559e$var$ki(8390656, 8, a, b);
}
function $f62453a6e3b4559e$var$$h(a, b) {
    return $f62453a6e3b4559e$var$li(2048, 8, a, b);
}
function $f62453a6e3b4559e$var$ni(a, b) {
    return $f62453a6e3b4559e$var$li(4, 2, a, b);
}
function $f62453a6e3b4559e$var$oi(a, b) {
    return $f62453a6e3b4559e$var$li(4, 4, a, b);
}
function $f62453a6e3b4559e$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f62453a6e3b4559e$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f62453a6e3b4559e$var$li(4, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
}
function $f62453a6e3b4559e$var$ri() {}
function $f62453a6e3b4559e$var$si(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ti(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ui(a, b, c) {
    if (0 === ($f62453a6e3b4559e$var$Hh & 21)) return a.baseState && (a.baseState = !1, $f62453a6e3b4559e$var$dh = !0), a.memoizedState = c;
    $f62453a6e3b4559e$var$He(c, b) || (c = $f62453a6e3b4559e$var$yc(), $f62453a6e3b4559e$var$M.lanes |= c, $f62453a6e3b4559e$var$rh |= c, a.baseState = !0);
    return b;
}
function $f62453a6e3b4559e$var$vi(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    $f62453a6e3b4559e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f62453a6e3b4559e$var$Gh.transition;
    $f62453a6e3b4559e$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$Gh.transition = d;
    }
}
function $f62453a6e3b4559e$var$wi() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$xi(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, c);
    else if (c = $f62453a6e3b4559e$var$hh(a, b, c, d), null !== c) {
        var e = $f62453a6e3b4559e$var$R();
        $f62453a6e3b4559e$var$gi(c, a, d, e);
        $f62453a6e3b4559e$var$Bi(c, b, d);
    }
}
function $f62453a6e3b4559e$var$ii(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f62453a6e3b4559e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f62453a6e3b4559e$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f62453a6e3b4559e$var$hh(a, b, e, d);
        null !== c && (e = $f62453a6e3b4559e$var$R(), $f62453a6e3b4559e$var$gi(c, a, d, e), $f62453a6e3b4559e$var$Bi(c, b, d));
    }
}
function $f62453a6e3b4559e$var$zi(a) {
    var b = a.alternate;
    return a === $f62453a6e3b4559e$var$M || null !== b && b === $f62453a6e3b4559e$var$M;
}
function $f62453a6e3b4559e$var$Ai(a, b) {
    $f62453a6e3b4559e$var$Jh = $f62453a6e3b4559e$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f62453a6e3b4559e$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
var $f62453a6e3b4559e$var$Rh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$P,
    useContext: $f62453a6e3b4559e$var$P,
    useEffect: $f62453a6e3b4559e$var$P,
    useImperativeHandle: $f62453a6e3b4559e$var$P,
    useInsertionEffect: $f62453a6e3b4559e$var$P,
    useLayoutEffect: $f62453a6e3b4559e$var$P,
    useMemo: $f62453a6e3b4559e$var$P,
    useReducer: $f62453a6e3b4559e$var$P,
    useRef: $f62453a6e3b4559e$var$P,
    useState: $f62453a6e3b4559e$var$P,
    useDebugValue: $f62453a6e3b4559e$var$P,
    useDeferredValue: $f62453a6e3b4559e$var$P,
    useTransition: $f62453a6e3b4559e$var$P,
    useMutableSource: $f62453a6e3b4559e$var$P,
    useSyncExternalStore: $f62453a6e3b4559e$var$P,
    useId: $f62453a6e3b4559e$var$P,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Oh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: function(a, b) {
        $f62453a6e3b4559e$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f62453a6e3b4559e$var$ki(4194308, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f62453a6e3b4559e$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f62453a6e3b4559e$var$xi.bind(null, $f62453a6e3b4559e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f62453a6e3b4559e$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f62453a6e3b4559e$var$hi,
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        return $f62453a6e3b4559e$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$hi(!1), b = a[0];
        a = $f62453a6e3b4559e$var$vi.bind(null, a[1]);
        $f62453a6e3b4559e$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$M, e = $f62453a6e3b4559e$var$Th();
        if ($f62453a6e3b4559e$var$I) {
            if (void 0 === c) throw Error($f62453a6e3b4559e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
            0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f62453a6e3b4559e$var$mi($f62453a6e3b4559e$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f62453a6e3b4559e$var$Th(), b = $f62453a6e3b4559e$var$Q.identifierPrefix;
        if ($f62453a6e3b4559e$var$I) {
            var c = $f62453a6e3b4559e$var$sg;
            var d = $f62453a6e3b4559e$var$rg;
            c = (d & ~(1 << 32 - $f62453a6e3b4559e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f62453a6e3b4559e$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f62453a6e3b4559e$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Ph = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Wh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Qh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Xh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return null === $f62453a6e3b4559e$var$N ? b.memoizedState = a : $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
};
function $f62453a6e3b4559e$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $f62453a6e3b4559e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f62453a6e3b4559e$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f62453a6e3b4559e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f62453a6e3b4559e$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f62453a6e3b4559e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f62453a6e3b4559e$var$R(), d = $f62453a6e3b4559e$var$yi(a), e = $f62453a6e3b4559e$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f62453a6e3b4559e$var$nh(a, e, d);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, d, c), $f62453a6e3b4559e$var$oh(b, a, d));
    }
};
function $f62453a6e3b4559e$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f62453a6e3b4559e$var$Ie(c, d) || !$f62453a6e3b4559e$var$Ie(e, f) : !0;
}
function $f62453a6e3b4559e$var$Gi(a, b, c) {
    var d = !1, e = $f62453a6e3b4559e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f62453a6e3b4559e$var$eh(f) : (e = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f62453a6e3b4559e$var$Yf(a, e) : $f62453a6e3b4559e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f62453a6e3b4559e$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f62453a6e3b4559e$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $f62453a6e3b4559e$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $f62453a6e3b4559e$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f62453a6e3b4559e$var$eh(f) : (f = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, e.context = $f62453a6e3b4559e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f62453a6e3b4559e$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(e, e.state, null), $f62453a6e3b4559e$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f62453a6e3b4559e$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $f62453a6e3b4559e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f62453a6e3b4559e$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f62453a6e3b4559e$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f62453a6e3b4559e$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $f62453a6e3b4559e$var$Ni(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f62453a6e3b4559e$var$Oi || ($f62453a6e3b4559e$var$Oi = !0, $f62453a6e3b4559e$var$Pi = d);
        $f62453a6e3b4559e$var$Li(a, b);
    };
    return c;
}
function $f62453a6e3b4559e$var$Qi(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f62453a6e3b4559e$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f62453a6e3b4559e$var$Li(a, b);
        "function" !== typeof d && (null === $f62453a6e3b4559e$var$Ri ? $f62453a6e3b4559e$var$Ri = new Set([
            this
        ]) : $f62453a6e3b4559e$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f62453a6e3b4559e$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f62453a6e3b4559e$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f62453a6e3b4559e$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $f62453a6e3b4559e$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f62453a6e3b4559e$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f62453a6e3b4559e$var$mh(-1, 1), b.tag = 2, $f62453a6e3b4559e$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f62453a6e3b4559e$var$Wi = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$dh = !1;
function $f62453a6e3b4559e$var$Xi(a, b, c, d) {
    b.child = null === a ? $f62453a6e3b4559e$var$Vg(b, null, c, d) : $f62453a6e3b4559e$var$Ug(b, a.child, c, d);
}
function $f62453a6e3b4559e$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f62453a6e3b4559e$var$ch(b, e);
    d = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    c = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && c && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, d, e);
    return b.child;
}
function $f62453a6e3b4559e$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f62453a6e3b4559e$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f62453a6e3b4559e$var$bj(a, b, f, d, e);
        a = $f62453a6e3b4559e$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f62453a6e3b4559e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f62453a6e3b4559e$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $f62453a6e3b4559e$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f62453a6e3b4559e$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f62453a6e3b4559e$var$Ie(f, d) && a.ref === b.ref) {
            if ($f62453a6e3b4559e$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f62453a6e3b4559e$var$dh = !0);
            else return b.lanes = a.lanes, $f62453a6e3b4559e$var$Zi(a, b, e);
        }
    }
    return $f62453a6e3b4559e$var$cj(a, b, c, d, e);
}
function $f62453a6e3b4559e$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj);
            $f62453a6e3b4559e$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= d;
    $f62453a6e3b4559e$var$Xi(a, b, e, c);
    return b.child;
}
function $f62453a6e3b4559e$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f62453a6e3b4559e$var$cj(a, b, c, d, e) {
    var f = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current;
    f = $f62453a6e3b4559e$var$Yf(b, f);
    $f62453a6e3b4559e$var$ch(b, e);
    c = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    d = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && d && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, c, e);
    return b.child;
}
function $f62453a6e3b4559e$var$hj(a, b, c, d, e) {
    if ($f62453a6e3b4559e$var$Zf(c)) {
        var f = !0;
        $f62453a6e3b4559e$var$cg(b);
    } else f = !1;
    $f62453a6e3b4559e$var$ch(b, e);
    if (null === b.stateNode) $f62453a6e3b4559e$var$ij(a, b), $f62453a6e3b4559e$var$Gi(b, c, d), $f62453a6e3b4559e$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f62453a6e3b4559e$var$eh(l) : (l = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, l = $f62453a6e3b4559e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f62453a6e3b4559e$var$Hi(b, g, d, l);
        $f62453a6e3b4559e$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof m && ($f62453a6e3b4559e$var$Di(b, c, m, d), k = b.memoizedState), (h = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f62453a6e3b4559e$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f62453a6e3b4559e$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f62453a6e3b4559e$var$eh(k) : (k = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, k = $f62453a6e3b4559e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f62453a6e3b4559e$var$Hi(b, g, d, k);
        $f62453a6e3b4559e$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof y && ($f62453a6e3b4559e$var$Di(b, c, y, d), n = b.memoizedState), (l = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f62453a6e3b4559e$var$jj(a, b, c, d, f, e);
}
function $f62453a6e3b4559e$var$jj(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f62453a6e3b4559e$var$dg(b, c, !1), $f62453a6e3b4559e$var$Zi(a, b, f);
    d = b.stateNode;
    $f62453a6e3b4559e$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f62453a6e3b4559e$var$Ug(b, a.child, null, f), b.child = $f62453a6e3b4559e$var$Ug(b, null, h, f)) : $f62453a6e3b4559e$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f62453a6e3b4559e$var$dg(b, c, !0);
    return b.child;
}
function $f62453a6e3b4559e$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f62453a6e3b4559e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f62453a6e3b4559e$var$ag(a, b.context, !1);
    $f62453a6e3b4559e$var$yh(a, b.containerInfo);
}
function $f62453a6e3b4559e$var$lj(a, b, c, d, e) {
    $f62453a6e3b4559e$var$Ig();
    $f62453a6e3b4559e$var$Jg(e);
    b.flags |= 256;
    $f62453a6e3b4559e$var$Xi(a, b, c, d);
    return b.child;
}
var $f62453a6e3b4559e$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f62453a6e3b4559e$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f62453a6e3b4559e$var$oj(a, b, c) {
    var d = b.pendingProps, e = $f62453a6e3b4559e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, e & 1);
    if (null === a) {
        $f62453a6e3b4559e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f62453a6e3b4559e$var$pj(g, d, 0, null), a = $f62453a6e3b4559e$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f62453a6e3b4559e$var$nj(c), b.memoizedState = $f62453a6e3b4559e$var$mj, a) : $f62453a6e3b4559e$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f62453a6e3b4559e$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f62453a6e3b4559e$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f62453a6e3b4559e$var$Pg(h, f) : (f = $f62453a6e3b4559e$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f62453a6e3b4559e$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f62453a6e3b4559e$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f62453a6e3b4559e$var$qj(a, b) {
    b = $f62453a6e3b4559e$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f62453a6e3b4559e$var$sj(a, b, c, d) {
    null !== d && $f62453a6e3b4559e$var$Jg(d);
    $f62453a6e3b4559e$var$Ug(b, a.child, null, c);
    a = $f62453a6e3b4559e$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f62453a6e3b4559e$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(422))), $f62453a6e3b4559e$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f62453a6e3b4559e$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f62453a6e3b4559e$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f62453a6e3b4559e$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $f62453a6e3b4559e$var$nj(g);
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f62453a6e3b4559e$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f62453a6e3b4559e$var$p(419));
        d = $f62453a6e3b4559e$var$Ki(f, d, void 0);
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f62453a6e3b4559e$var$dh || h) {
        d = $f62453a6e3b4559e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f62453a6e3b4559e$var$ih(a, e), $f62453a6e3b4559e$var$gi(d, a, e, -1));
        }
        $f62453a6e3b4559e$var$tj();
        d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(421)));
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f62453a6e3b4559e$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(e.nextSibling);
    $f62453a6e3b4559e$var$xg = b;
    $f62453a6e3b4559e$var$I = !0;
    $f62453a6e3b4559e$var$zg = null;
    null !== a && ($f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg, $f62453a6e3b4559e$var$rg = a.id, $f62453a6e3b4559e$var$sg = a.overflow, $f62453a6e3b4559e$var$qg = b);
    b = $f62453a6e3b4559e$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f62453a6e3b4559e$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f62453a6e3b4559e$var$bh(a.return, b, c);
}
function $f62453a6e3b4559e$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f62453a6e3b4559e$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f62453a6e3b4559e$var$Xi(a, b, d.children, c);
    d = $f62453a6e3b4559e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f62453a6e3b4559e$var$vj(a, c, b);
            else if (19 === a.tag) $f62453a6e3b4559e$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f62453a6e3b4559e$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f62453a6e3b4559e$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f62453a6e3b4559e$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f62453a6e3b4559e$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $f62453a6e3b4559e$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f62453a6e3b4559e$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f62453a6e3b4559e$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f62453a6e3b4559e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f62453a6e3b4559e$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f62453a6e3b4559e$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $f62453a6e3b4559e$var$kj(b);
            $f62453a6e3b4559e$var$Ig();
            break;
        case 5:
            $f62453a6e3b4559e$var$Ah(b);
            break;
        case 1:
            $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$cg(b);
            break;
        case 4:
            $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f62453a6e3b4559e$var$oj(a, b, c);
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
                a = $f62453a6e3b4559e$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f62453a6e3b4559e$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f62453a6e3b4559e$var$dj(a, b, c);
    }
    return $f62453a6e3b4559e$var$Zi(a, b, c);
}
var $f62453a6e3b4559e$var$zj, $f62453a6e3b4559e$var$Aj, $f62453a6e3b4559e$var$Bj, $f62453a6e3b4559e$var$Cj;
$f62453a6e3b4559e$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f62453a6e3b4559e$var$Aj = function() {};
$f62453a6e3b4559e$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f62453a6e3b4559e$var$Ya(a, e);
                d = $f62453a6e3b4559e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f62453a6e3b4559e$var$A({}, e, {
                    value: void 0
                });
                d = $f62453a6e3b4559e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f62453a6e3b4559e$var$gb(a, e);
                d = $f62453a6e3b4559e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
        }
        $f62453a6e3b4559e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f62453a6e3b4559e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f62453a6e3b4559e$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f62453a6e3b4559e$var$Dj(a, b) {
    if (!$f62453a6e3b4559e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f62453a6e3b4559e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f62453a6e3b4559e$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f62453a6e3b4559e$var$S(b), null;
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f62453a6e3b4559e$var$zh();
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
            $f62453a6e3b4559e$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f62453a6e3b4559e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null));
            $f62453a6e3b4559e$var$Aj(a, b);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 5:
            $f62453a6e3b4559e$var$Bh(b);
            var e = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f62453a6e3b4559e$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                    $f62453a6e3b4559e$var$S(b);
                    return null;
                }
                a = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    d[$f62453a6e3b4559e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f62453a6e3b4559e$var$D("cancel", d);
                            $f62453a6e3b4559e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], d);
                            break;
                        case "source":
                            $f62453a6e3b4559e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f62453a6e3b4559e$var$D("error", d);
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "details":
                            $f62453a6e3b4559e$var$D("toggle", d);
                            break;
                        case "input":
                            $f62453a6e3b4559e$var$Za(d, f);
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$hb(d, f), $f62453a6e3b4559e$var$D("invalid", d);
                    }
                    $f62453a6e3b4559e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f62453a6e3b4559e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f62453a6e3b4559e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f62453a6e3b4559e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f62453a6e3b4559e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f62453a6e3b4559e$var$Of] = b;
                    a[$f62453a6e3b4559e$var$Pf] = d;
                    $f62453a6e3b4559e$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f62453a6e3b4559e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f62453a6e3b4559e$var$D("cancel", a);
                                $f62453a6e3b4559e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f62453a6e3b4559e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f62453a6e3b4559e$var$D("error", a);
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f62453a6e3b4559e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f62453a6e3b4559e$var$Za(a, d);
                                e = $f62453a6e3b4559e$var$Ya(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f62453a6e3b4559e$var$A({}, d, {
                                    value: void 0
                                });
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$hb(a, d);
                                e = $f62453a6e3b4559e$var$gb(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f62453a6e3b4559e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f62453a6e3b4559e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f62453a6e3b4559e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f62453a6e3b4559e$var$ob(a, k) : "number" === typeof k && $f62453a6e3b4559e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f62453a6e3b4559e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f62453a6e3b4559e$var$D("scroll", a) : null != k && $f62453a6e3b4559e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f62453a6e3b4559e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f62453a6e3b4559e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f62453a6e3b4559e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f62453a6e3b4559e$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                c = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
                $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f62453a6e3b4559e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f62453a6e3b4559e$var$Of] = b, b.stateNode = d;
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f62453a6e3b4559e$var$I && null !== $f62453a6e3b4559e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f62453a6e3b4559e$var$Hg(), $f62453a6e3b4559e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f62453a6e3b4559e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f62453a6e3b4559e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f62453a6e3b4559e$var$p(317));
                        f[$f62453a6e3b4559e$var$Of] = b;
                    } else $f62453a6e3b4559e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f62453a6e3b4559e$var$S(b);
                    f = !1;
                } else null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f62453a6e3b4559e$var$L.current & 1) ? 0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 3) : $f62453a6e3b4559e$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$Aj(a, b), null === a && $f62453a6e3b4559e$var$sf(b.stateNode.containerInfo), $f62453a6e3b4559e$var$S(b), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), $f62453a6e3b4559e$var$S(b), null;
        case 17:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 19:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            f = b.memoizedState;
            if (null === f) return $f62453a6e3b4559e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f62453a6e3b4559e$var$Dj(f, !1);
                else {
                    if (0 !== $f62453a6e3b4559e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f62453a6e3b4559e$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f62453a6e3b4559e$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f62453a6e3b4559e$var$B() > $f62453a6e3b4559e$var$Gj && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f62453a6e3b4559e$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f62453a6e3b4559e$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$S(b), null;
                    } else 2 * $f62453a6e3b4559e$var$B() - f.renderingStartTime > $f62453a6e3b4559e$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f62453a6e3b4559e$var$B(), b.sibling = null, c = $f62453a6e3b4559e$var$L.current, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d ? c & 1 | 2 : c & 1), b;
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f62453a6e3b4559e$var$fj & 1073741824) && ($f62453a6e3b4559e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f62453a6e3b4559e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
}
function $f62453a6e3b4559e$var$Ij(a, b) {
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f62453a6e3b4559e$var$Bh(b), null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f62453a6e3b4559e$var$p(340));
                $f62453a6e3b4559e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L), null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$Jj = !1, $f62453a6e3b4559e$var$U = !1, $f62453a6e3b4559e$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $f62453a6e3b4559e$var$V = null;
function $f62453a6e3b4559e$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f62453a6e3b4559e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f62453a6e3b4559e$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f62453a6e3b4559e$var$W(a, b, d);
    }
}
var $f62453a6e3b4559e$var$Nj = !1;
function $f62453a6e3b4559e$var$Oj(a, b) {
    $f62453a6e3b4559e$var$Cf = $f62453a6e3b4559e$var$dd;
    a = $f62453a6e3b4559e$var$Me();
    if ($f62453a6e3b4559e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f62453a6e3b4559e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f62453a6e3b4559e$var$dd = !1;
    for($f62453a6e3b4559e$var$V = b; null !== $f62453a6e3b4559e$var$V;)if (b = $f62453a6e3b4559e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f62453a6e3b4559e$var$V = a;
    else for(; null !== $f62453a6e3b4559e$var$V;){
        b = $f62453a6e3b4559e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f62453a6e3b4559e$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(163));
            }
        } catch (F) {
            $f62453a6e3b4559e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f62453a6e3b4559e$var$V = a;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
    n = $f62453a6e3b4559e$var$Nj;
    $f62453a6e3b4559e$var$Nj = !1;
    return n;
}
function $f62453a6e3b4559e$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f62453a6e3b4559e$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f62453a6e3b4559e$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f62453a6e3b4559e$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f62453a6e3b4559e$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f62453a6e3b4559e$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f62453a6e3b4559e$var$Of], delete b[$f62453a6e3b4559e$var$Pf], delete b[$f62453a6e3b4559e$var$of], delete b[$f62453a6e3b4559e$var$Qf], delete b[$f62453a6e3b4559e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f62453a6e3b4559e$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f62453a6e3b4559e$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f62453a6e3b4559e$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f62453a6e3b4559e$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f62453a6e3b4559e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling;
}
function $f62453a6e3b4559e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling;
}
var $f62453a6e3b4559e$var$X = null, $f62453a6e3b4559e$var$Xj = !1;
function $f62453a6e3b4559e$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$f62453a6e3b4559e$var$Zj(a, b, c), c = c.sibling;
}
function $f62453a6e3b4559e$var$Zj(a, b, c) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberUnmount) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberUnmount($f62453a6e3b4559e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Lj(c, b);
        case 6:
            var d = $f62453a6e3b4559e$var$X, e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f62453a6e3b4559e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? $f62453a6e3b4559e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f62453a6e3b4559e$var$Kf(a, c), $f62453a6e3b4559e$var$bd(a)) : $f62453a6e3b4559e$var$Kf($f62453a6e3b4559e$var$X, c.stateNode));
            break;
        case 4:
            d = $f62453a6e3b4559e$var$X;
            e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = c.stateNode.containerInfo;
            $f62453a6e3b4559e$var$Xj = !0;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f62453a6e3b4559e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f62453a6e3b4559e$var$Mj(c, b, g) : 0 !== (f & 4) && $f62453a6e3b4559e$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 1:
            if (!$f62453a6e3b4559e$var$U && ($f62453a6e3b4559e$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f62453a6e3b4559e$var$W(c, b, h);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 21:
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f62453a6e3b4559e$var$U = (d = $f62453a6e3b4559e$var$U) || null !== c.memoizedState, $f62453a6e3b4559e$var$Yj(a, b, c), $f62453a6e3b4559e$var$U = d) : $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        default:
            $f62453a6e3b4559e$var$Yj(a, b, c);
    }
}
function $f62453a6e3b4559e$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f62453a6e3b4559e$var$Kj);
        b.forEach(function(b) {
            var d = $f62453a6e3b4559e$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f62453a6e3b4559e$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f62453a6e3b4559e$var$X = h.stateNode;
                        $f62453a6e3b4559e$var$Xj = !1;
                        break a;
                    case 3:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                    case 4:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f62453a6e3b4559e$var$X) throw Error($f62453a6e3b4559e$var$p(160));
            $f62453a6e3b4559e$var$Zj(f, g, e);
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f62453a6e3b4559e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f62453a6e3b4559e$var$dk(b, a), b = b.sibling;
}
function $f62453a6e3b4559e$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                try {
                    $f62453a6e3b4559e$var$Pj(3, a, a.return), $f62453a6e3b4559e$var$Qj(3, a);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
                try {
                    $f62453a6e3b4559e$var$Pj(5, a, a.return);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            break;
        case 5:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f62453a6e3b4559e$var$ob(e, "");
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f62453a6e3b4559e$var$ab(e, f);
                    $f62453a6e3b4559e$var$vb(h, g);
                    var l = $f62453a6e3b4559e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f62453a6e3b4559e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f62453a6e3b4559e$var$nb(e, q) : "children" === m ? $f62453a6e3b4559e$var$ob(e, q) : $f62453a6e3b4559e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f62453a6e3b4559e$var$bb(e, f);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f62453a6e3b4559e$var$Pf] = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f62453a6e3b4559e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f62453a6e3b4559e$var$bd(b.containerInfo);
            } catch (t) {
                $f62453a6e3b4559e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            break;
        case 13:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f62453a6e3b4559e$var$fk = $f62453a6e3b4559e$var$B()));
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f62453a6e3b4559e$var$U = (l = $f62453a6e3b4559e$var$U) || m, $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$U = l) : $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f62453a6e3b4559e$var$V = a, m = a.child; null !== m;){
                    for(q = $f62453a6e3b4559e$var$V = m; null !== $f62453a6e3b4559e$var$V;){
                        r = $f62453a6e3b4559e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f62453a6e3b4559e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f62453a6e3b4559e$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f62453a6e3b4559e$var$V = y) : $f62453a6e3b4559e$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f62453a6e3b4559e$var$rb("display", g));
                            } catch (t) {
                                $f62453a6e3b4559e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f62453a6e3b4559e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 21:
            break;
        default:
            $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$ek(a);
    }
}
function $f62453a6e3b4559e$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f62453a6e3b4559e$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f62453a6e3b4559e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f62453a6e3b4559e$var$ob(e, ""), d.flags &= -33);
                    var f = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(161));
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f62453a6e3b4559e$var$hk(a, b, c) {
    $f62453a6e3b4559e$var$V = a;
    $f62453a6e3b4559e$var$ik(a, b, c);
}
function $f62453a6e3b4559e$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f62453a6e3b4559e$var$V;){
        var e = $f62453a6e3b4559e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f62453a6e3b4559e$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f62453a6e3b4559e$var$U;
                h = $f62453a6e3b4559e$var$Jj;
                var l = $f62453a6e3b4559e$var$U;
                $f62453a6e3b4559e$var$Jj = g;
                if (($f62453a6e3b4559e$var$U = k) && !l) for($f62453a6e3b4559e$var$V = e; null !== $f62453a6e3b4559e$var$V;)g = $f62453a6e3b4559e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f62453a6e3b4559e$var$jk(e) : null !== k ? (k.return = g, $f62453a6e3b4559e$var$V = k) : $f62453a6e3b4559e$var$jk(e);
                for(; null !== f;)$f62453a6e3b4559e$var$V = f, $f62453a6e3b4559e$var$ik(f, b, c), f = f.sibling;
                $f62453a6e3b4559e$var$V = e;
                $f62453a6e3b4559e$var$Jj = h;
                $f62453a6e3b4559e$var$U = l;
            }
            $f62453a6e3b4559e$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f62453a6e3b4559e$var$V = f) : $f62453a6e3b4559e$var$kk(a, b, c);
    }
}
function $f62453a6e3b4559e$var$kk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f62453a6e3b4559e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f62453a6e3b4559e$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f62453a6e3b4559e$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f62453a6e3b4559e$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f62453a6e3b4559e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f62453a6e3b4559e$var$p(163));
                }
                $f62453a6e3b4559e$var$U || b.flags & 512 && $f62453a6e3b4559e$var$Rj(b);
            } catch (r) {
                $f62453a6e3b4559e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$gk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$jk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f62453a6e3b4559e$var$Qj(4, b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f62453a6e3b4559e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(b, b.return, k);
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f62453a6e3b4559e$var$V = h;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
var $f62453a6e3b4559e$var$lk = Math.ceil, $f62453a6e3b4559e$var$mk = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$nk = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$ok = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$K = 0, $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Y = null, $f62453a6e3b4559e$var$Z = 0, $f62453a6e3b4559e$var$fj = 0, $f62453a6e3b4559e$var$ej = $f62453a6e3b4559e$var$Uf(0), $f62453a6e3b4559e$var$T = 0, $f62453a6e3b4559e$var$pk = null, $f62453a6e3b4559e$var$rh = 0, $f62453a6e3b4559e$var$qk = 0, $f62453a6e3b4559e$var$rk = 0, $f62453a6e3b4559e$var$sk = null, $f62453a6e3b4559e$var$tk = null, $f62453a6e3b4559e$var$fk = 0, $f62453a6e3b4559e$var$Gj = Infinity, $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Oi = !1, $f62453a6e3b4559e$var$Pi = null, $f62453a6e3b4559e$var$Ri = null, $f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = null, $f62453a6e3b4559e$var$xk = 0, $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, $f62453a6e3b4559e$var$Ak = -1, $f62453a6e3b4559e$var$Bk = 0;
function $f62453a6e3b4559e$var$R() {
    return 0 !== ($f62453a6e3b4559e$var$K & 6) ? $f62453a6e3b4559e$var$B() : -1 !== $f62453a6e3b4559e$var$Ak ? $f62453a6e3b4559e$var$Ak : $f62453a6e3b4559e$var$Ak = $f62453a6e3b4559e$var$B();
}
function $f62453a6e3b4559e$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f62453a6e3b4559e$var$K & 2) && 0 !== $f62453a6e3b4559e$var$Z) return $f62453a6e3b4559e$var$Z & -$f62453a6e3b4559e$var$Z;
    if (null !== $f62453a6e3b4559e$var$Kg.transition) return 0 === $f62453a6e3b4559e$var$Bk && ($f62453a6e3b4559e$var$Bk = $f62453a6e3b4559e$var$yc()), $f62453a6e3b4559e$var$Bk;
    a = $f62453a6e3b4559e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f62453a6e3b4559e$var$jd(a.type);
    return a;
}
function $f62453a6e3b4559e$var$gi(a, b, c, d) {
    if (50 < $f62453a6e3b4559e$var$yk) throw $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, Error($f62453a6e3b4559e$var$p(185));
    $f62453a6e3b4559e$var$Ac(a, c, d);
    if (0 === ($f62453a6e3b4559e$var$K & 2) || a !== $f62453a6e3b4559e$var$Q) a === $f62453a6e3b4559e$var$Q && (0 === ($f62453a6e3b4559e$var$K & 2) && ($f62453a6e3b4559e$var$qk |= c), 4 === $f62453a6e3b4559e$var$T && $f62453a6e3b4559e$var$Ck(a, $f62453a6e3b4559e$var$Z)), $f62453a6e3b4559e$var$Dk(a, d), 1 === c && 0 === $f62453a6e3b4559e$var$K && 0 === (b.mode & 1) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
}
function $f62453a6e3b4559e$var$Dk(a, b) {
    var c = a.callbackNode;
    $f62453a6e3b4559e$var$wc(a, b);
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) null !== c && $f62453a6e3b4559e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f62453a6e3b4559e$var$bc(c);
        if (1 === b) 0 === a.tag ? $f62453a6e3b4559e$var$ig($f62453a6e3b4559e$var$Ek.bind(null, a)) : $f62453a6e3b4559e$var$hg($f62453a6e3b4559e$var$Ek.bind(null, a)), $f62453a6e3b4559e$var$Jf(function() {
            0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
        }), c = null;
        else {
            switch($f62453a6e3b4559e$var$Dc(d)){
                case 1:
                    c = $f62453a6e3b4559e$var$fc;
                    break;
                case 4:
                    c = $f62453a6e3b4559e$var$gc;
                    break;
                case 16:
                    c = $f62453a6e3b4559e$var$hc;
                    break;
                case 536870912:
                    c = $f62453a6e3b4559e$var$jc;
                    break;
                default:
                    c = $f62453a6e3b4559e$var$hc;
            }
            c = $f62453a6e3b4559e$var$Fk(c, $f62453a6e3b4559e$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f62453a6e3b4559e$var$Gk(a, b) {
    $f62453a6e3b4559e$var$Ak = -1;
    $f62453a6e3b4559e$var$Bk = 0;
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    var c = a.callbackNode;
    if ($f62453a6e3b4559e$var$Hk() && a.callbackNode !== c) return null;
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f62453a6e3b4559e$var$Ik(a, d);
    else {
        b = d;
        var e = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 2;
        var f = $f62453a6e3b4559e$var$Jk();
        if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$Kk(a, b);
        for(;;)try {
            $f62453a6e3b4559e$var$Lk();
            break;
        } catch (h) {
            $f62453a6e3b4559e$var$Mk(a, h);
        }
        $f62453a6e3b4559e$var$$g();
        $f62453a6e3b4559e$var$mk.current = f;
        $f62453a6e3b4559e$var$K = e;
        null !== $f62453a6e3b4559e$var$Y ? b = 0 : ($f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0, b = $f62453a6e3b4559e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f62453a6e3b4559e$var$xc(a), 0 !== e && (d = e, b = $f62453a6e3b4559e$var$Nk(a, e)));
        if (1 === b) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
        if (6 === b) $f62453a6e3b4559e$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f62453a6e3b4559e$var$Ok(e) && (b = $f62453a6e3b4559e$var$Ik(a, d), 2 === b && (f = $f62453a6e3b4559e$var$xc(a), 0 !== f && (d = f, b = $f62453a6e3b4559e$var$Nk(a, f))), 1 === b)) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f62453a6e3b4559e$var$p(345));
                case 2:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 3:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $f62453a6e3b4559e$var$fk + 500 - $f62453a6e3b4559e$var$B(), 10 < b)) {
                        if (0 !== $f62453a6e3b4559e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f62453a6e3b4559e$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), b);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 4:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f62453a6e3b4559e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f62453a6e3b4559e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f62453a6e3b4559e$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), d);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 5:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(329));
            }
        }
    }
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return a.callbackNode === c ? $f62453a6e3b4559e$var$Gk.bind(null, a) : null;
}
function $f62453a6e3b4559e$var$Nk(a, b) {
    var c = $f62453a6e3b4559e$var$sk;
    a.current.memoizedState.isDehydrated && ($f62453a6e3b4559e$var$Kk(a, b).flags |= 256);
    a = $f62453a6e3b4559e$var$Ik(a, b);
    2 !== a && (b = $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$tk = c, null !== b && $f62453a6e3b4559e$var$Fj(b));
    return a;
}
function $f62453a6e3b4559e$var$Fj(a) {
    null === $f62453a6e3b4559e$var$tk ? $f62453a6e3b4559e$var$tk = a : $f62453a6e3b4559e$var$tk.push.apply($f62453a6e3b4559e$var$tk, a);
}
function $f62453a6e3b4559e$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f62453a6e3b4559e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f62453a6e3b4559e$var$Ck(a, b) {
    b &= ~$f62453a6e3b4559e$var$rk;
    b &= ~$f62453a6e3b4559e$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f62453a6e3b4559e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f62453a6e3b4559e$var$Ek(a) {
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$uc(a, 0);
    if (0 === (b & 1)) return $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), null;
    var c = $f62453a6e3b4559e$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f62453a6e3b4559e$var$xc(a);
        0 !== d && (b = d, c = $f62453a6e3b4559e$var$Nk(a, d));
    }
    if (1 === c) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, b), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
    if (6 === c) throw Error($f62453a6e3b4559e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return null;
}
function $f62453a6e3b4559e$var$Qk(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f62453a6e3b4559e$var$K = c, 0 === $f62453a6e3b4559e$var$K && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
    }
}
function $f62453a6e3b4559e$var$Rk(a) {
    null !== $f62453a6e3b4559e$var$wk && 0 === $f62453a6e3b4559e$var$wk.tag && 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    var c = $f62453a6e3b4559e$var$ok.transition, d = $f62453a6e3b4559e$var$C;
    try {
        if ($f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, a) return a();
    } finally{
        $f62453a6e3b4559e$var$C = d, $f62453a6e3b4559e$var$ok.transition = c, $f62453a6e3b4559e$var$K = b, 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
    }
}
function $f62453a6e3b4559e$var$Hj() {
    $f62453a6e3b4559e$var$fj = $f62453a6e3b4559e$var$ej.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$ej);
}
function $f62453a6e3b4559e$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f62453a6e3b4559e$var$Gf(c));
    if (null !== $f62453a6e3b4559e$var$Y) for(c = $f62453a6e3b4559e$var$Y.return; null !== c;){
        var d = c;
        $f62453a6e3b4559e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f62453a6e3b4559e$var$$f();
                break;
            case 3:
                $f62453a6e3b4559e$var$zh();
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
                $f62453a6e3b4559e$var$Eh();
                break;
            case 5:
                $f62453a6e3b4559e$var$Bh(d);
                break;
            case 4:
                $f62453a6e3b4559e$var$zh();
                break;
            case 13:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 19:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 10:
                $f62453a6e3b4559e$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $f62453a6e3b4559e$var$Hj();
        }
        c = c.return;
    }
    $f62453a6e3b4559e$var$Q = a;
    $f62453a6e3b4559e$var$Y = a = $f62453a6e3b4559e$var$Pg(a.current, null);
    $f62453a6e3b4559e$var$Z = $f62453a6e3b4559e$var$fj = b;
    $f62453a6e3b4559e$var$T = 0;
    $f62453a6e3b4559e$var$pk = null;
    $f62453a6e3b4559e$var$rk = $f62453a6e3b4559e$var$qk = $f62453a6e3b4559e$var$rh = 0;
    $f62453a6e3b4559e$var$tk = $f62453a6e3b4559e$var$sk = null;
    if (null !== $f62453a6e3b4559e$var$fh) {
        for(b = 0; b < $f62453a6e3b4559e$var$fh.length; b++)if (c = $f62453a6e3b4559e$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f62453a6e3b4559e$var$fh = null;
    }
    return a;
}
function $f62453a6e3b4559e$var$Mk(a, b) {
    do {
        var c = $f62453a6e3b4559e$var$Y;
        try {
            $f62453a6e3b4559e$var$$g();
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
            if ($f62453a6e3b4559e$var$Ih) {
                for(var d = $f62453a6e3b4559e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f62453a6e3b4559e$var$Ih = !1;
            }
            $f62453a6e3b4559e$var$Hh = 0;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            $f62453a6e3b4559e$var$nk.current = null;
            if (null === c || null === c.return) {
                $f62453a6e3b4559e$var$T = 1;
                $f62453a6e3b4559e$var$pk = b;
                $f62453a6e3b4559e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f62453a6e3b4559e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f62453a6e3b4559e$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $f62453a6e3b4559e$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f62453a6e3b4559e$var$Si(f, l, b);
                            $f62453a6e3b4559e$var$tj();
                            break a;
                        }
                        k = Error($f62453a6e3b4559e$var$p(426));
                    }
                } else if ($f62453a6e3b4559e$var$I && h.mode & 1) {
                    var J = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f62453a6e3b4559e$var$Vi(J, g, h, f, b);
                        $f62453a6e3b4559e$var$Jg($f62453a6e3b4559e$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $f62453a6e3b4559e$var$Ji(k, h);
                4 !== $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 2);
                null === $f62453a6e3b4559e$var$sk ? $f62453a6e3b4559e$var$sk = [
                    f
                ] : $f62453a6e3b4559e$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f62453a6e3b4559e$var$Ni(f, k, b);
                            $f62453a6e3b4559e$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f62453a6e3b4559e$var$Qi(f, h, b);
                                $f62453a6e3b4559e$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f62453a6e3b4559e$var$Sk(c);
        } catch (na) {
            b = na;
            $f62453a6e3b4559e$var$Y === c && null !== c && ($f62453a6e3b4559e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f62453a6e3b4559e$var$Jk() {
    var a = $f62453a6e3b4559e$var$mk.current;
    $f62453a6e3b4559e$var$mk.current = $f62453a6e3b4559e$var$Rh;
    return null === a ? $f62453a6e3b4559e$var$Rh : a;
}
function $f62453a6e3b4559e$var$tj() {
    if (0 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T || 2 === $f62453a6e3b4559e$var$T) $f62453a6e3b4559e$var$T = 4;
    null === $f62453a6e3b4559e$var$Q || 0 === ($f62453a6e3b4559e$var$rh & 268435455) && 0 === ($f62453a6e3b4559e$var$qk & 268435455) || $f62453a6e3b4559e$var$Ck($f62453a6e3b4559e$var$Q, $f62453a6e3b4559e$var$Z);
}
function $f62453a6e3b4559e$var$Ik(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 2;
    var d = $f62453a6e3b4559e$var$Jk();
    if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Kk(a, b);
    for(;;)try {
        $f62453a6e3b4559e$var$Tk();
        break;
    } catch (e) {
        $f62453a6e3b4559e$var$Mk(a, e);
    }
    $f62453a6e3b4559e$var$$g();
    $f62453a6e3b4559e$var$K = c;
    $f62453a6e3b4559e$var$mk.current = d;
    if (null !== $f62453a6e3b4559e$var$Y) throw Error($f62453a6e3b4559e$var$p(261));
    $f62453a6e3b4559e$var$Q = null;
    $f62453a6e3b4559e$var$Z = 0;
    return $f62453a6e3b4559e$var$T;
}
function $f62453a6e3b4559e$var$Tk() {
    for(; null !== $f62453a6e3b4559e$var$Y;)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Lk() {
    for(; null !== $f62453a6e3b4559e$var$Y && !$f62453a6e3b4559e$var$cc();)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Uk(a) {
    var b = $f62453a6e3b4559e$var$Vk(a.alternate, a, $f62453a6e3b4559e$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f62453a6e3b4559e$var$Sk(a) : $f62453a6e3b4559e$var$Y = b;
    $f62453a6e3b4559e$var$nk.current = null;
}
function $f62453a6e3b4559e$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f62453a6e3b4559e$var$Ej(c, b, $f62453a6e3b4559e$var$fj), null !== c) {
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
        } else {
            c = $f62453a6e3b4559e$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f62453a6e3b4559e$var$T = 6;
                $f62453a6e3b4559e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f62453a6e3b4559e$var$Y = b;
            return;
        }
        $f62453a6e3b4559e$var$Y = b = a;
    }while (null !== b);
    0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 5);
}
function $f62453a6e3b4559e$var$Pk(a, b, c) {
    var d = $f62453a6e3b4559e$var$C, e = $f62453a6e3b4559e$var$ok.transition;
    try {
        $f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$Wk(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$ok.transition = e, $f62453a6e3b4559e$var$C = d;
    }
    return null;
}
function $f62453a6e3b4559e$var$Wk(a, b, c, d) {
    do $f62453a6e3b4559e$var$Hk();
    while (null !== $f62453a6e3b4559e$var$wk);
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f62453a6e3b4559e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f62453a6e3b4559e$var$Bc(a, f);
    a === $f62453a6e3b4559e$var$Q && ($f62453a6e3b4559e$var$Y = $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f62453a6e3b4559e$var$vk || ($f62453a6e3b4559e$var$vk = !0, $f62453a6e3b4559e$var$Fk($f62453a6e3b4559e$var$hc, function() {
        $f62453a6e3b4559e$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f62453a6e3b4559e$var$ok.transition;
        $f62453a6e3b4559e$var$ok.transition = null;
        var g = $f62453a6e3b4559e$var$C;
        $f62453a6e3b4559e$var$C = 1;
        var h = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 4;
        $f62453a6e3b4559e$var$nk.current = null;
        $f62453a6e3b4559e$var$Oj(a, c);
        $f62453a6e3b4559e$var$dk(c, a);
        $f62453a6e3b4559e$var$Oe($f62453a6e3b4559e$var$Df);
        $f62453a6e3b4559e$var$dd = !!$f62453a6e3b4559e$var$Cf;
        $f62453a6e3b4559e$var$Df = $f62453a6e3b4559e$var$Cf = null;
        a.current = c;
        $f62453a6e3b4559e$var$hk(c, a, e);
        $f62453a6e3b4559e$var$dc();
        $f62453a6e3b4559e$var$K = h;
        $f62453a6e3b4559e$var$C = g;
        $f62453a6e3b4559e$var$ok.transition = f;
    } else a.current = c;
    $f62453a6e3b4559e$var$vk && ($f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = a, $f62453a6e3b4559e$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($f62453a6e3b4559e$var$Ri = null);
    $f62453a6e3b4559e$var$mc(c.stateNode, d);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f62453a6e3b4559e$var$Oi) throw $f62453a6e3b4559e$var$Oi = !1, a = $f62453a6e3b4559e$var$Pi, $f62453a6e3b4559e$var$Pi = null, a;
    0 !== ($f62453a6e3b4559e$var$xk & 1) && 0 !== a.tag && $f62453a6e3b4559e$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f62453a6e3b4559e$var$zk ? $f62453a6e3b4559e$var$yk++ : ($f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = a) : $f62453a6e3b4559e$var$yk = 0;
    $f62453a6e3b4559e$var$jg();
    return null;
}
function $f62453a6e3b4559e$var$Hk() {
    if (null !== $f62453a6e3b4559e$var$wk) {
        var a = $f62453a6e3b4559e$var$Dc($f62453a6e3b4559e$var$xk), b = $f62453a6e3b4559e$var$ok.transition, c = $f62453a6e3b4559e$var$C;
        try {
            $f62453a6e3b4559e$var$ok.transition = null;
            $f62453a6e3b4559e$var$C = 16 > a ? 16 : a;
            if (null === $f62453a6e3b4559e$var$wk) var d = !1;
            else {
                a = $f62453a6e3b4559e$var$wk;
                $f62453a6e3b4559e$var$wk = null;
                $f62453a6e3b4559e$var$xk = 0;
                if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(331));
                var e = $f62453a6e3b4559e$var$K;
                $f62453a6e3b4559e$var$K |= 4;
                for($f62453a6e3b4559e$var$V = a.current; null !== $f62453a6e3b4559e$var$V;){
                    var f = $f62453a6e3b4559e$var$V, g = f.child;
                    if (0 !== ($f62453a6e3b4559e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f62453a6e3b4559e$var$V = l; null !== $f62453a6e3b4559e$var$V;){
                                    var m = $f62453a6e3b4559e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f62453a6e3b4559e$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f62453a6e3b4559e$var$V = q;
                                    else for(; null !== $f62453a6e3b4559e$var$V;){
                                        m = $f62453a6e3b4559e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f62453a6e3b4559e$var$Sj(m);
                                        if (m === l) {
                                            $f62453a6e3b4559e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f62453a6e3b4559e$var$V = r;
                                            break;
                                        }
                                        $f62453a6e3b4559e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f62453a6e3b4559e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f62453a6e3b4559e$var$V = g;
                    else b: for(; null !== $f62453a6e3b4559e$var$V;){
                        f = $f62453a6e3b4559e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f62453a6e3b4559e$var$V = x;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f62453a6e3b4559e$var$V = w; null !== $f62453a6e3b4559e$var$V;){
                    g = $f62453a6e3b4559e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f62453a6e3b4559e$var$V = u;
                    else b: for(g = w; null !== $f62453a6e3b4559e$var$V;){
                        h = $f62453a6e3b4559e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f62453a6e3b4559e$var$Qj(9, h);
                            }
                        } catch (na) {
                            $f62453a6e3b4559e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f62453a6e3b4559e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f62453a6e3b4559e$var$V = F;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = h.return;
                    }
                }
                $f62453a6e3b4559e$var$K = e;
                $f62453a6e3b4559e$var$jg();
                if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot) try {
                    $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot($f62453a6e3b4559e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$ok.transition = b;
        }
    }
    return !1;
}
function $f62453a6e3b4559e$var$Xk(a, b, c) {
    b = $f62453a6e3b4559e$var$Ji(c, b);
    b = $f62453a6e3b4559e$var$Ni(a, b, 1);
    a = $f62453a6e3b4559e$var$nh(a, b, 1);
    b = $f62453a6e3b4559e$var$R();
    null !== a && ($f62453a6e3b4559e$var$Ac(a, 1, b), $f62453a6e3b4559e$var$Dk(a, b));
}
function $f62453a6e3b4559e$var$W(a, b, c) {
    if (3 === a.tag) $f62453a6e3b4559e$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f62453a6e3b4559e$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(d))) {
                a = $f62453a6e3b4559e$var$Ji(c, a);
                a = $f62453a6e3b4559e$var$Qi(b, a, 1);
                b = $f62453a6e3b4559e$var$nh(b, a, 1);
                a = $f62453a6e3b4559e$var$R();
                null !== b && ($f62453a6e3b4559e$var$Ac(b, 1, a), $f62453a6e3b4559e$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f62453a6e3b4559e$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f62453a6e3b4559e$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $f62453a6e3b4559e$var$Q === a && ($f62453a6e3b4559e$var$Z & c) === c && (4 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$Z & 130023424) === $f62453a6e3b4559e$var$Z && 500 > $f62453a6e3b4559e$var$B() - $f62453a6e3b4559e$var$fk ? $f62453a6e3b4559e$var$Kk(a, 0) : $f62453a6e3b4559e$var$rk |= c);
    $f62453a6e3b4559e$var$Dk(a, b);
}
function $f62453a6e3b4559e$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f62453a6e3b4559e$var$sc, $f62453a6e3b4559e$var$sc <<= 1, 0 === ($f62453a6e3b4559e$var$sc & 130023424) && ($f62453a6e3b4559e$var$sc = 4194304)));
    var c = $f62453a6e3b4559e$var$R();
    a = $f62453a6e3b4559e$var$ih(a, b);
    null !== a && ($f62453a6e3b4559e$var$Ac(a, b, c), $f62453a6e3b4559e$var$Dk(a, c));
}
function $f62453a6e3b4559e$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f62453a6e3b4559e$var$Yk(a, c);
}
function $f62453a6e3b4559e$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f62453a6e3b4559e$var$p(314));
    }
    null !== d && d.delete(b);
    $f62453a6e3b4559e$var$Yk(a, c);
}
var $f62453a6e3b4559e$var$Vk;
$f62453a6e3b4559e$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f62453a6e3b4559e$var$Wf.current) $f62453a6e3b4559e$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$yj(a, b, c);
            $f62453a6e3b4559e$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$I && 0 !== (b.flags & 1048576) && $f62453a6e3b4559e$var$ug(b, $f62453a6e3b4559e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f62453a6e3b4559e$var$ij(a, b);
            a = b.pendingProps;
            var e = $f62453a6e3b4559e$var$Yf(b, $f62453a6e3b4559e$var$H.current);
            $f62453a6e3b4559e$var$ch(b, c);
            e = $f62453a6e3b4559e$var$Nh(null, b, d, a, e, c);
            var f = $f62453a6e3b4559e$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f62453a6e3b4559e$var$Zf(d) ? (f = !0, $f62453a6e3b4559e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f62453a6e3b4559e$var$kh(b), e.updater = $f62453a6e3b4559e$var$Ei, b.stateNode = e, e._reactInternals = b, $f62453a6e3b4559e$var$Ii(b, d, a, c), b = $f62453a6e3b4559e$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $f62453a6e3b4559e$var$I && f && $f62453a6e3b4559e$var$vg(b), $f62453a6e3b4559e$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f62453a6e3b4559e$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f62453a6e3b4559e$var$Zk(d);
                a = $f62453a6e3b4559e$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $f62453a6e3b4559e$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f62453a6e3b4559e$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f62453a6e3b4559e$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f62453a6e3b4559e$var$$i(null, b, d, $f62453a6e3b4559e$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($f62453a6e3b4559e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $f62453a6e3b4559e$var$kj(b);
                if (null === a) throw Error($f62453a6e3b4559e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f62453a6e3b4559e$var$lh(a, b);
                $f62453a6e3b4559e$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(423)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(424)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else for($f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.stateNode.containerInfo.firstChild), $f62453a6e3b4559e$var$xg = b, $f62453a6e3b4559e$var$I = !0, $f62453a6e3b4559e$var$zg = null, c = $f62453a6e3b4559e$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f62453a6e3b4559e$var$Ig();
                    if (d === e) {
                        b = $f62453a6e3b4559e$var$Zi(a, b, c);
                        break a;
                    }
                    $f62453a6e3b4559e$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f62453a6e3b4559e$var$Ah(b), null === a && $f62453a6e3b4559e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f62453a6e3b4559e$var$Ef(d, e) ? g = null : null !== f && $f62453a6e3b4559e$var$Ef(d, f) && (b.flags |= 32), $f62453a6e3b4559e$var$gj(a, b), $f62453a6e3b4559e$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $f62453a6e3b4559e$var$Eg(b), null;
        case 13:
            return $f62453a6e3b4559e$var$oj(a, b, c);
        case 4:
            return $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f62453a6e3b4559e$var$Ug(b, null, d, c) : $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$Yi(a, b, d, e, c);
        case 7:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f62453a6e3b4559e$var$He(f.value, g)) {
                        if (f.children === e.children && !$f62453a6e3b4559e$var$Wf.current) {
                            b = $f62453a6e3b4559e$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f62453a6e3b4559e$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f62453a6e3b4559e$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f62453a6e3b4559e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f62453a6e3b4559e$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f62453a6e3b4559e$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f62453a6e3b4559e$var$ch(b, c), e = $f62453a6e3b4559e$var$eh(e), d = d(e), b.flags |= 1, $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f62453a6e3b4559e$var$Ci(d, b.pendingProps), e = $f62453a6e3b4559e$var$Ci(d.type, e), $f62453a6e3b4559e$var$$i(a, b, d, e, c);
        case 15:
            return $f62453a6e3b4559e$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$ij(a, b), b.tag = 1, $f62453a6e3b4559e$var$Zf(d) ? (a = !0, $f62453a6e3b4559e$var$cg(b)) : a = !1, $f62453a6e3b4559e$var$ch(b, c), $f62453a6e3b4559e$var$Gi(b, d, e), $f62453a6e3b4559e$var$Ii(b, d, e, c), $f62453a6e3b4559e$var$jj(null, b, d, !0, a, c);
        case 19:
            return $f62453a6e3b4559e$var$xj(a, b, c);
        case 22:
            return $f62453a6e3b4559e$var$dj(a, b, c);
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
};
function $f62453a6e3b4559e$var$Fk(a, b) {
    return $f62453a6e3b4559e$var$ac(a, b);
}
function $f62453a6e3b4559e$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f62453a6e3b4559e$var$Bg(a, b, c, d) {
    return new $f62453a6e3b4559e$var$$k(a, b, c, d);
}
function $f62453a6e3b4559e$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f62453a6e3b4559e$var$Zk(a) {
    if ("function" === typeof a) return $f62453a6e3b4559e$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f62453a6e3b4559e$var$Da) return 11;
        if (a === $f62453a6e3b4559e$var$Ga) return 14;
    }
    return 2;
}
function $f62453a6e3b4559e$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $f62453a6e3b4559e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f62453a6e3b4559e$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f62453a6e3b4559e$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f62453a6e3b4559e$var$ya:
            return $f62453a6e3b4559e$var$Tg(c.children, e, f, b);
        case $f62453a6e3b4559e$var$za:
            g = 8;
            e |= 8;
            break;
        case $f62453a6e3b4559e$var$Aa:
            return a = $f62453a6e3b4559e$var$Bg(12, c, b, e | 2), a.elementType = $f62453a6e3b4559e$var$Aa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ea:
            return a = $f62453a6e3b4559e$var$Bg(13, c, b, e), a.elementType = $f62453a6e3b4559e$var$Ea, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Fa:
            return a = $f62453a6e3b4559e$var$Bg(19, c, b, e), a.elementType = $f62453a6e3b4559e$var$Fa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ia:
            return $f62453a6e3b4559e$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f62453a6e3b4559e$var$Ba:
                    g = 10;
                    break a;
                case $f62453a6e3b4559e$var$Ca:
                    g = 9;
                    break a;
                case $f62453a6e3b4559e$var$Da:
                    g = 11;
                    break a;
                case $f62453a6e3b4559e$var$Ga:
                    g = 14;
                    break a;
                case $f62453a6e3b4559e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f62453a6e3b4559e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f62453a6e3b4559e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f62453a6e3b4559e$var$Tg(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$pj(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(22, a, d, b);
    a.elementType = $f62453a6e3b4559e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f62453a6e3b4559e$var$Qg(a, b, c) {
    a = $f62453a6e3b4559e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$Sg(a, b, c) {
    b = $f62453a6e3b4559e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f62453a6e3b4559e$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f62453a6e3b4559e$var$zc(0);
    this.expirationTimes = $f62453a6e3b4559e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f62453a6e3b4559e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f62453a6e3b4559e$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $f62453a6e3b4559e$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f62453a6e3b4559e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f62453a6e3b4559e$var$kh(f);
    return a;
}
function $f62453a6e3b4559e$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f62453a6e3b4559e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f62453a6e3b4559e$var$dl(a) {
    if (!a) return $f62453a6e3b4559e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f62453a6e3b4559e$var$Vb(a) !== a || 1 !== a.tag) throw Error($f62453a6e3b4559e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f62453a6e3b4559e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f62453a6e3b4559e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f62453a6e3b4559e$var$Zf(c)) return $f62453a6e3b4559e$var$bg(a, c, b);
    }
    return b;
}
function $f62453a6e3b4559e$var$el(a, b, c, d, e, f, g, h, k) {
    a = $f62453a6e3b4559e$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $f62453a6e3b4559e$var$dl(null);
    c = a.current;
    d = $f62453a6e3b4559e$var$R();
    e = $f62453a6e3b4559e$var$yi(c);
    f = $f62453a6e3b4559e$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f62453a6e3b4559e$var$nh(c, f, e);
    a.current.lanes = e;
    $f62453a6e3b4559e$var$Ac(a, e, d);
    $f62453a6e3b4559e$var$Dk(a, d);
    return a;
}
function $f62453a6e3b4559e$var$fl(a, b, c, d) {
    var e = b.current, f = $f62453a6e3b4559e$var$R(), g = $f62453a6e3b4559e$var$yi(e);
    c = $f62453a6e3b4559e$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f62453a6e3b4559e$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f62453a6e3b4559e$var$nh(e, b, g);
    null !== a && ($f62453a6e3b4559e$var$gi(a, e, g, f), $f62453a6e3b4559e$var$oh(a, e, g));
    return g;
}
function $f62453a6e3b4559e$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f62453a6e3b4559e$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f62453a6e3b4559e$var$il(a, b) {
    $f62453a6e3b4559e$var$hl(a, b);
    (a = a.alternate) && $f62453a6e3b4559e$var$hl(a, b);
}
function $f62453a6e3b4559e$var$jl() {
    return null;
}
var $f62453a6e3b4559e$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f62453a6e3b4559e$var$ll(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.render = $f62453a6e3b4559e$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f62453a6e3b4559e$var$p(409));
    $f62453a6e3b4559e$var$fl(a, b, null, null);
};
$f62453a6e3b4559e$var$ml.prototype.unmount = $f62453a6e3b4559e$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f62453a6e3b4559e$var$Rk(function() {
            $f62453a6e3b4559e$var$fl(null, a, null, null);
        });
        b[$f62453a6e3b4559e$var$uf] = null;
    }
};
function $f62453a6e3b4559e$var$ml(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f62453a6e3b4559e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f62453a6e3b4559e$var$Qc.length && 0 !== b && b < $f62453a6e3b4559e$var$Qc[c].priority; c++);
        $f62453a6e3b4559e$var$Qc.splice(c, 0, a);
        0 === c && $f62453a6e3b4559e$var$Vc(a);
    }
};
function $f62453a6e3b4559e$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f62453a6e3b4559e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f62453a6e3b4559e$var$pl() {}
function $f62453a6e3b4559e$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                f.call(a);
            };
        }
        var g = $f62453a6e3b4559e$var$el(b, d, a, 0, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
        a._reactRootContainer = g;
        a[$f62453a6e3b4559e$var$uf] = g.current;
        $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f62453a6e3b4559e$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f62453a6e3b4559e$var$gl(k);
            h.call(a);
        };
    }
    var k = $f62453a6e3b4559e$var$bl(a, 0, !1, null, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
    a._reactRootContainer = k;
    a[$f62453a6e3b4559e$var$uf] = k.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$fl(b, k, c, d);
    });
    return k;
}
function $f62453a6e3b4559e$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                h.call(a);
            };
        }
        $f62453a6e3b4559e$var$fl(b, g, a, e);
    } else g = $f62453a6e3b4559e$var$ql(c, b, a, e, d);
    return $f62453a6e3b4559e$var$gl(g);
}
$f62453a6e3b4559e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f62453a6e3b4559e$var$tc(b.pendingLanes);
                0 !== c && ($f62453a6e3b4559e$var$Cc(b, c | 1), $f62453a6e3b4559e$var$Dk(b, $f62453a6e3b4559e$var$B()), 0 === ($f62453a6e3b4559e$var$K & 6) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$jg()));
            }
            break;
        case 13:
            $f62453a6e3b4559e$var$Rk(function() {
                var b = $f62453a6e3b4559e$var$ih(a, 1);
                if (null !== b) {
                    var c = $f62453a6e3b4559e$var$R();
                    $f62453a6e3b4559e$var$gi(b, a, 1, c);
                }
            }), $f62453a6e3b4559e$var$il(a, 1);
    }
};
$f62453a6e3b4559e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$ih(a, 134217728);
        if (null !== b) {
            var c = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(b, a, 134217728, c);
        }
        $f62453a6e3b4559e$var$il(a, 134217728);
    }
};
$f62453a6e3b4559e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$yi(a), c = $f62453a6e3b4559e$var$ih(a, b);
        if (null !== c) {
            var d = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(c, a, b, d);
        }
        $f62453a6e3b4559e$var$il(a, b);
    }
};
$f62453a6e3b4559e$var$Hc = function() {
    return $f62453a6e3b4559e$var$C;
};
$f62453a6e3b4559e$var$Ic = function(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    try {
        return $f62453a6e3b4559e$var$C = a, b();
    } finally{
        $f62453a6e3b4559e$var$C = c;
    }
};
$f62453a6e3b4559e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f62453a6e3b4559e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f62453a6e3b4559e$var$Db(d);
                        if (!e) throw Error($f62453a6e3b4559e$var$p(90));
                        $f62453a6e3b4559e$var$Wa(d);
                        $f62453a6e3b4559e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f62453a6e3b4559e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f62453a6e3b4559e$var$fb(a, !!c.multiple, b, !1);
    }
};
$f62453a6e3b4559e$var$Gb = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$var$Hb = $f62453a6e3b4559e$var$Rk;
var $f62453a6e3b4559e$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $f62453a6e3b4559e$var$Cb,
        $f62453a6e3b4559e$var$ue,
        $f62453a6e3b4559e$var$Db,
        $f62453a6e3b4559e$var$Eb,
        $f62453a6e3b4559e$var$Fb,
        $f62453a6e3b4559e$var$Qk
    ]
}, $f62453a6e3b4559e$var$tl = {
    findFiberByHostInstance: $f62453a6e3b4559e$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $f62453a6e3b4559e$var$ul = {
    bundleType: $f62453a6e3b4559e$var$tl.bundleType,
    version: $f62453a6e3b4559e$var$tl.version,
    rendererPackageName: $f62453a6e3b4559e$var$tl.rendererPackageName,
    rendererConfig: $f62453a6e3b4559e$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f62453a6e3b4559e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f62453a6e3b4559e$var$tl.findFiberByHostInstance || $f62453a6e3b4559e$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f62453a6e3b4559e$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f62453a6e3b4559e$var$vl.isDisabled && $f62453a6e3b4559e$var$vl.supportsFiber) try {
        $f62453a6e3b4559e$var$kc = $f62453a6e3b4559e$var$vl.inject($f62453a6e3b4559e$var$ul), $f62453a6e3b4559e$var$lc = $f62453a6e3b4559e$var$vl;
    } catch (a) {}
}
$f62453a6e3b4559e$export$ae55be85d98224ed = $f62453a6e3b4559e$var$sl;
$f62453a6e3b4559e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f62453a6e3b4559e$var$nl(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$cl(a, b, null, c);
};
$f62453a6e3b4559e$export$882461b6382ed46c = function(a, b) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(299));
    var c = !1, d = "", e = $f62453a6e3b4559e$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f62453a6e3b4559e$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f62453a6e3b4559e$var$ll(b);
};
$f62453a6e3b4559e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f62453a6e3b4559e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f62453a6e3b4559e$var$p(268, a));
    }
    a = $f62453a6e3b4559e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f62453a6e3b4559e$export$cd75ccfd720a3cd4 = function(a) {
    return $f62453a6e3b4559e$var$Rk(a);
};
$f62453a6e3b4559e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !0, c);
};
$f62453a6e3b4559e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f62453a6e3b4559e$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f62453a6e3b4559e$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f62453a6e3b4559e$var$ml(b);
};
$f62453a6e3b4559e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !1, c);
};
$f62453a6e3b4559e$export$502457920280e6be = function(a) {
    if (!$f62453a6e3b4559e$var$ol(a)) throw Error($f62453a6e3b4559e$var$p(40));
    return a._reactRootContainer ? ($f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f62453a6e3b4559e$var$uf] = null;
        });
    }), !0) : !1;
};
$f62453a6e3b4559e$export$c78a37762a8d58e1 = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f62453a6e3b4559e$var$ol(c)) throw Error($f62453a6e3b4559e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f62453a6e3b4559e$var$p(38));
    return $f62453a6e3b4559e$var$rl(a, b, c, !1, d);
};
$f62453a6e3b4559e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7zDBh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
"use strict";
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});



parcelRegister("h5Z1H", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

var $14024a6d51999040$exports = {};
"use strict";

$14024a6d51999040$exports = (parcelRequire("aPfka"));


parcelRequire("aqdBs");
var $c920eedc27eaef64$export$882461b6382ed46c;
var $c920eedc27eaef64$export$757ceba2d55c277e;
"use strict";
var $e813d4480671d45c$exports = {};
"use strict";
function $e813d4480671d45c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e813d4480671d45c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e813d4480671d45c$var$checkDCE();

$e813d4480671d45c$exports = (parcelRequire("l8cRS"));


var $c920eedc27eaef64$var$i;
$c920eedc27eaef64$export$882461b6382ed46c = $e813d4480671d45c$exports.createRoot;
$c920eedc27eaef64$export$757ceba2d55c277e = $e813d4480671d45c$exports.hydrateRoot;




var $aqdBs = parcelRequire("aqdBs");
/**
 * React Router DOM v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aqdBs = parcelRequire("aqdBs");

/**
 * @remix-run/router v1.19.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $50cc6ffcbdc13a7b$var$_extends() {
    $50cc6ffcbdc13a7b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $50cc6ffcbdc13a7b$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($50cc6ffcbdc13a7b$export$e19cd5f9376f8cee || ($50cc6ffcbdc13a7b$export$e19cd5f9376f8cee = {}));
const $50cc6ffcbdc13a7b$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $50cc6ffcbdc13a7b$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $50cc6ffcbdc13a7b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $50cc6ffcbdc13a7b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $50cc6ffcbdc13a7b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $50cc6ffcbdc13a7b$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $50cc6ffcbdc13a7b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $50cc6ffcbdc13a7b$export$fe53371bee54353d(to);
    }
    return $50cc6ffcbdc13a7b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $50cc6ffcbdc13a7b$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $50cc6ffcbdc13a7b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $50cc6ffcbdc13a7b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $50cc6ffcbdc13a7b$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $50cc6ffcbdc13a7b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $50cc6ffcbdc13a7b$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $50cc6ffcbdc13a7b$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $50cc6ffcbdc13a7b$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $50cc6ffcbdc13a7b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $50cc6ffcbdc13a7b$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $50cc6ffcbdc13a7b$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $50cc6ffcbdc13a7b$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $50cc6ffcbdc13a7b$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $50cc6ffcbdc13a7b$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($50cc6ffcbdc13a7b$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Push;
        let location = $50cc6ffcbdc13a7b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $50cc6ffcbdc13a7b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Replace;
        let location = $50cc6ffcbdc13a7b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $50cc6ffcbdc13a7b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $50cc6ffcbdc13a7b$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($50cc6ffcbdc13a7b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($50cc6ffcbdc13a7b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $50cc6ffcbdc13a7b$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($50cc6ffcbdc13a7b$var$ResultType || ($50cc6ffcbdc13a7b$var$ResultType = {}));
const $50cc6ffcbdc13a7b$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $50cc6ffcbdc13a7b$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $50cc6ffcbdc13a7b$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($50cc6ffcbdc13a7b$var$isIndexRoute(route)) {
            let indexRoute = $50cc6ffcbdc13a7b$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $50cc6ffcbdc13a7b$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $50cc6ffcbdc13a7b$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $50cc6ffcbdc13a7b$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $50cc6ffcbdc13a7b$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $50cc6ffcbdc13a7b$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $50cc6ffcbdc13a7b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $50cc6ffcbdc13a7b$var$flattenRoutes(routes);
    $50cc6ffcbdc13a7b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $50cc6ffcbdc13a7b$export$30d21fd6d7295f52(pathname);
        matches = $50cc6ffcbdc13a7b$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $50cc6ffcbdc13a7b$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $50cc6ffcbdc13a7b$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $50cc6ffcbdc13a7b$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $50cc6ffcbdc13a7b$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $50cc6ffcbdc13a7b$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $50cc6ffcbdc13a7b$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $50cc6ffcbdc13a7b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $50cc6ffcbdc13a7b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $50cc6ffcbdc13a7b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $50cc6ffcbdc13a7b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $50cc6ffcbdc13a7b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $50cc6ffcbdc13a7b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $50cc6ffcbdc13a7b$var$paramRe = /^:[\w-]+$/;
const $50cc6ffcbdc13a7b$var$dynamicSegmentValue = 3;
const $50cc6ffcbdc13a7b$var$indexRouteValue = 2;
const $50cc6ffcbdc13a7b$var$emptySegmentValue = 1;
const $50cc6ffcbdc13a7b$var$staticSegmentValue = 10;
const $50cc6ffcbdc13a7b$var$splatPenalty = -2;
const $50cc6ffcbdc13a7b$var$isSplat = (s)=>s === "*";
function $50cc6ffcbdc13a7b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($50cc6ffcbdc13a7b$var$isSplat)) initialScore += $50cc6ffcbdc13a7b$var$splatPenalty;
    if (index) initialScore += $50cc6ffcbdc13a7b$var$indexRouteValue;
    return segments.filter((s)=>!$50cc6ffcbdc13a7b$var$isSplat(s)).reduce((score, segment)=>score + ($50cc6ffcbdc13a7b$var$paramRe.test(segment) ? $50cc6ffcbdc13a7b$var$dynamicSegmentValue : segment === "" ? $50cc6ffcbdc13a7b$var$emptySegmentValue : $50cc6ffcbdc13a7b$var$staticSegmentValue), initialScore);
}
function $50cc6ffcbdc13a7b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $50cc6ffcbdc13a7b$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $50cc6ffcbdc13a7b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $50cc6ffcbdc13a7b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $50cc6ffcbdc13a7b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $50cc6ffcbdc13a7b$export$a5c6d149b50c1d86($50cc6ffcbdc13a7b$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $50cc6ffcbdc13a7b$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $50cc6ffcbdc13a7b$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $50cc6ffcbdc13a7b$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $50cc6ffcbdc13a7b$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $50cc6ffcbdc13a7b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $50cc6ffcbdc13a7b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $50cc6ffcbdc13a7b$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $50cc6ffcbdc13a7b$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $50cc6ffcbdc13a7b$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $50cc6ffcbdc13a7b$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $50cc6ffcbdc13a7b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $50cc6ffcbdc13a7b$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $50cc6ffcbdc13a7b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $50cc6ffcbdc13a7b$var$normalizeSearch(search),
        hash: $50cc6ffcbdc13a7b$var$normalizeHash(hash)
    };
}
function $50cc6ffcbdc13a7b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $50cc6ffcbdc13a7b$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $50cc6ffcbdc13a7b$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $50cc6ffcbdc13a7b$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $50cc6ffcbdc13a7b$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $50cc6ffcbdc13a7b$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(toArg);
    else {
        to = $50cc6ffcbdc13a7b$var$_extends({}, toArg);
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $50cc6ffcbdc13a7b$var$getInvalidPathError("?", "pathname", "search", to));
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $50cc6ffcbdc13a7b$var$getInvalidPathError("#", "pathname", "hash", to));
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $50cc6ffcbdc13a7b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $50cc6ffcbdc13a7b$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $50cc6ffcbdc13a7b$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $50cc6ffcbdc13a7b$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $50cc6ffcbdc13a7b$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $50cc6ffcbdc13a7b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $50cc6ffcbdc13a7b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $50cc6ffcbdc13a7b$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $50cc6ffcbdc13a7b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $50cc6ffcbdc13a7b$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $50cc6ffcbdc13a7b$export$480182c6abbb2ff6(data, init) {
    return new $50cc6ffcbdc13a7b$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $50cc6ffcbdc13a7b$export$42a99a7a4bc0e76a extends Error {
}
class $50cc6ffcbdc13a7b$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $50cc6ffcbdc13a7b$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $50cc6ffcbdc13a7b$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $50cc6ffcbdc13a7b$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $50cc6ffcbdc13a7b$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $50cc6ffcbdc13a7b$var$unwrapTrackedPromise(value) {
    if (!$50cc6ffcbdc13a7b$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $50cc6ffcbdc13a7b$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $50cc6ffcbdc13a7b$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $50cc6ffcbdc13a7b$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $50cc6ffcbdc13a7b$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $50cc6ffcbdc13a7b$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $50cc6ffcbdc13a7b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $50cc6ffcbdc13a7b$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $50cc6ffcbdc13a7b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $50cc6ffcbdc13a7b$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $50cc6ffcbdc13a7b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $50cc6ffcbdc13a7b$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $50cc6ffcbdc13a7b$var$validMutationMethods = new Set($50cc6ffcbdc13a7b$var$validMutationMethodsArr);
const $50cc6ffcbdc13a7b$var$validRequestMethodsArr = [
    "get",
    ...$50cc6ffcbdc13a7b$var$validMutationMethodsArr
];
const $50cc6ffcbdc13a7b$var$validRequestMethods = new Set($50cc6ffcbdc13a7b$var$validRequestMethodsArr);
const $50cc6ffcbdc13a7b$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $50cc6ffcbdc13a7b$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $50cc6ffcbdc13a7b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $50cc6ffcbdc13a7b$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $50cc6ffcbdc13a7b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $50cc6ffcbdc13a7b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $50cc6ffcbdc13a7b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $50cc6ffcbdc13a7b$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $50cc6ffcbdc13a7b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $50cc6ffcbdc13a7b$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $50cc6ffcbdc13a7b$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $50cc6ffcbdc13a7b$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $50cc6ffcbdc13a7b$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $50cc6ffcbdc13a7b$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $50cc6ffcbdc13a7b$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $50cc6ffcbdc13a7b$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $50cc6ffcbdc13a7b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $50cc6ffcbdc13a7b$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $50cc6ffcbdc13a7b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $50cc6ffcbdc13a7b$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$50cc6ffcbdc13a7b$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $50cc6ffcbdc13a7b$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $50cc6ffcbdc13a7b$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $50cc6ffcbdc13a7b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $50cc6ffcbdc13a7b$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $50cc6ffcbdc13a7b$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($50cc6ffcbdc13a7b$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $50cc6ffcbdc13a7b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $50cc6ffcbdc13a7b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $50cc6ffcbdc13a7b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $50cc6ffcbdc13a7b$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $50cc6ffcbdc13a7b$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $50cc6ffcbdc13a7b$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $50cc6ffcbdc13a7b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $50cc6ffcbdc13a7b$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $50cc6ffcbdc13a7b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $50cc6ffcbdc13a7b$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $50cc6ffcbdc13a7b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $50cc6ffcbdc13a7b$var$findNearestBoundary(matches).route.id,
            {
                type: $50cc6ffcbdc13a7b$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $50cc6ffcbdc13a7b$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($50cc6ffcbdc13a7b$var$isErrorResult(result) && $50cc6ffcbdc13a7b$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $50cc6ffcbdc13a7b$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $50cc6ffcbdc13a7b$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $50cc6ffcbdc13a7b$var$_extends({
            matches: updatedMatches || matches
        }, $50cc6ffcbdc13a7b$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $50cc6ffcbdc13a7b$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $50cc6ffcbdc13a7b$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $50cc6ffcbdc13a7b$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $50cc6ffcbdc13a7b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $50cc6ffcbdc13a7b$var$ResultType.error,
            error: $50cc6ffcbdc13a7b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($50cc6ffcbdc13a7b$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $50cc6ffcbdc13a7b$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($50cc6ffcbdc13a7b$var$isDeferredResult(result)) throw $50cc6ffcbdc13a7b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($50cc6ffcbdc13a7b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $50cc6ffcbdc13a7b$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $50cc6ffcbdc13a7b$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $50cc6ffcbdc13a7b$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($50cc6ffcbdc13a7b$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $50cc6ffcbdc13a7b$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $50cc6ffcbdc13a7b$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $50cc6ffcbdc13a7b$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $50cc6ffcbdc13a7b$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $50cc6ffcbdc13a7b$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $50cc6ffcbdc13a7b$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $50cc6ffcbdc13a7b$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $50cc6ffcbdc13a7b$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $50cc6ffcbdc13a7b$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $50cc6ffcbdc13a7b$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $50cc6ffcbdc13a7b$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $50cc6ffcbdc13a7b$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $50cc6ffcbdc13a7b$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $50cc6ffcbdc13a7b$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $50cc6ffcbdc13a7b$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $50cc6ffcbdc13a7b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $50cc6ffcbdc13a7b$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($50cc6ffcbdc13a7b$var$isRedirectResult(actionResult) || $50cc6ffcbdc13a7b$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $50cc6ffcbdc13a7b$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($50cc6ffcbdc13a7b$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $50cc6ffcbdc13a7b$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $50cc6ffcbdc13a7b$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($50cc6ffcbdc13a7b$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($50cc6ffcbdc13a7b$var$isDeferredResult(actionResult)) throw $50cc6ffcbdc13a7b$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $50cc6ffcbdc13a7b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $50cc6ffcbdc13a7b$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $50cc6ffcbdc13a7b$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $50cc6ffcbdc13a7b$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $50cc6ffcbdc13a7b$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $50cc6ffcbdc13a7b$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false);
        redirect = $50cc6ffcbdc13a7b$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $50cc6ffcbdc13a7b$var$processLoaderData(state, matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $50cc6ffcbdc13a7b$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $50cc6ffcbdc13a7b$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $50cc6ffcbdc13a7b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $50cc6ffcbdc13a7b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $50cc6ffcbdc13a7b$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $50cc6ffcbdc13a7b$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($50cc6ffcbdc13a7b$var$isDeferredResult(result)) result = await $50cc6ffcbdc13a7b$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $50cc6ffcbdc13a7b$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($50cc6ffcbdc13a7b$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $50cc6ffcbdc13a7b$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($50cc6ffcbdc13a7b$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(!$50cc6ffcbdc13a7b$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $50cc6ffcbdc13a7b$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $50cc6ffcbdc13a7b$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $50cc6ffcbdc13a7b$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($50cc6ffcbdc13a7b$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $50cc6ffcbdc13a7b$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Replace : $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $50cc6ffcbdc13a7b$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($50cc6ffcbdc13a7b$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $50cc6ffcbdc13a7b$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $50cc6ffcbdc13a7b$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $50cc6ffcbdc13a7b$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $50cc6ffcbdc13a7b$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $50cc6ffcbdc13a7b$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($50cc6ffcbdc13a7b$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $50cc6ffcbdc13a7b$var$ResultType.redirect,
                response: $50cc6ffcbdc13a7b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $50cc6ffcbdc13a7b$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $50cc6ffcbdc13a7b$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $50cc6ffcbdc13a7b$var$ResultType.error,
                    error: $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $50cc6ffcbdc13a7b$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $50cc6ffcbdc13a7b$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $50cc6ffcbdc13a7b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $50cc6ffcbdc13a7b$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $50cc6ffcbdc13a7b$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $50cc6ffcbdc13a7b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $50cc6ffcbdc13a7b$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $50cc6ffcbdc13a7b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $50cc6ffcbdc13a7b$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $50cc6ffcbdc13a7b$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $50cc6ffcbdc13a7b$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $50cc6ffcbdc13a7b$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $50cc6ffcbdc13a7b$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $50cc6ffcbdc13a7b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$50cc6ffcbdc13a7b$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                let fogMatches = $50cc6ffcbdc13a7b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $50cc6ffcbdc13a7b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $50cc6ffcbdc13a7b$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $50cc6ffcbdc13a7b$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = $50cc6ffcbdc13a7b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $50cc6ffcbdc13a7b$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $50cc6ffcbdc13a7b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $50cc6ffcbdc13a7b$export$4d0306f8f6a4585b = Symbol("deferred");
function $50cc6ffcbdc13a7b$export$3336b097a6fbc59a(routes, opts) {
    $50cc6ffcbdc13a7b$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $50cc6ffcbdc13a7b$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $50cc6ffcbdc13a7b$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $50cc6ffcbdc13a7b$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $50cc6ffcbdc13a7b$var$createLocation("", $50cc6ffcbdc13a7b$export$fe53371bee54353d(url), null, "default");
        let matches = $50cc6ffcbdc13a7b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$50cc6ffcbdc13a7b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $50cc6ffcbdc13a7b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $50cc6ffcbdc13a7b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $50cc6ffcbdc13a7b$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($50cc6ffcbdc13a7b$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $50cc6ffcbdc13a7b$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $50cc6ffcbdc13a7b$var$createLocation("", $50cc6ffcbdc13a7b$export$fe53371bee54353d(url), null, "default");
        let matches = $50cc6ffcbdc13a7b$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$50cc6ffcbdc13a7b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $50cc6ffcbdc13a7b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $50cc6ffcbdc13a7b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $50cc6ffcbdc13a7b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($50cc6ffcbdc13a7b$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$50cc6ffcbdc13a7b$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($50cc6ffcbdc13a7b$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $50cc6ffcbdc13a7b$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $50cc6ffcbdc13a7b$var$isResponse(result) ? result : $50cc6ffcbdc13a7b$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($50cc6ffcbdc13a7b$var$isDataStrategyResult(e) && $50cc6ffcbdc13a7b$var$isResponse(e.result)) {
                if (e.type === $50cc6ffcbdc13a7b$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($50cc6ffcbdc13a7b$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $50cc6ffcbdc13a7b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $50cc6ffcbdc13a7b$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $50cc6ffcbdc13a7b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($50cc6ffcbdc13a7b$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($50cc6ffcbdc13a7b$var$isDeferredResult(result)) {
            let error = $50cc6ffcbdc13a7b$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $50cc6ffcbdc13a7b$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($50cc6ffcbdc13a7b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($50cc6ffcbdc13a7b$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $50cc6ffcbdc13a7b$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $50cc6ffcbdc13a7b$var$_extends({}, context, {
                statusCode: $50cc6ffcbdc13a7b$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $50cc6ffcbdc13a7b$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $50cc6ffcbdc13a7b$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $50cc6ffcbdc13a7b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1]) ? $50cc6ffcbdc13a7b$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $50cc6ffcbdc13a7b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $50cc6ffcbdc13a7b$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $50cc6ffcbdc13a7b$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $50cc6ffcbdc13a7b$var$callDataStrategyImpl(unstable_dataStrategy || $50cc6ffcbdc13a7b$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($50cc6ffcbdc13a7b$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $50cc6ffcbdc13a7b$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($50cc6ffcbdc13a7b$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $50cc6ffcbdc13a7b$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $50cc6ffcbdc13a7b$export$fec11da027c70692(routes, context, error) {
    let newContext = $50cc6ffcbdc13a7b$var$_extends({}, context, {
        statusCode: $50cc6ffcbdc13a7b$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $50cc6ffcbdc13a7b$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $50cc6ffcbdc13a7b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $50cc6ffcbdc13a7b$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $50cc6ffcbdc13a7b$export$cae722b0cc860f13(to ? to : ".", $50cc6ffcbdc13a7b$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $50cc6ffcbdc13a7b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$50cc6ffcbdc13a7b$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $50cc6ffcbdc13a7b$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $50cc6ffcbdc13a7b$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $50cc6ffcbdc13a7b$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$50cc6ffcbdc13a7b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$50cc6ffcbdc13a7b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $50cc6ffcbdc13a7b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $50cc6ffcbdc13a7b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $50cc6ffcbdc13a7b$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$50cc6ffcbdc13a7b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$50cc6ffcbdc13a7b$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $50cc6ffcbdc13a7b$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $50cc6ffcbdc13a7b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $50cc6ffcbdc13a7b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $50cc6ffcbdc13a7b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $50cc6ffcbdc13a7b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($50cc6ffcbdc13a7b$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $50cc6ffcbdc13a7b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $50cc6ffcbdc13a7b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $50cc6ffcbdc13a7b$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $50cc6ffcbdc13a7b$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $50cc6ffcbdc13a7b$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($50cc6ffcbdc13a7b$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $50cc6ffcbdc13a7b$var$shouldRevalidateLoader(match, $50cc6ffcbdc13a7b$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $50cc6ffcbdc13a7b$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $50cc6ffcbdc13a7b$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $50cc6ffcbdc13a7b$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $50cc6ffcbdc13a7b$var$shouldRevalidateLoader(fetcherMatch, $50cc6ffcbdc13a7b$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $50cc6ffcbdc13a7b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $50cc6ffcbdc13a7b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $50cc6ffcbdc13a7b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $50cc6ffcbdc13a7b$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $50cc6ffcbdc13a7b$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $50cc6ffcbdc13a7b$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $50cc6ffcbdc13a7b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $50cc6ffcbdc13a7b$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $50cc6ffcbdc13a7b$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $50cc6ffcbdc13a7b$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $50cc6ffcbdc13a7b$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $50cc6ffcbdc13a7b$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$50cc6ffcbdc13a7b$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $50cc6ffcbdc13a7b$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $50cc6ffcbdc13a7b$var$defaultDataStrategy(_ref6) {
    let { matches: matches } = _ref6;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $50cc6ffcbdc13a7b$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $50cc6ffcbdc13a7b$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $50cc6ffcbdc13a7b$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $50cc6ffcbdc13a7b$var$ResultType.data,
                result: undefined
            });
        };
        return $50cc6ffcbdc13a7b$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $50cc6ffcbdc13a7b$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $50cc6ffcbdc13a7b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $50cc6ffcbdc13a7b$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $50cc6ffcbdc13a7b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $50cc6ffcbdc13a7b$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $50cc6ffcbdc13a7b$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($50cc6ffcbdc13a7b$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $50cc6ffcbdc13a7b$var$ResultType.error,
                error: e
            };
        }
        if (type === $50cc6ffcbdc13a7b$var$ResultType.error) return {
            type: $50cc6ffcbdc13a7b$var$ResultType.error,
            error: new $50cc6ffcbdc13a7b$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $50cc6ffcbdc13a7b$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $50cc6ffcbdc13a7b$var$ResultType.error) {
        if ($50cc6ffcbdc13a7b$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $50cc6ffcbdc13a7b$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $50cc6ffcbdc13a7b$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $50cc6ffcbdc13a7b$var$ResultType.error,
            error: result,
            statusCode: $50cc6ffcbdc13a7b$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($50cc6ffcbdc13a7b$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $50cc6ffcbdc13a7b$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($50cc6ffcbdc13a7b$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $50cc6ffcbdc13a7b$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $50cc6ffcbdc13a7b$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $50cc6ffcbdc13a7b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $50cc6ffcbdc13a7b$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$50cc6ffcbdc13a7b$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $50cc6ffcbdc13a7b$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $50cc6ffcbdc13a7b$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($50cc6ffcbdc13a7b$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $50cc6ffcbdc13a7b$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $50cc6ffcbdc13a7b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($50cc6ffcbdc13a7b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $50cc6ffcbdc13a7b$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $50cc6ffcbdc13a7b$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $50cc6ffcbdc13a7b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $50cc6ffcbdc13a7b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $50cc6ffcbdc13a7b$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(!$50cc6ffcbdc13a7b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($50cc6ffcbdc13a7b$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $50cc6ffcbdc13a7b$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $50cc6ffcbdc13a7b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($50cc6ffcbdc13a7b$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $50cc6ffcbdc13a7b$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $50cc6ffcbdc13a7b$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($50cc6ffcbdc13a7b$var$isErrorResult(result)) {
            let boundaryMatch = $50cc6ffcbdc13a7b$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $50cc6ffcbdc13a7b$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($50cc6ffcbdc13a7b$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($50cc6ffcbdc13a7b$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $50cc6ffcbdc13a7b$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $50cc6ffcbdc13a7b$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $50cc6ffcbdc13a7b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $50cc6ffcbdc13a7b$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $50cc6ffcbdc13a7b$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $50cc6ffcbdc13a7b$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $50cc6ffcbdc13a7b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $50cc6ffcbdc13a7b$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $50cc6ffcbdc13a7b$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $50cc6ffcbdc13a7b$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $50cc6ffcbdc13a7b$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($50cc6ffcbdc13a7b$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $50cc6ffcbdc13a7b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(path) : path;
    return $50cc6ffcbdc13a7b$export$fe53371bee54353d($50cc6ffcbdc13a7b$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $50cc6ffcbdc13a7b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $50cc6ffcbdc13a7b$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $50cc6ffcbdc13a7b$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $50cc6ffcbdc13a7b$var$ResultType.data || result.type === $50cc6ffcbdc13a7b$var$ResultType.error);
}
function $50cc6ffcbdc13a7b$var$isRedirectDataStrategyResultResult(result) {
    return $50cc6ffcbdc13a7b$var$isResponse(result.result) && $50cc6ffcbdc13a7b$var$redirectStatusCodes.has(result.result.status);
}
function $50cc6ffcbdc13a7b$var$isDeferredResult(result) {
    return result.type === $50cc6ffcbdc13a7b$var$ResultType.deferred;
}
function $50cc6ffcbdc13a7b$var$isErrorResult(result) {
    return result.type === $50cc6ffcbdc13a7b$var$ResultType.error;
}
function $50cc6ffcbdc13a7b$var$isRedirectResult(result) {
    return (result && result.type) === $50cc6ffcbdc13a7b$var$ResultType.redirect;
}
function $50cc6ffcbdc13a7b$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $50cc6ffcbdc13a7b$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $50cc6ffcbdc13a7b$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $50cc6ffcbdc13a7b$var$isRedirectResponse(result) {
    if (!$50cc6ffcbdc13a7b$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $50cc6ffcbdc13a7b$var$isValidMethod(method) {
    return $50cc6ffcbdc13a7b$var$validRequestMethods.has(method.toLowerCase());
}
function $50cc6ffcbdc13a7b$var$isMutationMethod(method) {
    return $50cc6ffcbdc13a7b$var$validMutationMethods.has(method.toLowerCase());
}
async function $50cc6ffcbdc13a7b$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$50cc6ffcbdc13a7b$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($50cc6ffcbdc13a7b$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $50cc6ffcbdc13a7b$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $50cc6ffcbdc13a7b$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($50cc6ffcbdc13a7b$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $50cc6ffcbdc13a7b$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $50cc6ffcbdc13a7b$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $50cc6ffcbdc13a7b$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $50cc6ffcbdc13a7b$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $50cc6ffcbdc13a7b$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $50cc6ffcbdc13a7b$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $50cc6ffcbdc13a7b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $50cc6ffcbdc13a7b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $50cc6ffcbdc13a7b$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $50cc6ffcbdc13a7b$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $50cc6ffcbdc13a7b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $50cc6ffcbdc13a7b$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $50cc6ffcbdc13a7b$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $50cc6ffcbdc13a7b$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $50cc6ffcbdc13a7b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $50cc6ffcbdc13a7b$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $50cc6ffcbdc13a7b$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($50cc6ffcbdc13a7b$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $50cc6ffcbdc13a7b$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($50cc6ffcbdc13a7b$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $50cc6ffcbdc13a7b$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aqdBs = parcelRequire("aqdBs");

function $3e7e4c969b7540c8$var$_extends() {
    $3e7e4c969b7540c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e7e4c969b7540c8$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $3e7e4c969b7540c8$export$3add0d5dce533e2e = /*#__PURE__*/ $aqdBs.createContext(null);
const $3e7e4c969b7540c8$export$145dfa71566a64dc = /*#__PURE__*/ $aqdBs.createContext(null);
const $3e7e4c969b7540c8$var$AwaitContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $3e7e4c969b7540c8$export$26749e8557646306 = /*#__PURE__*/ $aqdBs.createContext(null);
const $3e7e4c969b7540c8$export$c7914228fb69b0f5 = /*#__PURE__*/ $aqdBs.createContext(null);
const $3e7e4c969b7540c8$export$9072aa6dd1f93057 = /*#__PURE__*/ $aqdBs.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $3e7e4c969b7540c8$var$RouteErrorContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $3e7e4c969b7540c8$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$3e7e4c969b7540c8$export$9c954a9d03d32f4a() && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $aqdBs.useContext($3e7e4c969b7540c8$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $3e7e4c969b7540c8$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $50cc6ffcbdc13a7b$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $3e7e4c969b7540c8$export$9c954a9d03d32f4a() {
    return $aqdBs.useContext($3e7e4c969b7540c8$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $3e7e4c969b7540c8$export$45d76561a5302f2b() {
    !$3e7e4c969b7540c8$export$9c954a9d03d32f4a() && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    return $aqdBs.useContext($3e7e4c969b7540c8$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $3e7e4c969b7540c8$export$1b3f31771c5d07c() {
    return $aqdBs.useContext($3e7e4c969b7540c8$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $3e7e4c969b7540c8$export$6c330e8992e8a295(pattern) {
    !$3e7e4c969b7540c8$export$9c954a9d03d32f4a() && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $3e7e4c969b7540c8$export$45d76561a5302f2b();
    return $aqdBs.useMemo(()=>(0, $50cc6ffcbdc13a7b$export$81336c211d5ff295)(pattern, (0, $50cc6ffcbdc13a7b$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $3e7e4c969b7540c8$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $3e7e4c969b7540c8$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aqdBs.useContext($3e7e4c969b7540c8$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $aqdBs.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $3e7e4c969b7540c8$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $3e7e4c969b7540c8$var$useNavigateStable() : $3e7e4c969b7540c8$var$useNavigateUnstable();
}
function $3e7e4c969b7540c8$var$useNavigateUnstable() {
    !$3e7e4c969b7540c8$export$9c954a9d03d32f4a() && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    let dataRouterContext = $aqdBs.useContext($3e7e4c969b7540c8$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $aqdBs.useContext($3e7e4c969b7540c8$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3e7e4c969b7540c8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $50cc6ffcbdc13a7b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $aqdBs.useRef(false);
    $3e7e4c969b7540c8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $50cc6ffcbdc13a7b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $50cc6ffcbdc13a7b$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $3e7e4c969b7540c8$var$OutletContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $3e7e4c969b7540c8$export$4138103a3ae699cc() {
    return $aqdBs.useContext($3e7e4c969b7540c8$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $3e7e4c969b7540c8$export$a3be3530d8e40d0b(context) {
    let outlet = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $3e7e4c969b7540c8$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $3e7e4c969b7540c8$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $aqdBs.useContext($3e7e4c969b7540c8$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3e7e4c969b7540c8$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $50cc6ffcbdc13a7b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $aqdBs.useMemo(()=>(0, $50cc6ffcbdc13a7b$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $3e7e4c969b7540c8$export$5d3fca4a98652595(routes, locationArg) {
    return $3e7e4c969b7540c8$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $3e7e4c969b7540c8$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$3e7e4c969b7540c8$export$9c954a9d03d32f4a() && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $aqdBs.useContext($3e7e4c969b7540c8$export$26749e8557646306);
    let { matches: parentMatches } = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $3e7e4c969b7540c8$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $50cc6ffcbdc13a7b$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $3e7e4c969b7540c8$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $50cc6ffcbdc13a7b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $50cc6ffcbdc13a7b$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $3e7e4c969b7540c8$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $3e7e4c969b7540c8$var$DefaultErrorComponent() {
    let error = $3e7e4c969b7540c8$export$ed527bf60f6e05f2();
    let message = (0, $50cc6ffcbdc13a7b$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $aqdBs.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $aqdBs.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $3e7e4c969b7540c8$var$defaultErrorElement = /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$DefaultErrorComponent, null);
class $3e7e4c969b7540c8$var$RenderErrorBoundary extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $3e7e4c969b7540c8$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $aqdBs.useContext($3e7e4c969b7540c8$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $3e7e4c969b7540c8$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $3e7e4c969b7540c8$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $3e7e4c969b7540c8$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $aqdBs.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $3e7e4c969b7540c8$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($3e7e4c969b7540c8$var$DataRouterHook || {});
var $3e7e4c969b7540c8$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($3e7e4c969b7540c8$var$DataRouterStateHook || {});
function $3e7e4c969b7540c8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $3e7e4c969b7540c8$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext($3e7e4c969b7540c8$export$3add0d5dce533e2e);
    !ctx && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $3e7e4c969b7540c8$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext($3e7e4c969b7540c8$export$145dfa71566a64dc);
    !state && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    return state;
}
function $3e7e4c969b7540c8$var$useRouteContext(hookName) {
    let route = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057);
    !route && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $3e7e4c969b7540c8$var$useCurrentRouteId(hookName) {
    let route = $3e7e4c969b7540c8$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $3e7e4c969b7540c8$export$5fc8298006ad9e58() {
    return $3e7e4c969b7540c8$var$useCurrentRouteId($3e7e4c969b7540c8$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $3e7e4c969b7540c8$export$d0fd4b7106de2769() {
    let state = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $3e7e4c969b7540c8$export$600dc272ed516c15() {
    let dataRouterContext = $3e7e4c969b7540c8$var$useDataRouterContext($3e7e4c969b7540c8$var$DataRouterHook.UseRevalidator);
    let state = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseRevalidator);
    return $aqdBs.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $3e7e4c969b7540c8$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseMatches);
    return $aqdBs.useMemo(()=>matches.map((m)=>(0, $50cc6ffcbdc13a7b$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $3e7e4c969b7540c8$export$1448a5050d252c4d() {
    let state = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseLoaderData);
    let routeId = $3e7e4c969b7540c8$var$useCurrentRouteId($3e7e4c969b7540c8$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $3e7e4c969b7540c8$export$fd5d37484eab868d(routeId) {
    let state = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $3e7e4c969b7540c8$export$fdc00f3f26066d5e() {
    let state = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseActionData);
    let routeId = $3e7e4c969b7540c8$var$useCurrentRouteId($3e7e4c969b7540c8$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $3e7e4c969b7540c8$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $aqdBs.useContext($3e7e4c969b7540c8$var$RouteErrorContext);
    let state = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseRouteError);
    let routeId = $3e7e4c969b7540c8$var$useCurrentRouteId($3e7e4c969b7540c8$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $3e7e4c969b7540c8$export$78a72ddb39bdd145() {
    let value = $aqdBs.useContext($3e7e4c969b7540c8$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $3e7e4c969b7540c8$export$17f53340677d5831() {
    let value = $aqdBs.useContext($3e7e4c969b7540c8$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $3e7e4c969b7540c8$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $3e7e4c969b7540c8$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $3e7e4c969b7540c8$var$useDataRouterContext($3e7e4c969b7540c8$var$DataRouterHook.UseBlocker);
    let state = $3e7e4c969b7540c8$var$useDataRouterState($3e7e4c969b7540c8$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $aqdBs.useState("");
    let blockerFunction = $aqdBs.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $3e7e4c969b7540c8$var$_extends({}, currentLocation, {
                pathname: (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $3e7e4c969b7540c8$var$_extends({}, nextLocation, {
                pathname: (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $aqdBs.useEffect(()=>{
        let key = String(++$3e7e4c969b7540c8$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $aqdBs.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $50cc6ffcbdc13a7b$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $3e7e4c969b7540c8$var$useNavigateStable() {
    let { router: router } = $3e7e4c969b7540c8$var$useDataRouterContext($3e7e4c969b7540c8$var$DataRouterHook.UseNavigateStable);
    let id = $3e7e4c969b7540c8$var$useCurrentRouteId($3e7e4c969b7540c8$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $aqdBs.useRef(false);
    $3e7e4c969b7540c8$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $3e7e4c969b7540c8$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $3e7e4c969b7540c8$var$alreadyWarned = {};
function $3e7e4c969b7540c8$var$warningOnce(key, cond, message) {
    if (!cond && !$3e7e4c969b7540c8$var$alreadyWarned[key]) $3e7e4c969b7540c8$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $3e7e4c969b7540c8$var$START_TRANSITION = "startTransition";
const $3e7e4c969b7540c8$var$startTransitionImpl = $aqdBs[$3e7e4c969b7540c8$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $3e7e4c969b7540c8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aqdBs.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        if (v7_startTransition && $3e7e4c969b7540c8$var$startTransitionImpl) $3e7e4c969b7540c8$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $aqdBs.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $3e7e4c969b7540c8$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $3e7e4c969b7540c8$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $3e7e4c969b7540c8$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $50cc6ffcbdc13a7b$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $3e7e4c969b7540c8$var$startTransitionImpl ? $3e7e4c969b7540c8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $3e7e4c969b7540c8$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$3e7e4c969b7540c8$export$9c954a9d03d32f4a() && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $aqdBs.useContext($3e7e4c969b7540c8$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($3e7e4c969b7540c8$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $3e7e4c969b7540c8$export$45d76561a5302f2b();
    let navigate = $3e7e4c969b7540c8$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $50cc6ffcbdc13a7b$export$cae722b0cc860f13)(to, (0, $50cc6ffcbdc13a7b$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aqdBs.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $3e7e4c969b7540c8$export$910ae8079b2c2852(props) {
    return $3e7e4c969b7540c8$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $3e7e4c969b7540c8$export$e7b0ac011bb776c6(_props) {
    (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $3e7e4c969b7540c8$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $50cc6ffcbdc13a7b$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$3e7e4c969b7540c8$export$9c954a9d03d32f4a() && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aqdBs.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $3e7e4c969b7540c8$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $50cc6ffcbdc13a7b$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aqdBs.useMemo(()=>{
        let trailingPathname = (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $3e7e4c969b7540c8$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $3e7e4c969b7540c8$export$5d3fca4a98652595($3e7e4c969b7540c8$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $3e7e4c969b7540c8$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$ResolveAwait, null, children));
}
var $3e7e4c969b7540c8$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($3e7e4c969b7540c8$var$AwaitRenderStatus || {});
const $3e7e4c969b7540c8$var$neverSettledPromise = new Promise(()=>{});
class $3e7e4c969b7540c8$var$AwaitErrorBoundary extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $3e7e4c969b7540c8$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $3e7e4c969b7540c8$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $3e7e4c969b7540c8$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $3e7e4c969b7540c8$var$AwaitRenderStatus.error : "_data" in promise ? $3e7e4c969b7540c8$var$AwaitRenderStatus.success : $3e7e4c969b7540c8$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $3e7e4c969b7540c8$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $3e7e4c969b7540c8$var$AwaitRenderStatus.error && promise._error instanceof (0, $50cc6ffcbdc13a7b$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $3e7e4c969b7540c8$var$neverSettledPromise;
        if (status === $3e7e4c969b7540c8$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $3e7e4c969b7540c8$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $3e7e4c969b7540c8$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $aqdBs.createElement($3e7e4c969b7540c8$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $3e7e4c969b7540c8$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $3e7e4c969b7540c8$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $3e7e4c969b7540c8$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $aqdBs.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $aqdBs.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aqdBs.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $3e7e4c969b7540c8$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $3e7e4c969b7540c8$export$e7b0ac011bb776c6) && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $3e7e4c969b7540c8$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $3e7e4c969b7540c8$export$daf73786167a7f72(matches) {
    return $3e7e4c969b7540c8$var$_renderMatches(matches);
}
function $3e7e4c969b7540c8$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $aqdBs.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $aqdBs.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $aqdBs.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $3e7e4c969b7540c8$export$f30f7e456d254e83(routes, opts) {
    return (0, $50cc6ffcbdc13a7b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3e7e4c969b7540c8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $50cc6ffcbdc13a7b$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $3e7e4c969b7540c8$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}



function $3ad25f07d94ec634$var$_extends() {
    $3ad25f07d94ec634$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ad25f07d94ec634$var$_extends.apply(this, arguments);
}
function $3ad25f07d94ec634$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $3ad25f07d94ec634$var$defaultMethod = "get";
const $3ad25f07d94ec634$var$defaultEncType = "application/x-www-form-urlencoded";
function $3ad25f07d94ec634$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $3ad25f07d94ec634$var$isButtonElement(object) {
    return $3ad25f07d94ec634$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $3ad25f07d94ec634$var$isFormElement(object) {
    return $3ad25f07d94ec634$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $3ad25f07d94ec634$var$isInputElement(object) {
    return $3ad25f07d94ec634$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $3ad25f07d94ec634$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $3ad25f07d94ec634$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$3ad25f07d94ec634$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $3ad25f07d94ec634$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $3ad25f07d94ec634$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $3ad25f07d94ec634$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $3ad25f07d94ec634$var$_formDataSupportsSubmitter = null;
function $3ad25f07d94ec634$var$isFormDataSubmitterSupported() {
    if ($3ad25f07d94ec634$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $3ad25f07d94ec634$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $3ad25f07d94ec634$var$_formDataSupportsSubmitter = true;
    }
    return $3ad25f07d94ec634$var$_formDataSupportsSubmitter;
}
const $3ad25f07d94ec634$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $3ad25f07d94ec634$var$getFormEncType(encType) {
    if (encType != null && !$3ad25f07d94ec634$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $3ad25f07d94ec634$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($3ad25f07d94ec634$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $3ad25f07d94ec634$var$defaultMethod;
        encType = $3ad25f07d94ec634$var$getFormEncType(target.getAttribute("enctype")) || $3ad25f07d94ec634$var$defaultEncType;
        formData = new FormData(target);
    } else if ($3ad25f07d94ec634$var$isButtonElement(target) || $3ad25f07d94ec634$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $3ad25f07d94ec634$var$defaultMethod;
        encType = $3ad25f07d94ec634$var$getFormEncType(target.getAttribute("formenctype")) || $3ad25f07d94ec634$var$getFormEncType(form.getAttribute("enctype")) || $3ad25f07d94ec634$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$3ad25f07d94ec634$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($3ad25f07d94ec634$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $3ad25f07d94ec634$var$defaultMethod;
        action = null;
        encType = $3ad25f07d94ec634$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $3ad25f07d94ec634$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $3ad25f07d94ec634$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $3ad25f07d94ec634$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $3ad25f07d94ec634$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $3ad25f07d94ec634$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $3ad25f07d94ec634$export$1f3f55432a00e06d(routes, opts) {
    return (0, $50cc6ffcbdc13a7b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3ad25f07d94ec634$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $50cc6ffcbdc13a7b$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $3ad25f07d94ec634$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3e7e4c969b7540c8$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $3ad25f07d94ec634$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $50cc6ffcbdc13a7b$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3ad25f07d94ec634$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $50cc6ffcbdc13a7b$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $3ad25f07d94ec634$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3e7e4c969b7540c8$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $3ad25f07d94ec634$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $3ad25f07d94ec634$var$_extends({}, state, {
        errors: $3ad25f07d94ec634$var$deserializeErrors(state.errors)
    });
    return state;
}
function $3ad25f07d94ec634$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $50cc6ffcbdc13a7b$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $3ad25f07d94ec634$export$7ad602f0e94e62d1 = /*#__PURE__*/ $aqdBs.createContext({
    isTransitioning: false
});
const $3ad25f07d94ec634$export$148fd98d095596d4 = /*#__PURE__*/ $aqdBs.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $3ad25f07d94ec634$var$START_TRANSITION = "startTransition";
const $3ad25f07d94ec634$var$startTransitionImpl = $aqdBs[$3ad25f07d94ec634$var$START_TRANSITION];
const $3ad25f07d94ec634$var$FLUSH_SYNC = "flushSync";
const $3ad25f07d94ec634$var$flushSyncImpl = $e813d4480671d45c$exports[$3ad25f07d94ec634$var$FLUSH_SYNC];
const $3ad25f07d94ec634$var$USE_ID = "useId";
const $3ad25f07d94ec634$var$useIdImpl = $aqdBs[$3ad25f07d94ec634$var$USE_ID];
function $3ad25f07d94ec634$var$startTransitionSafe(cb) {
    if ($3ad25f07d94ec634$var$startTransitionImpl) $3ad25f07d94ec634$var$startTransitionImpl(cb);
    else cb();
}
function $3ad25f07d94ec634$var$flushSyncSafe(cb) {
    if ($3ad25f07d94ec634$var$flushSyncImpl) $3ad25f07d94ec634$var$flushSyncImpl(cb);
    else cb();
}
class $3ad25f07d94ec634$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $3ad25f07d94ec634$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aqdBs.useState(router.state);
    let [pendingState, setPendingState] = $aqdBs.useState();
    let [vtContext, setVtContext] = $aqdBs.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $aqdBs.useState();
    let [transition, setTransition] = $aqdBs.useState();
    let [interruption, setInterruption] = $aqdBs.useState();
    let fetcherData = $aqdBs.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $aqdBs.useCallback((cb)=>{
        if (v7_startTransition) $3ad25f07d94ec634$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $aqdBs.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $3ad25f07d94ec634$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $3ad25f07d94ec634$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $3ad25f07d94ec634$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $3ad25f07d94ec634$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $3ad25f07d94ec634$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $aqdBs.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $3ad25f07d94ec634$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $aqdBs.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $aqdBs.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $aqdBs.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement((0, $3e7e4c969b7540c8$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $3e7e4c969b7540c8$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $aqdBs.createElement($3ad25f07d94ec634$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $aqdBs.createElement($3ad25f07d94ec634$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $3e7e4c969b7540c8$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aqdBs.createElement($3ad25f07d94ec634$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $3ad25f07d94ec634$var$MemoizedDataRoutes = /*#__PURE__*/ $aqdBs.memo($3ad25f07d94ec634$var$DataRoutes);
function $3ad25f07d94ec634$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $3e7e4c969b7540c8$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $3ad25f07d94ec634$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $50cc6ffcbdc13a7b$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $3ad25f07d94ec634$var$startTransitionImpl ? $3ad25f07d94ec634$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $3e7e4c969b7540c8$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $3ad25f07d94ec634$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $50cc6ffcbdc13a7b$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $3ad25f07d94ec634$var$startTransitionImpl ? $3ad25f07d94ec634$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $3e7e4c969b7540c8$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $3ad25f07d94ec634$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $3ad25f07d94ec634$var$startTransitionImpl ? $3ad25f07d94ec634$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $3e7e4c969b7540c8$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $3ad25f07d94ec634$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $3ad25f07d94ec634$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $3ad25f07d94ec634$export$a6c7ac8248d6e38a = /*#__PURE__*/ $aqdBs.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $3ad25f07d94ec634$var$_objectWithoutPropertiesLoose(_ref7, $3ad25f07d94ec634$var$_excluded);
    let { basename: basename } = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $3ad25f07d94ec634$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($3ad25f07d94ec634$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $3e7e4c969b7540c8$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $3ad25f07d94ec634$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $aqdBs.createElement("a", $3ad25f07d94ec634$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $3ad25f07d94ec634$export$b0d92dbee9b5b60d = /*#__PURE__*/ $aqdBs.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $3ad25f07d94ec634$var$_objectWithoutPropertiesLoose(_ref8, $3ad25f07d94ec634$var$_excluded2);
    let path = (0, $3e7e4c969b7540c8$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $3e7e4c969b7540c8$export$45d76561a5302f2b)();
    let routerState = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3ad25f07d94ec634$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $aqdBs.createElement($3ad25f07d94ec634$export$a6c7ac8248d6e38a, $3ad25f07d94ec634$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $3ad25f07d94ec634$export$a7fed597f4b8afd8 = /*#__PURE__*/ $aqdBs.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $3ad25f07d94ec634$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $3ad25f07d94ec634$var$_objectWithoutPropertiesLoose(_ref9, $3ad25f07d94ec634$var$_excluded3);
    let submit = $3ad25f07d94ec634$export$47c85c6e3a081d3();
    let formAction = $3ad25f07d94ec634$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $aqdBs.createElement("form", $3ad25f07d94ec634$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $3ad25f07d94ec634$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $3ad25f07d94ec634$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $3ad25f07d94ec634$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($3ad25f07d94ec634$var$DataRouterHook || ($3ad25f07d94ec634$var$DataRouterHook = {}));
var $3ad25f07d94ec634$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($3ad25f07d94ec634$var$DataRouterStateHook || ($3ad25f07d94ec634$var$DataRouterStateHook = {}));
// Internal hooks
function $3ad25f07d94ec634$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $3ad25f07d94ec634$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$3add0d5dce533e2e));
    !ctx && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    return ctx;
}
function $3ad25f07d94ec634$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$145dfa71566a64dc));
    !state && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $3ad25f07d94ec634$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $3e7e4c969b7540c8$export$9770f232ac06a008)();
    let location = (0, $3e7e4c969b7540c8$export$45d76561a5302f2b)();
    let path = (0, $3e7e4c969b7540c8$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $aqdBs.useCallback((event)=>{
        if ($3ad25f07d94ec634$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $50cc6ffcbdc13a7b$export$fe53371bee54353d)(location) === (0, $50cc6ffcbdc13a7b$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $3ad25f07d94ec634$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $aqdBs.useRef($3ad25f07d94ec634$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aqdBs.useRef(false);
    let location = (0, $3e7e4c969b7540c8$export$45d76561a5302f2b)();
    let searchParams = $aqdBs.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $3ad25f07d94ec634$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $3e7e4c969b7540c8$export$9770f232ac06a008)();
    let setSearchParams = $aqdBs.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $3ad25f07d94ec634$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $3ad25f07d94ec634$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $3ad25f07d94ec634$var$fetcherId = 0;
let $3ad25f07d94ec634$var$getUniqueFetcherId = ()=>"__" + String(++$3ad25f07d94ec634$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $3ad25f07d94ec634$export$47c85c6e3a081d3() {
    let { router: router } = $3ad25f07d94ec634$var$useDataRouterContext($3ad25f07d94ec634$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$26749e8557646306));
    let currentRouteId = (0, $3e7e4c969b7540c8$export$5fc8298006ad9e58)();
    return $aqdBs.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $3ad25f07d94ec634$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $3ad25f07d94ec634$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $3ad25f07d94ec634$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $3ad25f07d94ec634$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$26749e8557646306));
    let routeContext = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$9072aa6dd1f93057));
    !routeContext && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $3ad25f07d94ec634$var$_extends({}, (0, $3e7e4c969b7540c8$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $3e7e4c969b7540c8$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $50cc6ffcbdc13a7b$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $50cc6ffcbdc13a7b$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $3ad25f07d94ec634$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $3ad25f07d94ec634$var$useDataRouterContext($3ad25f07d94ec634$var$DataRouterHook.UseFetcher);
    let state = $3ad25f07d94ec634$var$useDataRouterState($3ad25f07d94ec634$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $aqdBs.useContext($3ad25f07d94ec634$export$148fd98d095596d4);
    let route = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    !route && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $3ad25f07d94ec634$var$useIdImpl ? $3ad25f07d94ec634$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $aqdBs.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($3ad25f07d94ec634$var$getUniqueFetcherId());
    // Registration/cleanup
    $aqdBs.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $aqdBs.useCallback((href, opts)=>{
        !routeId && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $3ad25f07d94ec634$export$47c85c6e3a081d3();
    let submit = $aqdBs.useCallback((target, opts)=>{
        submitImpl(target, $3ad25f07d94ec634$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $aqdBs.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $aqdBs.createElement($3ad25f07d94ec634$export$a7fed597f4b8afd8, $3ad25f07d94ec634$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $50cc6ffcbdc13a7b$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $aqdBs.useMemo(()=>$3ad25f07d94ec634$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $3ad25f07d94ec634$export$fa996778a3a31087() {
    let state = $3ad25f07d94ec634$var$useDataRouterState($3ad25f07d94ec634$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $3ad25f07d94ec634$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $3ad25f07d94ec634$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $3ad25f07d94ec634$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $3ad25f07d94ec634$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $3ad25f07d94ec634$var$useDataRouterContext($3ad25f07d94ec634$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $3ad25f07d94ec634$var$useDataRouterState($3ad25f07d94ec634$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $aqdBs.useContext((0, $3e7e4c969b7540c8$export$26749e8557646306));
    let location = (0, $3e7e4c969b7540c8$export$45d76561a5302f2b)();
    let matches = (0, $3e7e4c969b7540c8$export$2378eb7f5ff86053)();
    let navigation = (0, $3e7e4c969b7540c8$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $aqdBs.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $3ad25f07d94ec634$var$usePageHide($aqdBs.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $3ad25f07d94ec634$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $3ad25f07d94ec634$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($3ad25f07d94ec634$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $3ad25f07d94ec634$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $3ad25f07d94ec634$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($3ad25f07d94ec634$var$_extends({}, location, {
                    pathname: (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($3ad25f07d94ec634$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $3ad25f07d94ec634$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $3ad25f07d94ec634$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $3ad25f07d94ec634$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $3e7e4c969b7540c8$export$b273b3273281a049)(when);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $3ad25f07d94ec634$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $aqdBs.useContext($3ad25f07d94ec634$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $50cc6ffcbdc13a7b$export$3e9cee6b33872309)(false);
    let { basename: basename } = $3ad25f07d94ec634$var$useDataRouterContext($3ad25f07d94ec634$var$DataRouterHook.useViewTransitionState);
    let path = (0, $3e7e4c969b7540c8$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $50cc6ffcbdc13a7b$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $50cc6ffcbdc13a7b$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $50cc6ffcbdc13a7b$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
/**
 * @public
 */ const $e2cb17888fa727a9$export$22a697fb29aac98d = (0, $aqdBs.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $aqdBs = parcelRequire("aqdBs");
const $44e456049c8ede2e$export$2285bbca2c666415 = (0, $aqdBs.createContext)({});



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
/**
 * @public
 */ const $ec2595e9e9997037$export$f224e4635b6f8ce2 = (0, $aqdBs.createContext)(null);




var $aqdBs = parcelRequire("aqdBs");
const $201dce3b0ffc9438$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $d0769678dab3d9d0$export$700979bc83e7db82 = (0, $201dce3b0ffc9438$export$4e09c449d6c407f7) ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect);



var $aqdBs = parcelRequire("aqdBs");
const $a2b41b17b284da8d$export$40f10139ecf1f171 = (0, $aqdBs.createContext)({
    strict: false
});



/**
 * Convert camelCase to dash-case properties.
 */ const $121800c2821ef5f8$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $bc90b91dc291ba84$export$ed7b8fa9dbf0105d = "framerAppearId";
const $bc90b91dc291ba84$export$8592e1c077c890a6 = "data-" + (0, $121800c2821ef5f8$export$9fd24a634729c672)($bc90b91dc291ba84$export$ed7b8fa9dbf0105d);


const $0e2650f5a5001016$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


function $ab4e5c4a95b68d47$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $b33fc83f827fa690$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $b33fc83f827fa690$var$maxElapsed = 40;
function $b33fc83f827fa690$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $b33fc83f827fa690$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $ab4e5c4a95b68d47$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $0e2650f5a5001016$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $b33fc83f827fa690$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $b33fc83f827fa690$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $b33fc83f827fa690$export$71ecace0a033b35a.length; i++)steps[$b33fc83f827fa690$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $8f61580f0f073a44$export$bb76eed83315504c, cancel: $8f61580f0f073a44$export$3252729004b8456e } = (0, $b33fc83f827fa690$export$510b0596a933801a)(queueMicrotask, false);


function $27725de4af5e1030$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $aqdBs = parcelRequire("aqdBs");
/**
 * Internal, exported only for usage in Framer
 */ const $d0a9e5cdbd928545$export$da5f7b802957459a = (0, $aqdBs.createContext)({});


let $ebdf8d8b85bdf65a$var$scheduleHandoffComplete = false;
function $ebdf8d8b85bdf65a$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a;
    const { visualElement: parent } = (0, $aqdBs.useContext)((0, $44e456049c8ede2e$export$2285bbca2c666415));
    const lazyContext = (0, $aqdBs.useContext)((0, $a2b41b17b284da8d$export$40f10139ecf1f171));
    const presenceContext = (0, $aqdBs.useContext)((0, $ec2595e9e9997037$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $aqdBs.useContext)((0, $e2cb17888fa727a9$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $aqdBs.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $aqdBs.useContext)((0, $d0a9e5cdbd928545$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $ebdf8d8b85bdf65a$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $aqdBs.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $bc90b91dc291ba84$export$8592e1c077c890a6];
    const wantsHandoff = (0, $aqdBs.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete && ((_a = window.MotionHasOptimisedAnimation) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)));
    (0, $d0769678dab3d9d0$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $8f61580f0f073a44$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $aqdBs.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        wantsHandoff.current = false;
        // This ensures all future calls to animateChanges() will run in useEffect
        if (!$ebdf8d8b85bdf65a$var$scheduleHandoffComplete) {
            $ebdf8d8b85bdf65a$var$scheduleHandoffComplete = true;
            queueMicrotask($ebdf8d8b85bdf65a$var$completeHandoff);
        }
    });
    return visualElement;
}
function $ebdf8d8b85bdf65a$var$completeHandoff() {
    window.MotionHandoffIsComplete = true;
}
function $ebdf8d8b85bdf65a$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $ebdf8d8b85bdf65a$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $27725de4af5e1030$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $ebdf8d8b85bdf65a$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $ebdf8d8b85bdf65a$var$getClosestProjectingNode(visualElement.parent);
}



var $aqdBs = parcelRequire("aqdBs");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $b9fbb85af4aa3ca8$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $aqdBs.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $27725de4af5e1030$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $aqdBs = parcelRequire("aqdBs");

/**
 * Decides if the supplied variable is variant label
 */ function $4b6a123e70fc63fa$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $f427edcc6ef3d862$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $82d627d5aca8db85$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $82d627d5aca8db85$export$1405a65085f40b9 = [
    "initial",
    ...$82d627d5aca8db85$export$16e45afcc206d3a8
];


function $0f71c5f58aee6d21$export$4b3c3bd8d910d78d(props) {
    return (0, $f427edcc6ef3d862$export$aa71198ceeaf53ce)(props.animate) || (0, $82d627d5aca8db85$export$1405a65085f40b9).some((name)=>(0, $4b6a123e70fc63fa$export$720b90e312cea233)(props[name]));
}
function $0f71c5f58aee6d21$export$ce46fa4165cdec40(props) {
    return Boolean($0f71c5f58aee6d21$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $bb6fa6e79c38d4ba$export$12fc32fc096a04a3(props, context) {
    if ((0, $0f71c5f58aee6d21$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $4b6a123e70fc63fa$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $4b6a123e70fc63fa$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $1383c74c56cbcf74$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $bb6fa6e79c38d4ba$export$12fc32fc096a04a3)(props, (0, $aqdBs.useContext)((0, $44e456049c8ede2e$export$2285bbca2c666415)));
    return (0, $aqdBs.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $1383c74c56cbcf74$var$variantLabelsAsDependency(initial),
        $1383c74c56cbcf74$var$variantLabelsAsDependency(animate)
    ]);
}
function $1383c74c56cbcf74$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $fb7b4da6dbbf0981$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $fb7b4da6dbbf0981$export$65570e08d843624d = {};
for(const key in $fb7b4da6dbbf0981$var$featureProps)$fb7b4da6dbbf0981$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$fb7b4da6dbbf0981$var$featureProps[key].some((name)=>!!props[name])
};


function $d278bd26e931efeb$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $fb7b4da6dbbf0981$export$65570e08d843624d)[key] = {
        ...(0, $fb7b4da6dbbf0981$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $aqdBs = parcelRequire("aqdBs");
const $29b76a43c78cea20$export$a3579ca508007a95 = (0, $aqdBs.createContext)({});



const $8630fd1467570f77$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $8df54ac2a962c382$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $d278bd26e931efeb$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $aqdBs.useContext)((0, $e2cb17888fa727a9$export$22a697fb29aac98d)),
            ...props,
            layoutId: $8df54ac2a962c382$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $1383c74c56cbcf74$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $201dce3b0ffc9438$export$4e09c449d6c407f7)) {
            $8df54ac2a962c382$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $8df54ac2a962c382$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $ebdf8d8b85bdf65a$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $14024a6d51999040$exports.jsxs)((0, $44e456049c8ede2e$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $14024a6d51999040$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $b9fbb85af4aa3ca8$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $aqdBs.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $8630fd1467570f77$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $8df54ac2a962c382$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $aqdBs.useContext)((0, $29b76a43c78cea20$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $8df54ac2a962c382$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $aqdBs.useContext)((0, $a2b41b17b284da8d$export$40f10139ecf1f171)).strict;
}
function $8df54ac2a962c382$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $fb7b4da6dbbf0981$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $4db221893ad49f6d$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $8df54ac2a962c382$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $0d5ab0c984c05635$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ab69ffa832b458c8$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $0d5ab0c984c05635$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
const $cf22175a737a0f8a$export$91ddd985b97788d1 = {};
function $cf22175a737a0f8a$export$de9e7791c71225fd(correctors) {
    Object.assign($cf22175a737a0f8a$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $032a8b903b1240cf$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $032a8b903b1240cf$export$7b42a0094fb00b6e = new Set($032a8b903b1240cf$export$280dc01950909d86);


function $159ecac2e04f40ca$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $cf22175a737a0f8a$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $b174766382de4d58$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $cec9fbcd2dc93458$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $e76a06b177a0d943$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $e76a06b177a0d943$export$58f0f39f63f3cf42 = {
    ...$e76a06b177a0d943$export$98e628dec113755e,
    transform: (v)=>(0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $e76a06b177a0d943$export$dcdf75081b88279d = {
    ...$e76a06b177a0d943$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $45a926b5c317cbaa$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $45a926b5c317cbaa$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $45a926b5c317cbaa$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $45a926b5c317cbaa$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $45a926b5c317cbaa$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $45a926b5c317cbaa$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $03dbaa7517065106$var$createUnitType = (unit)=>({
        test: (v)=>(0, $45a926b5c317cbaa$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $03dbaa7517065106$export$41fc368e1a942b97 = $03dbaa7517065106$var$createUnitType("deg");
const $03dbaa7517065106$export$626336c2cd4b14de = $03dbaa7517065106$var$createUnitType("%");
const $03dbaa7517065106$export$91c0eda1d06bf008 = $03dbaa7517065106$var$createUnitType("px");
const $03dbaa7517065106$export$f91e8c45a95a32f2 = $03dbaa7517065106$var$createUnitType("vh");
const $03dbaa7517065106$export$aed3d7b7d206c196 = $03dbaa7517065106$var$createUnitType("vw");
const $03dbaa7517065106$export$44e2e1705876d7ed = {
    ...$03dbaa7517065106$export$626336c2cd4b14de,
    parse: (v)=>$03dbaa7517065106$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$03dbaa7517065106$export$626336c2cd4b14de.transform(v * 100)
};



const $f0c3e29d566684f9$export$7d260a2a5f8bc19e = {
    ...(0, $e76a06b177a0d943$export$98e628dec113755e),
    transform: Math.round
};


const $a0ba10b28aae969f$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderTopWidth: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderRightWidth: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderRadius: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    radius: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    maxWidth: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    height: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    maxHeight: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    size: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    top: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    right: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    bottom: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    left: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    paddingTop: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    paddingRight: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    paddingBottom: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    paddingLeft: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    margin: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    marginTop: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    marginRight: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    marginBottom: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    marginLeft: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $03dbaa7517065106$export$41fc368e1a942b97),
    rotateX: (0, $03dbaa7517065106$export$41fc368e1a942b97),
    rotateY: (0, $03dbaa7517065106$export$41fc368e1a942b97),
    rotateZ: (0, $03dbaa7517065106$export$41fc368e1a942b97),
    scale: $e76a06b177a0d943$export$dcdf75081b88279d,
    scaleX: (0, $e76a06b177a0d943$export$dcdf75081b88279d),
    scaleY: (0, $e76a06b177a0d943$export$dcdf75081b88279d),
    scaleZ: (0, $e76a06b177a0d943$export$dcdf75081b88279d),
    skew: (0, $03dbaa7517065106$export$41fc368e1a942b97),
    skewX: (0, $03dbaa7517065106$export$41fc368e1a942b97),
    skewY: (0, $03dbaa7517065106$export$41fc368e1a942b97),
    distance: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    translateX: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    translateY: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    translateZ: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    x: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    y: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    z: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    perspective: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    transformPerspective: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    opacity: (0, $e76a06b177a0d943$export$58f0f39f63f3cf42),
    originX: (0, $03dbaa7517065106$export$44e2e1705876d7ed),
    originY: (0, $03dbaa7517065106$export$44e2e1705876d7ed),
    originZ: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $f0c3e29d566684f9$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $e76a06b177a0d943$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $e76a06b177a0d943$export$58f0f39f63f3cf42),
    numOctaves: (0, $f0c3e29d566684f9$export$7d260a2a5f8bc19e)
};


const $8750846890082179$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $8750846890082179$var$numTransforms = (0, $032a8b903b1240cf$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $8750846890082179$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $8750846890082179$var$numTransforms; i++){
        const key = (0, $032a8b903b1240cf$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $cec9fbcd2dc93458$export$453ef540a9a1bd6b)(value, (0, $a0ba10b28aae969f$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $8750846890082179$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


const $fc7f1298786c2ca0$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $fc7f1298786c2ca0$export$9de1236619d9e756 = $fc7f1298786c2ca0$var$checkStringStartsWith("--");
const $fc7f1298786c2ca0$var$startsAsVariableToken = $fc7f1298786c2ca0$var$checkStringStartsWith("var(--");
const $fc7f1298786c2ca0$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $fc7f1298786c2ca0$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $fc7f1298786c2ca0$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $fc7f1298786c2ca0$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;





function $bb944cc56ea095cf$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $fc7f1298786c2ca0$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $cec9fbcd2dc93458$export$453ef540a9a1bd6b)(value, (0, $a0ba10b28aae969f$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $8750846890082179$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $fb6ef7af63d353a1$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $510af842c8f2ec1f$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $b174766382de4d58$export$605d60a2578142d3)(source[key]) && !(0, $159ecac2e04f40ca$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $510af842c8f2ec1f$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $aqdBs.useMemo)(()=>{
        const state = (0, $fb6ef7af63d353a1$export$8940b483cf52eeda)();
        (0, $bb944cc56ea095cf$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $510af842c8f2ec1f$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $510af842c8f2ec1f$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $510af842c8f2ec1f$var$useInitialMotionValues(props, visualState));
    return style;
}
function $510af842c8f2ec1f$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $510af842c8f2ec1f$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $6839f14b9f8b31c4$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $6839f14b9f8b31c4$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $6839f14b9f8b31c4$var$validMotionProps.has(key);
}


let $5eeef9002bb73ab8$var$shouldForward = (key)=>!(0, $6839f14b9f8b31c4$export$2f9c46555243bf04)(key);
function $5eeef9002bb73ab8$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $5eeef9002bb73ab8$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $6839f14b9f8b31c4$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $5eeef9002bb73ab8$export$59d6962c470509a5($5eeef9002bb73ab8$import$b503ab8daee337ee$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $5eeef9002bb73ab8$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($5eeef9002bb73ab8$var$shouldForward(key) || forwardMotionProps === true && (0, $6839f14b9f8b31c4$export$2f9c46555243bf04)(key) || !isDom && !(0, $6839f14b9f8b31c4$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $aqdBs = parcelRequire("aqdBs");



function $014b657677bd968f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $03dbaa7517065106$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $014b657677bd968f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $014b657677bd968f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $014b657677bd968f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $e782936d804eab61$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $e782936d804eab61$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $e782936d804eab61$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $e782936d804eab61$var$dashKeys : $e782936d804eab61$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $03dbaa7517065106$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $03dbaa7517065106$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $03dbaa7517065106$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $dc9b5a4ef8e0098e$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $bb944cc56ea095cf$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $014b657677bd968f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $e782936d804eab61$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $bb67abfd302f3fb7$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $fb6ef7af63d353a1$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $2fa760979a79cd54$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $d1553c07ec478b8e$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $aqdBs.useMemo)(()=>{
        const state = (0, $bb67abfd302f3fb7$export$41be8b43e1c4d4f9)();
        (0, $dc9b5a4ef8e0098e$export$5475d24f125d7053)(state, visualState, (0, $2fa760979a79cd54$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $510af842c8f2ec1f$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $9e4c7d3b9975b9cc$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ab69ffa832b458c8$export$88f3fc2fd3766989)(Component) ? (0, $d1553c07ec478b8e$export$84309c4f53cb1bd5) : (0, $510af842c8f2ec1f$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $5eeef9002bb73ab8$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $aqdBs.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $aqdBs.useMemo)(()=>(0, $b174766382de4d58$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $aqdBs.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}



function $790745892039e685$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $fe0d5c55833ee0a7$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $594e41917d2e7fd4$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $790745892039e685$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $fe0d5c55833ee0a7$export$28931db5d57958e5).has(key) ? (0, $121800c2821ef5f8$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $5483e8e2203edd76$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $b174766382de4d58$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $b174766382de4d58$export$605d60a2578142d3)(prevProps.style[key]) || (0, $159ecac2e04f40ca$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}



function $00d5dc0c9386a00b$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $5483e8e2203edd76$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $b174766382de4d58$export$605d60a2578142d3)(props[key]) || (0, $b174766382de4d58$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $032a8b903b1240cf$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $aqdBs = parcelRequire("aqdBs");


function $a3af003fe383772a$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $a3af003fe383772a$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $a3af003fe383772a$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $a3af003fe383772a$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}



var $aqdBs = parcelRequire("aqdBs");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $ca8730202900f961$export$fe4300aa8eebea86(init) {
    const ref = (0, $aqdBs.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $dd9796e9348b1a5d$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $17182e68fda22ffe$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $17182e68fda22ffe$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $dd9796e9348b1a5d$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $d54487322d67fb88$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $b174766382de4d58$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $17182e68fda22ffe$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $f10cdca7d77c81ea$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);




function $25fb24a8bf2dfd8a$export$b3f9dd865b560c6(name) {
    if ((0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(name)) return "transform";
    else if ((0, $f10cdca7d77c81ea$export$a27eefbd8fb5e404).has(name)) return (0, $121800c2821ef5f8$export$9fd24a634729c672)(name);
}


function $c3a87dadbcad932c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $c3a87dadbcad932c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $c3a87dadbcad932c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


function $5b536b77454f9bed$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $5b536b77454f9bed$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5b536b77454f9bed$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $aqdBs.useContext)((0, $44e456049c8ede2e$export$2285bbca2c666415));
        const presenceContext = (0, $aqdBs.useContext)((0, $ec2595e9e9997037$export$f224e4635b6f8ce2));
        const make = ()=>$5b536b77454f9bed$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $ca8730202900f961$export$fe4300aa8eebea86)(make);
    };
function $5b536b77454f9bed$var$addWillChange(willChange, name) {
    const memberName = (0, $25fb24a8bf2dfd8a$export$b3f9dd865b560c6)(name);
    if (memberName) (0, $c3a87dadbcad932c$export$20e507e47fae79fd)(willChange, memberName);
}
function $5b536b77454f9bed$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $a3af003fe383772a$export$d68f140c4d9b48bc)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            callback(target, transitionEnd);
        }
    }
}
function $5b536b77454f9bed$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $d54487322d67fb88$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $0f71c5f58aee6d21$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $0f71c5f58aee6d21$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $f427edcc6ef3d862$export$aa71198ceeaf53ce)(variantToSet)) $5b536b77454f9bed$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $f427edcc6ef3d862$export$aa71198ceeaf53ce)(animate)) $5b536b77454f9bed$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$5b536b77454f9bed$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}





const $bdd2758ba14e7fc4$export$8793edee2d425525 = (any)=>any;



const { schedule: $da858f109646e9e4$export$2cef06c20297c17d, cancel: $da858f109646e9e4$export$ec99c0ef4978dccb, state: $da858f109646e9e4$export$fff89137e9e818ce, steps: $da858f109646e9e4$export$be3f796aed065412 } = (0, $b33fc83f827fa690$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $bdd2758ba14e7fc4$export$8793edee2d425525), true);


const $a71401f345c7184a$export$44dabd3fae512e85 = {
    useVisualState: (0, $5b536b77454f9bed$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $00d5dc0c9386a00b$export$16da615486abaa45),
        createRenderState: (0, $bb67abfd302f3fb7$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $da858f109646e9e4$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $da858f109646e9e4$export$2cef06c20297c17d).render(()=>{
                (0, $dc9b5a4ef8e0098e$export$5475d24f125d7053)(renderState, latestValues, (0, $2fa760979a79cd54$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $594e41917d2e7fd4$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $3f2e411e8413e198$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5b536b77454f9bed$export$e91e107bc6d03a8e)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $5483e8e2203edd76$export$16da615486abaa45,
        createRenderState: (0, $fb6ef7af63d353a1$export$8940b483cf52eeda)
    })
};


function $b80137b18c8ab85b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $ab69ffa832b458c8$export$88f3fc2fd3766989)(Component) ? (0, $a71401f345c7184a$export$44dabd3fae512e85) : (0, $3f2e411e8413e198$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $9e4c7d3b9975b9cc$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $30b07f782189bf37$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $fdeda1b56b432c34$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $c3e261b53a099ead$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $c3e261b53a099ead$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $fdeda1b56b432c34$export$a4cf9c8a4b063a6e)(event) && handler(event, $c3e261b53a099ead$export$12f84bb882d06e1a(event));
};


function $a0729997323e3766$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $30b07f782189bf37$export$b1d829ddf82884aa)(target, eventName, (0, $c3e261b53a099ead$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $9852e6ab6dd2ac4e$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $9852e6ab6dd2ac4e$export$a4627e546088548d = (...transformers)=>transformers.reduce($9852e6ab6dd2ac4e$var$combineFunctions);


function $5e28bec1081f60a1$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $5e28bec1081f60a1$var$globalHorizontalLock = $5e28bec1081f60a1$export$518c5fc2dcb7974b("dragHorizontal");
const $5e28bec1081f60a1$var$globalVerticalLock = $5e28bec1081f60a1$export$518c5fc2dcb7974b("dragVertical");
function $5e28bec1081f60a1$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $5e28bec1081f60a1$var$globalVerticalLock();
    else if (drag === "x") lock = $5e28bec1081f60a1$var$globalHorizontalLock();
    else {
        const openHorizontal = $5e28bec1081f60a1$var$globalHorizontalLock();
        const openVertical = $5e28bec1081f60a1$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $5e28bec1081f60a1$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $5e28bec1081f60a1$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $c3848bb710a5005b$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}



function $2fdd66825c8ffbf2$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $5e28bec1081f60a1$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $a0729997323e3766$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $2fdd66825c8ffbf2$export$93a81ea037eac456 extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)($2fdd66825c8ffbf2$var$addHoverEvent(this.node, true), $2fdd66825c8ffbf2$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $861ef145a580d0fb$export$d4826db40d47595b extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)((0, $30b07f782189bf37$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $30b07f782189bf37$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $7ddcdc5a9d62e5ce$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $7ddcdc5a9d62e5ce$export$e841ada32ff745b(parent, child.parentElement);
};




function $6a4e39b4424f1605$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $c3e261b53a099ead$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $6a4e39b4424f1605$export$f026abdbba7f0c9e extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
        this.removeEndListeners = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $7ddcdc5a9d62e5ce$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $da858f109646e9e4$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $a0729997323e3766$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $a0729997323e3766$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $6a4e39b4424f1605$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $30b07f782189bf37$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $6a4e39b4424f1605$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $30b07f782189bf37$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $6a4e39b4424f1605$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $30b07f782189bf37$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $5e28bec1081f60a1$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $a0729997323e3766$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $30b07f782189bf37$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $da1441c733967140$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $da1441c733967140$var$observers = new WeakMap();
const $da1441c733967140$var$fireObserverCallback = (entry)=>{
    const callback = $da1441c733967140$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $da1441c733967140$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($da1441c733967140$var$fireObserverCallback);
};
function $da1441c733967140$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$da1441c733967140$var$observers.has(lookupRoot)) $da1441c733967140$var$observers.set(lookupRoot, {});
    const rootObservers = $da1441c733967140$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($da1441c733967140$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $da1441c733967140$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $da1441c733967140$var$initIntersectionObserver(options);
    $da1441c733967140$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $da1441c733967140$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $bdaee53ee531d945$var$thresholdNames = {
    some: 0,
    all: 1
};
class $bdaee53ee531d945$export$150851c8cc2f0c72 extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $bdaee53ee531d945$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $da1441c733967140$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($bdaee53ee531d945$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $bdaee53ee531d945$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $73324faa6a2e8a7c$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $bdaee53ee531d945$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $6a4e39b4424f1605$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $861ef145a580d0fb$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $2fdd66825c8ffbf2$export$93a81ea037eac456)
    }
};





function $23b5db3145517195$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




function $98638e388064355b$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $a3af003fe383772a$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}





/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $15fb6145a9c5f30b$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $68999112eeb6910d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $68999112eeb6910d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $68999112eeb6910d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $68999112eeb6910d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $68999112eeb6910d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $68999112eeb6910d$var$keyframesTransition;
    else if ((0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $68999112eeb6910d$var$criticallyDampedSpring(keyframes[1]) : $68999112eeb6910d$var$underDampedSpring;
    return $68999112eeb6910d$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $22d0d7d15a4390a5$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $22d0d7d15a4390a5$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $c0a901977371eb7f$export$888a3d84909f9e3d = {
    current: false
};


const $bcb1fcceb380e4cd$var$isNotNull = (value)=>value !== null;
function $bcb1fcceb380e4cd$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($bcb1fcceb380e4cd$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $327614556bc46d16$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $976ae35349721fdd$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $327614556bc46d16$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $f63b64e92c2a19e4$export$491112666e282270 = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
let $f63b64e92c2a19e4$export$f5708dca728d7177 = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
var $f63b64e92c2a19e4$var$check, $f63b64e92c2a19e4$var$message, $f63b64e92c2a19e4$var$check1, $f63b64e92c2a19e4$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $b9f09cf5c3b837af$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $8326cd58c4ad92d1$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $8326cd58c4ad92d1$export$b9f0c1f373aee2b0(current) {
    const match = $8326cd58c4ad92d1$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $8326cd58c4ad92d1$var$maxDepth = 4;
function $8326cd58c4ad92d1$export$289398774300c991(current, element, depth = 1) {
    (0, $f63b64e92c2a19e4$export$f5708dca728d7177)(depth <= $8326cd58c4ad92d1$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $8326cd58c4ad92d1$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $b9f09cf5c3b837af$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $fc7f1298786c2ca0$export$31f9caa2600b5723)(fallback) ? $8326cd58c4ad92d1$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






const $407c46538feafc2a$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $407c46538feafc2a$export$8e5250d1aa9bf370 = (v)=>v === (0, $e76a06b177a0d943$export$98e628dec113755e) || v === (0, $03dbaa7517065106$export$91c0eda1d06bf008);
const $407c46538feafc2a$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $407c46538feafc2a$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $407c46538feafc2a$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $407c46538feafc2a$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $407c46538feafc2a$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $407c46538feafc2a$var$nonTranslationalTransformKeys = (0, $032a8b903b1240cf$export$280dc01950909d86).filter((key)=>!$407c46538feafc2a$var$transformKeys.has(key));
function $407c46538feafc2a$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $407c46538feafc2a$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $407c46538feafc2a$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $407c46538feafc2a$var$getTranslateFromMatrix(4, 13),
    y: $407c46538feafc2a$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$407c46538feafc2a$export$781d46a8aa670d52.translateX = $407c46538feafc2a$export$781d46a8aa670d52.x;
$407c46538feafc2a$export$781d46a8aa670d52.translateY = $407c46538feafc2a$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $2ba8617457534c99$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $f6a4e07b462cdc08$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a951967510396e1e$export$d176691c1998a1f5 = [
    (0, $e76a06b177a0d943$export$98e628dec113755e),
    (0, $03dbaa7517065106$export$91c0eda1d06bf008),
    (0, $03dbaa7517065106$export$626336c2cd4b14de),
    (0, $03dbaa7517065106$export$41fc368e1a942b97),
    (0, $03dbaa7517065106$export$aed3d7b7d206c196),
    (0, $03dbaa7517065106$export$f91e8c45a95a32f2),
    (0, $f6a4e07b462cdc08$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a951967510396e1e$export$eefdd52e3ccae428 = (v)=>$a951967510396e1e$export$d176691c1998a1f5.find((0, $2ba8617457534c99$export$6eae4d0a6a7ca7cd)(v));




const $2121b659d6ab5da6$var$toResolve = new Set();
let $2121b659d6ab5da6$var$isScheduled = false;
let $2121b659d6ab5da6$var$anyNeedsMeasurement = false;
function $2121b659d6ab5da6$var$measureAllKeyframes() {
    if ($2121b659d6ab5da6$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($2121b659d6ab5da6$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $407c46538feafc2a$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $2121b659d6ab5da6$var$anyNeedsMeasurement = false;
    $2121b659d6ab5da6$var$isScheduled = false;
    $2121b659d6ab5da6$var$toResolve.forEach((resolver)=>resolver.complete());
    $2121b659d6ab5da6$var$toResolve.clear();
}
function $2121b659d6ab5da6$var$readAllKeyframes() {
    $2121b659d6ab5da6$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $2121b659d6ab5da6$var$anyNeedsMeasurement = true;
    });
}
function $2121b659d6ab5da6$export$78b96d2a12593b05() {
    $2121b659d6ab5da6$var$readAllKeyframes();
    $2121b659d6ab5da6$var$measureAllKeyframes();
}
class $2121b659d6ab5da6$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $2121b659d6ab5da6$var$toResolve.add(this);
            if (!$2121b659d6ab5da6$var$isScheduled) {
                $2121b659d6ab5da6$var$isScheduled = true;
                (0, $da858f109646e9e4$export$2cef06c20297c17d).read($2121b659d6ab5da6$var$readAllKeyframes);
                (0, $da858f109646e9e4$export$2cef06c20297c17d).resolveKeyframes($2121b659d6ab5da6$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $2121b659d6ab5da6$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $2121b659d6ab5da6$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $f87921611c27a62c$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $45a926b5c317cbaa$export$844ec244b1367d54)(v) && (0, $45a926b5c317cbaa$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $45a926b5c317cbaa$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $f87921611c27a62c$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $45a926b5c317cbaa$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $45a926b5c317cbaa$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $30b6e14756589b29$var$clampRgbUnit = (v)=>(0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)(0, 255, v);
const $30b6e14756589b29$export$7a99c86b5b1f4c9e = {
    ...(0, $e76a06b177a0d943$export$98e628dec113755e),
    transform: (v)=>Math.round($30b6e14756589b29$var$clampRgbUnit(v))
};
const $30b6e14756589b29$export$4e46ac54fc82cf3b = {
    test: (0, $f87921611c27a62c$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $f87921611c27a62c$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $30b6e14756589b29$export$7a99c86b5b1f4c9e.transform(red) + ", " + $30b6e14756589b29$export$7a99c86b5b1f4c9e.transform(green) + ", " + $30b6e14756589b29$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $45a926b5c317cbaa$export$83d2e9e3e4ee39ed)((0, $e76a06b177a0d943$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $227c440256f84bc8$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $227c440256f84bc8$export$834dfc94dde4b3d8 = {
    test: (0, $f87921611c27a62c$export$2c8400d58aca05e)("#"),
    parse: $227c440256f84bc8$var$parseHex,
    transform: (0, $30b6e14756589b29$export$4e46ac54fc82cf3b).transform
};






const $2c87437c20eb7980$export$810b04175080204c = {
    test: (0, $f87921611c27a62c$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $f87921611c27a62c$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $03dbaa7517065106$export$626336c2cd4b14de).transform((0, $45a926b5c317cbaa$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $03dbaa7517065106$export$626336c2cd4b14de).transform((0, $45a926b5c317cbaa$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $45a926b5c317cbaa$export$83d2e9e3e4ee39ed)((0, $e76a06b177a0d943$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $adaeaefd70ded231$export$35e9368ef982300f = {
    test: (v)=>(0, $30b6e14756589b29$export$4e46ac54fc82cf3b).test(v) || (0, $227c440256f84bc8$export$834dfc94dde4b3d8).test(v) || (0, $2c87437c20eb7980$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $30b6e14756589b29$export$4e46ac54fc82cf3b).test(v)) return (0, $30b6e14756589b29$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $2c87437c20eb7980$export$810b04175080204c).test(v)) return (0, $2c87437c20eb7980$export$810b04175080204c).parse(v);
        else return (0, $227c440256f84bc8$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $45a926b5c317cbaa$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $30b6e14756589b29$export$4e46ac54fc82cf3b).transform(v) : (0, $2c87437c20eb7980$export$810b04175080204c).transform(v);
    }
};



function $7384eba00d1ce525$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $45a926b5c317cbaa$export$844ec244b1367d54)(v) && (((_a = v.match((0, $45a926b5c317cbaa$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $45a926b5c317cbaa$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $7384eba00d1ce525$var$NUMBER_TOKEN = "number";
const $7384eba00d1ce525$var$COLOR_TOKEN = "color";
const $7384eba00d1ce525$var$VAR_TOKEN = "var";
const $7384eba00d1ce525$var$VAR_FUNCTION_TOKEN = "var(";
const $7384eba00d1ce525$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $7384eba00d1ce525$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $7384eba00d1ce525$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($7384eba00d1ce525$var$complexRegex, (parsedValue)=>{
        if ((0, $adaeaefd70ded231$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($7384eba00d1ce525$var$COLOR_TOKEN);
            values.push((0, $adaeaefd70ded231$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($7384eba00d1ce525$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($7384eba00d1ce525$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($7384eba00d1ce525$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $7384eba00d1ce525$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($7384eba00d1ce525$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $7384eba00d1ce525$var$parseComplexValue(v) {
    return $7384eba00d1ce525$export$b61fc7c44bf646d5(v).values;
}
function $7384eba00d1ce525$var$createTransformer(source) {
    const { split: split, types: types } = $7384eba00d1ce525$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $7384eba00d1ce525$var$NUMBER_TOKEN) output += (0, $45a926b5c317cbaa$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $7384eba00d1ce525$var$COLOR_TOKEN) output += (0, $adaeaefd70ded231$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $7384eba00d1ce525$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $7384eba00d1ce525$var$getAnimatableNone(v) {
    const parsed = $7384eba00d1ce525$var$parseComplexValue(v);
    const transformer = $7384eba00d1ce525$var$createTransformer(v);
    return transformer(parsed.map($7384eba00d1ce525$var$convertNumbersToZero));
}
const $7384eba00d1ce525$export$83a0e34f1302825b = {
    test: $7384eba00d1ce525$var$test,
    parse: $7384eba00d1ce525$var$parseComplexValue,
    createTransformer: $7384eba00d1ce525$var$createTransformer,
    getAnimatableNone: $7384eba00d1ce525$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $593cf11e0c4f332b$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $593cf11e0c4f332b$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $45a926b5c317cbaa$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $593cf11e0c4f332b$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $593cf11e0c4f332b$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $593cf11e0c4f332b$export$3dea766d36a8935f = {
    ...(0, $7384eba00d1ce525$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($593cf11e0c4f332b$var$functionRegex);
        return functions ? functions.map($593cf11e0c4f332b$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $94410fa53221ef8d$export$98cd7c72c5a731fb = {
    ...(0, $a0ba10b28aae969f$export$eec14432cd1cb67b),
    color: // Color props
    $adaeaefd70ded231$export$35e9368ef982300f,
    backgroundColor: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    outlineColor: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    fill: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    stroke: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    borderTopColor: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    borderRightColor: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    borderBottomColor: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    borderLeftColor: (0, $adaeaefd70ded231$export$35e9368ef982300f),
    filter: $593cf11e0c4f332b$export$3dea766d36a8935f,
    WebkitFilter: (0, $593cf11e0c4f332b$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $94410fa53221ef8d$export$67d1babe0338d23b = (key)=>$94410fa53221ef8d$export$98cd7c72c5a731fb[key];


function $5d6b90ee59d1f7cf$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $94410fa53221ef8d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $593cf11e0c4f332b$export$3dea766d36a8935f)) defaultValueType = (0, $7384eba00d1ce525$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $48f959c7d1376da9$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $48f959c7d1376da9$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$48f959c7d1376da9$var$invalidTemplates.has(keyframe) && (0, $7384eba00d1ce525$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $5d6b90ee59d1f7cf$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $f42804f83f4371ca$export$4983792d11b61017 extends (0, $2121b659d6ab5da6$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $fc7f1298786c2ca0$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $8326cd58c4ad92d1$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $407c46538feafc2a$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $a951967510396e1e$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $a951967510396e1e$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $407c46538feafc2a$export$8e5250d1aa9bf370)(originType) && (0, $407c46538feafc2a$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $976ae35349721fdd$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $48f959c7d1376da9$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $407c46538feafc2a$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $407c46538feafc2a$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $9298b904c72c4cad$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}






let $5c713de314b44f1b$var$now;
function $5c713de314b44f1b$var$clearTime() {
    $5c713de314b44f1b$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $5c713de314b44f1b$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($5c713de314b44f1b$var$now === undefined) $5c713de314b44f1b$export$2da9be4cfdb689b1.set((0, $da858f109646e9e4$export$fff89137e9e818ce).isProcessing || (0, $0e2650f5a5001016$export$dd826089e3c5e502).useManualTiming ? (0, $da858f109646e9e4$export$fff89137e9e818ce).timestamp : performance.now());
        return $5c713de314b44f1b$var$now;
    },
    set: (newTime)=>{
        $5c713de314b44f1b$var$now = newTime;
        queueMicrotask($5c713de314b44f1b$var$clearTime);
    }
};






/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $f133b344f3f2d847$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $7384eba00d1ce525$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $164d5673dc1f29ec$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $164d5673dc1f29ec$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $f133b344f3f2d847$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $f133b344f3f2d847$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $f63b64e92c2a19e4$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $164d5673dc1f29ec$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $f4943dd7aa3faf9e$var$MAX_RESOLVE_DELAY = 40;
class $f4943dd7aa3faf9e$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $f4943dd7aa3faf9e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $2121b659d6ab5da6$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $164d5673dc1f29ec$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $c0a901977371eb7f$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $bcb1fcceb380e4cd$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $9de9549c4845cd3c$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $a6c5ca0b30ef9415$var$velocitySampleDuration = 5; // ms
function $a6c5ca0b30ef9415$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $a6c5ca0b30ef9415$var$velocitySampleDuration, 0);
    return (0, $9de9549c4845cd3c$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $c2fc24981e543ddc$var$safeMin = 0.001;
const $c2fc24981e543ddc$export$a3cdb76e84ee608e = 0.01;
const $c2fc24981e543ddc$export$1824b851fad8862b = 10.0;
const $c2fc24981e543ddc$export$ff08f2d53484465 = 0.05;
const $c2fc24981e543ddc$export$201ca48e54038115 = 1;
function $c2fc24981e543ddc$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $f63b64e92c2a19e4$export$491112666e282270)(duration <= (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)($c2fc24981e543ddc$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)($c2fc24981e543ddc$export$ff08f2d53484465, $c2fc24981e543ddc$export$201ca48e54038115, dampingRatio);
    duration = (0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)($c2fc24981e543ddc$export$a3cdb76e84ee608e, $c2fc24981e543ddc$export$1824b851fad8862b, (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $c2fc24981e543ddc$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $c2fc24981e543ddc$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $c2fc24981e543ddc$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $c2fc24981e543ddc$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$c2fc24981e543ddc$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $c2fc24981e543ddc$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $c2fc24981e543ddc$var$rootIterations = 12;
function $c2fc24981e543ddc$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $c2fc24981e543ddc$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $c2fc24981e543ddc$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $7d9ca378215563bc$var$durationKeys = [
    "duration",
    "bounce"
];
const $7d9ca378215563bc$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $7d9ca378215563bc$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $7d9ca378215563bc$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$7d9ca378215563bc$var$isSpringType(options, $7d9ca378215563bc$var$physicsKeys) && $7d9ca378215563bc$var$isSpringType(options, $7d9ca378215563bc$var$durationKeys)) {
        const derived = (0, $c2fc24981e543ddc$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $7d9ca378215563bc$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $7d9ca378215563bc$var$getSpringOptions({
        ...options,
        velocity: -(0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $c2fc24981e543ddc$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $a6c5ca0b30ef9415$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $2434c20052e7cc5f$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $7d9ca378215563bc$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $a6c5ca0b30ef9415$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $47dfdeb9246f63ae$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $47dfdeb9246f63ae$var$subdivisionPrecision = 0.0000001;
const $47dfdeb9246f63ae$var$subdivisionMaxIterations = 12;
function $47dfdeb9246f63ae$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $47dfdeb9246f63ae$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $47dfdeb9246f63ae$var$subdivisionPrecision && ++i < $47dfdeb9246f63ae$var$subdivisionMaxIterations);
    return currentT;
}
function $47dfdeb9246f63ae$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $bdd2758ba14e7fc4$export$8793edee2d425525;
    const getTForX = (aX)=>$47dfdeb9246f63ae$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $47dfdeb9246f63ae$var$calcBezier(getTForX(t), mY1, mY2);
}


const $d0685ea365226ef6$export$929e5a82286172a6 = (0, $47dfdeb9246f63ae$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $d0685ea365226ef6$export$57636bb43b1ccbb0 = (0, $47dfdeb9246f63ae$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $d0685ea365226ef6$export$c07234257a03d5e9 = (0, $47dfdeb9246f63ae$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $7107b4f2ca988271$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $9753b003a1565f58$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $c46ee0620437c1dd$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $09ebde36bc2d9b19$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $09ebde36bc2d9b19$export$c8d67a19199d1a50 = (0, $c46ee0620437c1dd$export$2c07eeff45156d4d)($09ebde36bc2d9b19$export$e444123e42d03385);
const $09ebde36bc2d9b19$export$30d3455eee55bed5 = (0, $9753b003a1565f58$export$f946554fb8aeaf0d)($09ebde36bc2d9b19$export$e444123e42d03385);





const $e1821210fc6f9680$export$77edfce482316a60 = (0, $47dfdeb9246f63ae$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $e1821210fc6f9680$export$b01116c84cdfe1a2 = (0, $c46ee0620437c1dd$export$2c07eeff45156d4d)($e1821210fc6f9680$export$77edfce482316a60);
const $e1821210fc6f9680$export$ddc5fd596f6c71b2 = (0, $9753b003a1565f58$export$f946554fb8aeaf0d)($e1821210fc6f9680$export$b01116c84cdfe1a2);



const $fc48efa3e8630936$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $e1821210fc6f9680$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $1f5bf0f1ba4d6681$var$easingLookup = {
    linear: (0, $bdd2758ba14e7fc4$export$8793edee2d425525),
    easeIn: $d0685ea365226ef6$export$929e5a82286172a6,
    easeInOut: $d0685ea365226ef6$export$c07234257a03d5e9,
    easeOut: $d0685ea365226ef6$export$57636bb43b1ccbb0,
    circIn: $09ebde36bc2d9b19$export$e444123e42d03385,
    circInOut: $09ebde36bc2d9b19$export$30d3455eee55bed5,
    circOut: $09ebde36bc2d9b19$export$c8d67a19199d1a50,
    backIn: $e1821210fc6f9680$export$b01116c84cdfe1a2,
    backInOut: $e1821210fc6f9680$export$ddc5fd596f6c71b2,
    backOut: $e1821210fc6f9680$export$77edfce482316a60,
    anticipate: $fc48efa3e8630936$export$6b0af63b873d419e
};
const $1f5bf0f1ba4d6681$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $f63b64e92c2a19e4$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $47dfdeb9246f63ae$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $f63b64e92c2a19e4$export$f5708dca728d7177)($1f5bf0f1ba4d6681$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $1f5bf0f1ba4d6681$var$easingLookup[definition];
    }
    return definition;
};





/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $b49335144235184c$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $41f7600f89d72ce6$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $8ced9b03ba8d5c21$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $8ced9b03ba8d5c21$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $8ced9b03ba8d5c21$var$hueToRgb(p, q, hue + 1 / 3);
        green = $8ced9b03ba8d5c21$var$hueToRgb(p, q, hue);
        blue = $8ced9b03ba8d5c21$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $007691fac1129cbe$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $4f55fa5c8ac7c8bd$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $4f55fa5c8ac7c8bd$var$colorTypes = [
    (0, $227c440256f84bc8$export$834dfc94dde4b3d8),
    (0, $30b6e14756589b29$export$4e46ac54fc82cf3b),
    (0, $2c87437c20eb7980$export$810b04175080204c)
];
const $4f55fa5c8ac7c8bd$var$getColorType = (v)=>$4f55fa5c8ac7c8bd$var$colorTypes.find((type)=>type.test(v));
function $4f55fa5c8ac7c8bd$var$asRGBA(color) {
    const type = $4f55fa5c8ac7c8bd$var$getColorType(color);
    (0, $f63b64e92c2a19e4$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $2c87437c20eb7980$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $8ced9b03ba8d5c21$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $4f55fa5c8ac7c8bd$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $4f55fa5c8ac7c8bd$var$asRGBA(from);
    const toRGBA = $4f55fa5c8ac7c8bd$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $007691fac1129cbe$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $4f55fa5c8ac7c8bd$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $4f55fa5c8ac7c8bd$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $4f55fa5c8ac7c8bd$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $30b6e14756589b29$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $e42e6f3702bfa69b$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $e42e6f3702bfa69b$export$fed62ccc3fb1a568(origin, target) {
    if ($e42e6f3702bfa69b$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $02711c9c616fb93e$var$mixNumber(a, b) {
    return (p)=>(0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $02711c9c616fb93e$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $02711c9c616fb93e$var$mixNumber;
    else if (typeof a === "string") return (0, $fc7f1298786c2ca0$export$31f9caa2600b5723)(a) ? (0, $007691fac1129cbe$export$a6f92d4bae65c0f1) : (0, $adaeaefd70ded231$export$35e9368ef982300f).test(a) ? (0, $4f55fa5c8ac7c8bd$export$51e568cf5c039bac) : $02711c9c616fb93e$export$65516310a87d8205;
    else if (Array.isArray(a)) return $02711c9c616fb93e$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $adaeaefd70ded231$export$35e9368ef982300f).test(a) ? (0, $4f55fa5c8ac7c8bd$export$51e568cf5c039bac) : $02711c9c616fb93e$export$ebc23b6840c51ba1;
    return 0, $007691fac1129cbe$export$a6f92d4bae65c0f1;
}
function $02711c9c616fb93e$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$02711c9c616fb93e$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $02711c9c616fb93e$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $02711c9c616fb93e$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $02711c9c616fb93e$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $02711c9c616fb93e$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $7384eba00d1ce525$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $7384eba00d1ce525$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $7384eba00d1ce525$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $e42e6f3702bfa69b$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $e42e6f3702bfa69b$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $e42e6f3702bfa69b$export$fed62ccc3fb1a568)(origin, target);
        return (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)($02711c9c616fb93e$export$3bbefa2f402845c4($02711c9c616fb93e$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $f63b64e92c2a19e4$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $007691fac1129cbe$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $c38a8be149aee355$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $02711c9c616fb93e$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $7018d6d776bead1f$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $c38a8be149aee355$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $bdd2758ba14e7fc4$export$8793edee2d425525) : ease;
            mixer = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $7018d6d776bead1f$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $f63b64e92c2a19e4$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $7018d6d776bead1f$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $b49335144235184c$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $80782e3d6e5b7594$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $b49335144235184c$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $f30f36ddcfc10368$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $80782e3d6e5b7594$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $7418bc3e390a95a8$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $49d5dfa74ba3c7df$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $d0685ea365226ef6$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $49d5dfa74ba3c7df$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $7107b4f2ca988271$export$216948827bbdc797)(ease) ? ease.map((0, $1f5bf0f1ba4d6681$export$ef97fe084f156ca4)) : (0, $1f5bf0f1ba4d6681$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $7418bc3e390a95a8$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $f30f36ddcfc10368$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $7018d6d776bead1f$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $49d5dfa74ba3c7df$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $d1fb78a87bc7274c$export$f4ff70a5b4808fd8 = 20000;
function $d1fb78a87bc7274c$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $d1fb78a87bc7274c$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $d1fb78a87bc7274c$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $76891b8254a8f6ca$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $da858f109646e9e4$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $da858f109646e9e4$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $da858f109646e9e4$export$fff89137e9e818ce).isProcessing ? (0, $da858f109646e9e4$export$fff89137e9e818ce).timestamp : (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now()
    };
};



const $35655f18d178520c$var$generators = {
    decay: (0, $2434c20052e7cc5f$export$ee3ff3a17106998),
    inertia: $2434c20052e7cc5f$export$ee3ff3a17106998,
    tween: (0, $49d5dfa74ba3c7df$export$d25ddfdf17c3ad3e),
    keyframes: (0, $49d5dfa74ba3c7df$export$d25ddfdf17c3ad3e),
    spring: $7d9ca378215563bc$export$b36281d89752ae66
};
const $35655f18d178520c$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $35655f18d178520c$export$fd98d9cca67a58bc extends (0, $f4943dd7aa3faf9e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $2121b659d6ab5da6$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $35655f18d178520c$var$generators[type] || (0, $49d5dfa74ba3c7df$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $49d5dfa74ba3c7df$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)($35655f18d178520c$var$percentToProgress, (0, $c38a8be149aee355$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $d1fb78a87bc7274c$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $bcb1fcceb380e4cd$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $76891b8254a8f6ca$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $35655f18d178520c$export$ee9b76de7353d815(options) {
    return new $35655f18d178520c$export$fd98d9cca67a58bc(options);
}



const $556a7974d064071a$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $9999866ac98b8edd$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $9999866ac98b8edd$export$2cf569f5e2221176 || (0, $556a7974d064071a$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($9999866ac98b8edd$export$fcdd8f3f2160beda));
}
const $9999866ac98b8edd$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $9999866ac98b8edd$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $9999866ac98b8edd$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $9999866ac98b8edd$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $9999866ac98b8edd$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $9999866ac98b8edd$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $9999866ac98b8edd$var$mapEasingToNativeEasingWithDefault(easing) {
    return $9999866ac98b8edd$export$916ea73bcd3a6030(easing) || $9999866ac98b8edd$export$2cf569f5e2221176.easeOut;
}
function $9999866ac98b8edd$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $556a7974d064071a$export$ff43f99925d7366b)(easing)) return $9999866ac98b8edd$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($9999866ac98b8edd$var$mapEasingToNativeEasingWithDefault);
    else return $9999866ac98b8edd$export$2cf569f5e2221176[easing];
}


function $b6864579ea2deeda$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $9999866ac98b8edd$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $3082ec01c2ccc277$var$supportsWaapi = (0, $9298b904c72c4cad$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $3082ec01c2ccc277$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $3082ec01c2ccc277$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $3082ec01c2ccc277$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $9999866ac98b8edd$export$fcdd8f3f2160beda)(options.ease);
}
function $3082ec01c2ccc277$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $35655f18d178520c$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $3082ec01c2ccc277$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $3082ec01c2ccc277$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $3082ec01c2ccc277$var$sampleDelta,
        ease: "linear"
    };
}
class $3082ec01c2ccc277$export$2a45abb4e6513325 extends (0, $f4943dd7aa3faf9e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $f42804f83f4371ca$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($3082ec01c2ccc277$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $3082ec01c2ccc277$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $b6864579ea2deeda$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $bcb1fcceb380e4cd$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $bdd2758ba14e7fc4$export$8793edee2d425525;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $bdd2758ba14e7fc4$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $35655f18d178520c$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $3082ec01c2ccc277$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $3082ec01c2ccc277$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $3082ec01c2ccc277$var$supportsWaapi() && name && (0, $f10cdca7d77c81ea$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




function $f60cd7cf226bdd06$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $da858f109646e9e4$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $da858f109646e9e4$export$ec99c0ef4978dccb)(onFrame);
}



const $2721cac22396f495$export$20d68f04f30763a5 = (0, $9298b904c72c4cad$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $747faef877a1aa0d$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $2721cac22396f495$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $f60cd7cf226bdd06$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


const $4f0ac1b338a44c47$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd)=>(onComplete)=>{
        const valueTransition = (0, $22d0d7d15a4390a5$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $22d0d7d15a4390a5$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $68999112eeb6910d$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $c0a901977371eb7f$export$888a3d84909f9e3d).current || (0, $0e2650f5a5001016$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $bcb1fcceb380e4cd$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $da858f109646e9e4$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $747faef877a1aa0d$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $3082ec01c2ccc277$export$2a45abb4e6513325).supports(options)) return new (0, $3082ec01c2ccc277$export$2a45abb4e6513325)(options);
        else return new (0, $35655f18d178520c$export$fd98d9cca67a58bc)(options);
    };




class $023e73907af64bc6$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $c3a87dadbcad932c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $c3a87dadbcad932c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $1f19417e03f49a81$var$MAX_VELOCITY_DELTA = 30;
const $1f19417e03f49a81$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $1f19417e03f49a81$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $1f19417e03f49a81$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.3.31";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $1f19417e03f49a81$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $023e73907af64bc6$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $da858f109646e9e4$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($1f19417e03f49a81$export$67fcd818a264039d.current) $1f19417e03f49a81$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $1f19417e03f49a81$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $1f19417e03f49a81$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $9de9549c4845cd3c$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $1f19417e03f49a81$export$ce8bdc721e76545f(init, options) {
    return new $1f19417e03f49a81$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $338280056622a093$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $1f19417e03f49a81$export$ce8bdc721e76545f)(value));
}
function $338280056622a093$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $98638e388064355b$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $17182e68fda22ffe$export$5485128c47bd48bb)(target[key]);
        $338280056622a093$var$setMotionValue(visualElement, key, value);
    }
}




function $45aba0379cee6ca8$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $bc90b91dc291ba84$export$8592e1c077c890a6];
}





class $c8354d7fac4bc9ae$export$3fe5fa490af65f85 extends (0, $1f19417e03f49a81$export$8cea36d14ee64562) {
    constructor(){
        super(...arguments);
        this.output = [];
        this.counts = new Map();
    }
    add(name) {
        const styleName = (0, $25fb24a8bf2dfd8a$export$b3f9dd865b560c6)(name);
        if (!styleName) return;
        /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ const prevCount = this.counts.get(styleName) || 0;
        this.counts.set(styleName, prevCount + 1);
        if (prevCount === 0) {
            this.output.push(styleName);
            this.update();
        }
        /**
         * Prevents the remove function from being called multiple times.
         */ let hasRemoved = false;
        return ()=>{
            if (hasRemoved) return;
            hasRemoved = true;
            const newCount = this.counts.get(styleName) - 1;
            this.counts.set(styleName, newCount);
            if (newCount === 0) {
                (0, $c3a87dadbcad932c$export$fe2d9b4e03920b4c)(this.output, styleName);
                this.update();
            }
        };
    }
    update() {
        this.set(this.output.length ? this.output.join(", ") : "auto");
    }
}



function $9e2826f066f9517d$export$98397f3adbf6259f(value) {
    return Boolean((0, $b174766382de4d58$export$605d60a2578142d3)(value) && value.add);
}


function $321d200f39007788$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $c8354d7fac4bc9ae$export$3fe5fa490af65f85)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $9e2826f066f9517d$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $214fd6bf942c3984$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $214fd6bf942c3984$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $214fd6bf942c3984$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $22d0d7d15a4390a5$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $45aba0379cee6ca8$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $da858f109646e9e4$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $4f0ac1b338a44c47$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $321d200f39007788$export$3ac5aed310be0bee)(visualElement, key)));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $da858f109646e9e4$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $338280056622a093$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $7bdf443f485f1ace$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $98638e388064355b$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $214fd6bf942c3984$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $7bdf443f485f1ace$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $7bdf443f485f1ace$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($7bdf443f485f1ace$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($7bdf443f485f1ace$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $7bdf443f485f1ace$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $35f1393f3f94bc11$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $7bdf443f485f1ace$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $7bdf443f485f1ace$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $98638e388064355b$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $214fd6bf942c3984$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}


const $4a79c488992935f8$var$reversePriorityOrder = [
    ...(0, $82d627d5aca8db85$export$16e45afcc206d3a8)
].reverse();
const $4a79c488992935f8$var$numAnimationTypes = (0, $82d627d5aca8db85$export$16e45afcc206d3a8).length;
function $4a79c488992935f8$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $35f1393f3f94bc11$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $4a79c488992935f8$export$bb53502b7a672aa8(visualElement) {
    let animate = $4a79c488992935f8$var$animateList(visualElement);
    let state = $4a79c488992935f8$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $98638e388064355b$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $4a79c488992935f8$var$numAnimationTypes; i++){
            const type = $4a79c488992935f8$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $4b6a123e70fc63fa$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $f427edcc6ef3d862$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $4a79c488992935f8$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $dd9796e9348b1a5d$export$9153ad4c4999f4a0)(next) && (0, $dd9796e9348b1a5d$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $23b5db3145517195$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $4a79c488992935f8$var$createState();
            isInitialRender = true;
        }
    };
}
function $4a79c488992935f8$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $23b5db3145517195$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $4a79c488992935f8$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $4a79c488992935f8$var$createState() {
    return {
        animate: $4a79c488992935f8$var$createTypeState(true),
        whileInView: $4a79c488992935f8$var$createTypeState(),
        whileHover: $4a79c488992935f8$var$createTypeState(),
        whileTap: $4a79c488992935f8$var$createTypeState(),
        whileDrag: $4a79c488992935f8$var$createTypeState(),
        whileFocus: $4a79c488992935f8$var$createTypeState(),
        exit: $4a79c488992935f8$var$createTypeState()
    };
}



class $03afa96eec749fa2$export$b45b3fe5caabdca extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $4a79c488992935f8$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $f427edcc6ef3d862$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $23aa7acd0d5f239f$var$id = 0;
class $23aa7acd0d5f239f$export$4989d1eb6104cc6c extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $23aa7acd0d5f239f$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $f256603ffeeb107d$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $03afa96eec749fa2$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $23aa7acd0d5f239f$export$4989d1eb6104cc6c)
    }
};









const $ede5a98109664199$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $ede5a98109664199$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $ede5a98109664199$export$9f17032d917177de(a.x, b.x);
    const yDelta = $ede5a98109664199$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $9ce46a922925eb36$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $9ce46a922925eb36$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $ede5a98109664199$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $da858f109646e9e4$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $9ce46a922925eb36$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $da858f109646e9e4$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $9ce46a922925eb36$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $9ce46a922925eb36$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $fdeda1b56b432c34$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $c3e261b53a099ead$export$12f84bb882d06e1a)(event);
        const initialInfo = $9ce46a922925eb36$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $da858f109646e9e4$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $9ce46a922925eb36$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $9852e6ab6dd2ac4e$export$a4627e546088548d)((0, $a0729997323e3766$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $a0729997323e3766$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $a0729997323e3766$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $da858f109646e9e4$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $9ce46a922925eb36$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $9ce46a922925eb36$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $9ce46a922925eb36$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $9ce46a922925eb36$var$subtractPoint(point, $9ce46a922925eb36$var$lastDevicePoint(history)),
        offset: $9ce46a922925eb36$var$subtractPoint(point, $9ce46a922925eb36$var$startDevicePoint(history)),
        velocity: $9ce46a922925eb36$var$getVelocity(history, 0.1)
    };
}
function $9ce46a922925eb36$var$startDevicePoint(history) {
    return history[0];
}
function $9ce46a922925eb36$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $9ce46a922925eb36$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $9ce46a922925eb36$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $15fb6145a9c5f30b$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $15fb6145a9c5f30b$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







const $f55d90ca3a5731fa$var$SCALE_PRECISION = 0.0001;
const $f55d90ca3a5731fa$var$SCALE_MIN = 1 - $f55d90ca3a5731fa$var$SCALE_PRECISION;
const $f55d90ca3a5731fa$var$SCALE_MAX = 1 + $f55d90ca3a5731fa$var$SCALE_PRECISION;
const $f55d90ca3a5731fa$var$TRANSLATE_PRECISION = 0.01;
const $f55d90ca3a5731fa$var$TRANSLATE_MIN = 0 - $f55d90ca3a5731fa$var$TRANSLATE_PRECISION;
const $f55d90ca3a5731fa$var$TRANSLATE_MAX = 0 + $f55d90ca3a5731fa$var$TRANSLATE_PRECISION;
function $f55d90ca3a5731fa$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $f55d90ca3a5731fa$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $f55d90ca3a5731fa$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $f55d90ca3a5731fa$export$c1c127004b72a37(target) / $f55d90ca3a5731fa$export$c1c127004b72a37(source);
    delta.translate = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $f55d90ca3a5731fa$var$SCALE_MIN && delta.scale <= $f55d90ca3a5731fa$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $f55d90ca3a5731fa$var$TRANSLATE_MIN && delta.translate <= $f55d90ca3a5731fa$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $f55d90ca3a5731fa$export$c0d25e96fc67d310(delta, source, target, origin) {
    $f55d90ca3a5731fa$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $f55d90ca3a5731fa$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $f55d90ca3a5731fa$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $f55d90ca3a5731fa$export$c1c127004b72a37(relative);
}
function $f55d90ca3a5731fa$export$426154f9d100f99(target, relative, parent) {
    $f55d90ca3a5731fa$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $f55d90ca3a5731fa$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $f55d90ca3a5731fa$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $f55d90ca3a5731fa$export$c1c127004b72a37(layout);
}
function $f55d90ca3a5731fa$export$2785bfcc929c5650(target, layout, parent) {
    $f55d90ca3a5731fa$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $f55d90ca3a5731fa$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $03e10795371095c3$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $03e10795371095c3$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $03e10795371095c3$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $03e10795371095c3$export$690c180aa5775042(layoutBox.x, left, right),
        y: $03e10795371095c3$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $03e10795371095c3$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $03e10795371095c3$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $03e10795371095c3$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $03e10795371095c3$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $03e10795371095c3$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(source);
    const targetLength = (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $b49335144235184c$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $b49335144235184c$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $03e10795371095c3$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $03e10795371095c3$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $03e10795371095c3$export$7c5eaef8f4723d22(dragElastic = $03e10795371095c3$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $03e10795371095c3$export$a3366d3bac43a742;
    return {
        x: $03e10795371095c3$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $03e10795371095c3$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $03e10795371095c3$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $03e10795371095c3$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $03e10795371095c3$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $03e10795371095c3$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $47f4d2defa8e216f$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $47f4d2defa8e216f$export$3d227df54007d73a = ()=>({
        x: $47f4d2defa8e216f$export$ff25708b37f72782(),
        y: $47f4d2defa8e216f$export$ff25708b37f72782()
    });
const $47f4d2defa8e216f$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $47f4d2defa8e216f$export$6459fc9e86be362e = ()=>({
        x: $47f4d2defa8e216f$export$6db76765312617ac(),
        y: $47f4d2defa8e216f$export$6db76765312617ac()
    });


function $871a91479be541f5$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $7c2241105638f4b2$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $7c2241105638f4b2$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $7c2241105638f4b2$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $f41e5d312a9deb57$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $f41e5d312a9deb57$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$f41e5d312a9deb57$var$isIdentityScale(scale) || !$f41e5d312a9deb57$var$isIdentityScale(scaleX) || !$f41e5d312a9deb57$var$isIdentityScale(scaleY);
}
function $f41e5d312a9deb57$export$a545127cf1fbb600(values) {
    return $f41e5d312a9deb57$export$bdf30dca883ea463(values) || $f41e5d312a9deb57$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $f41e5d312a9deb57$export$bf80f5f8f4dc327f(values) {
    return $f41e5d312a9deb57$var$is2DTranslate(values.x) || $f41e5d312a9deb57$var$is2DTranslate(values.y);
}
function $f41e5d312a9deb57$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $b8f106d55ad9bbd4$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $b8f106d55ad9bbd4$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $b8f106d55ad9bbd4$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $b8f106d55ad9bbd4$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $b8f106d55ad9bbd4$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $b8f106d55ad9bbd4$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $b8f106d55ad9bbd4$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $b8f106d55ad9bbd4$export$d80074982803af5c(box, { x: x, y: y }) {
    $b8f106d55ad9bbd4$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $b8f106d55ad9bbd4$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $b8f106d55ad9bbd4$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $b8f106d55ad9bbd4$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $b8f106d55ad9bbd4$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $b8f106d55ad9bbd4$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $b8f106d55ad9bbd4$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $f41e5d312a9deb57$export$a545127cf1fbb600)(node.latestValues)) $b8f106d55ad9bbd4$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $b8f106d55ad9bbd4$var$TREE_SCALE_SNAP_MAX && treeScale.x > $b8f106d55ad9bbd4$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $b8f106d55ad9bbd4$var$TREE_SCALE_SNAP_MAX && treeScale.y > $b8f106d55ad9bbd4$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $b8f106d55ad9bbd4$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $b8f106d55ad9bbd4$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $b8f106d55ad9bbd4$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $b8f106d55ad9bbd4$export$58b16271041fbfb(box, transform) {
    $b8f106d55ad9bbd4$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $b8f106d55ad9bbd4$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $8b6f4744289dca53$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $7c2241105638f4b2$export$d3955c6a8f65a36b)((0, $7c2241105638f4b2$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $8b6f4744289dca53$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $8b6f4744289dca53$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $b8f106d55ad9bbd4$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $b8f106d55ad9bbd4$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $f899286af5a82d77$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $03eb39f8e84fca2b$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $03eb39f8e84fca2b$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $c3e261b53a099ead$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $5e28bec1081f60a1$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $03dbaa7517065106$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
            this.removeWillChange = (0, $321d200f39007788$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $03eb39f8e84fca2b$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $9ce46a922925eb36$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $f899286af5a82d77$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        var _a;
        (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$03eb39f8e84fca2b$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $03e10795371095c3$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $27725de4af5e1030$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $03e10795371095c3$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $03e10795371095c3$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $03e10795371095c3$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $27725de4af5e1030$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $f63b64e92c2a19e4$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $8b6f4744289dca53$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $03e10795371095c3$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $7c2241105638f4b2$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $7c2241105638f4b2$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            if (!$03eb39f8e84fca2b$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $4f0ac1b338a44c47$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false, (0, $321d200f39007788$export$3ac5aed310be0bee)(this.visualElement, axis)));
    }
    stopAnimation() {
        (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$03eb39f8e84fca2b$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $27725de4af5e1030$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $03e10795371095c3$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            if (!$03eb39f8e84fca2b$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $03eb39f8e84fca2b$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $a0729997323e3766$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $27725de4af5e1030$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $da858f109646e9e4$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $30b07f782189bf37$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $03e10795371095c3$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $03eb39f8e84fca2b$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $03eb39f8e84fca2b$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $7fcec4ca741e597a$export$5d97dc2872682820 extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
        this.removeListeners = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
        this.controls = new (0, $03eb39f8e84fca2b$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $96851d357334f4f7$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $96851d357334f4f7$export$b4f8f1ee75ce5859 extends (0, $c3848bb710a5005b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $9ce46a922925eb36$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $f899286af5a82d77$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $96851d357334f4f7$var$asyncHandler(onPanSessionStart),
            onStart: $96851d357334f4f7$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $a0729997323e3766$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $45eeb5e04d327eb0$export$2a8c16d82a0a0e26() {
    const context = (0, $aqdBs.useContext)((0, $ec2595e9e9997037$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $aqdBs.useId)();
    (0, $aqdBs.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $aqdBs.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $45eeb5e04d327eb0$export$8249053f690ea39a() {
    return $45eeb5e04d327eb0$export$ee27c052bca048fb((0, $aqdBs.useContext)((0, $ec2595e9e9997037$export$f224e4635b6f8ce2)));
}
function $45eeb5e04d327eb0$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $2458875d1ef428da$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $cbb016be5500a841$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $cbb016be5500a841$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $03dbaa7517065106$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $cbb016be5500a841$export$fafff692be55225d(latest, node.target.x);
        const y = $cbb016be5500a841$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $6d458bdf51ee3d1b$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $7384eba00d1ce525$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $7384eba00d1ce525$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};





class $35b3b1bdc30ff89c$var$MeasureLayoutWithContext extends (0, $aqdBs.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $cf22175a737a0f8a$export$de9e7791c71225fd)($35b3b1bdc30ff89c$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $2458875d1ef428da$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $8f61580f0f073a44$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $35b3b1bdc30ff89c$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $45eeb5e04d327eb0$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $aqdBs.useContext)((0, $29b76a43c78cea20$export$a3579ca508007a95));
    return (0, $14024a6d51999040$exports.jsx)($35b3b1bdc30ff89c$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $aqdBs.useContext)((0, $d0a9e5cdbd928545$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $35b3b1bdc30ff89c$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $cbb016be5500a841$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $cbb016be5500a841$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $cbb016be5500a841$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $cbb016be5500a841$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $cbb016be5500a841$export$5eafb6257a5844c),
    boxShadow: (0, $6d458bdf51ee3d1b$export$eb0bc629e74dcf8)
};








const $dadecba60ed33882$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $dadecba60ed33882$var$numBorders = $dadecba60ed33882$var$borders.length;
const $dadecba60ed33882$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $dadecba60ed33882$var$isPx = (value)=>typeof value === "number" || (0, $03dbaa7517065106$export$91c0eda1d06bf008).test(value);
function $dadecba60ed33882$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $dadecba60ed33882$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $dadecba60ed33882$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $dadecba60ed33882$var$numBorders; i++){
        const borderLabel = `border${$dadecba60ed33882$var$borders[i]}Radius`;
        let followRadius = $dadecba60ed33882$var$getRadius(follow, borderLabel);
        let leadRadius = $dadecba60ed33882$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $dadecba60ed33882$var$isPx(followRadius) === $dadecba60ed33882$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)($dadecba60ed33882$var$asNumber(followRadius), $dadecba60ed33882$var$asNumber(leadRadius), progress), 0);
            if ((0, $03dbaa7517065106$export$626336c2cd4b14de).test(leadRadius) || (0, $03dbaa7517065106$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $dadecba60ed33882$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $dadecba60ed33882$var$easeCrossfadeIn = $dadecba60ed33882$var$compress(0, 0.5, (0, $09ebde36bc2d9b19$export$c8d67a19199d1a50));
const $dadecba60ed33882$var$easeCrossfadeOut = $dadecba60ed33882$var$compress(0.5, 0.95, (0, $bdd2758ba14e7fc4$export$8793edee2d425525));
function $dadecba60ed33882$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $b49335144235184c$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $bb01e9983277152b$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $bb01e9983277152b$export$c53fd88f45d77e4b(box, originBox) {
    $bb01e9983277152b$export$a0230ae482601ae8(box.x, originBox.x);
    $bb01e9983277152b$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $bb01e9983277152b$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $84ac64189401d016$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $b8f106d55ad9bbd4$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $b8f106d55ad9bbd4$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $84ac64189401d016$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $03dbaa7517065106$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $84ac64189401d016$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $84ac64189401d016$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $84ac64189401d016$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $84ac64189401d016$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $84ac64189401d016$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $84ac64189401d016$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $84ac64189401d016$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $84ac64189401d016$export$42b76f1d0d16d5b(box.x, transforms, $84ac64189401d016$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $84ac64189401d016$export$42b76f1d0d16d5b(box.y, transforms, $84ac64189401d016$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $7a17718e4062b86e$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $7a17718e4062b86e$export$a7ec7642fe550fb6(delta) {
    return $7a17718e4062b86e$var$isAxisDeltaZero(delta.x) && $7a17718e4062b86e$var$isAxisDeltaZero(delta.y);
}
function $7a17718e4062b86e$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $7a17718e4062b86e$export$8d5cf76bb7daff09(a, b) {
    return $7a17718e4062b86e$export$7a9a6f114ddd0fdb(a.x, b.x) && $7a17718e4062b86e$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $7a17718e4062b86e$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $7a17718e4062b86e$export$ef641b782d85522(a, b) {
    return $7a17718e4062b86e$export$22adf28bfca1c186(a.x, b.x) && $7a17718e4062b86e$export$22adf28bfca1c186(a.y, b.y);
}
function $7a17718e4062b86e$export$c5706146bc63213(box) {
    return (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(box.x) / (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(box.y);
}
function $7a17718e4062b86e$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $94f8ca6cfe7f082c$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $c3a87dadbcad932c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $c3a87dadbcad932c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $fa062ec6aa153a59$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $28979d28a8d83d85$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $193ab60be7cc4e67$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $c3a87dadbcad932c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $c3a87dadbcad932c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $28979d28a8d83d85$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $e0639ab4756e629c$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $da858f109646e9e4$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $da858f109646e9e4$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $da858f109646e9e4$export$ec99c0ef4978dccb)(checkElapsed);
}



function $5d8a3d44beed707e$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $eb52a6c96d0fa199$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $b174766382de4d58$export$605d60a2578142d3)(value) ? value : (0, $1f19417e03f49a81$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $4f0ac1b338a44c47$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $e6d4705b1dc50aad$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $e6d4705b1dc50aad$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $e6d4705b1dc50aad$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $e6d4705b1dc50aad$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $e6d4705b1dc50aad$var$animationTarget = 1000;
let $e6d4705b1dc50aad$var$id = 0;
function $e6d4705b1dc50aad$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $e6d4705b1dc50aad$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $45aba0379cee6ca8$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $da858f109646e9e4$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $e6d4705b1dc50aad$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $e6d4705b1dc50aad$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $e6d4705b1dc50aad$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($e6d4705b1dc50aad$var$isDebug) $e6d4705b1dc50aad$var$metrics.totalNodes = $e6d4705b1dc50aad$var$metrics.resolvedTargetDeltas = $e6d4705b1dc50aad$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($e6d4705b1dc50aad$export$131f2f0cc5fe9609);
                this.nodes.forEach($e6d4705b1dc50aad$var$resolveTargetDelta);
                this.nodes.forEach($e6d4705b1dc50aad$var$calcProjection);
                this.nodes.forEach($e6d4705b1dc50aad$export$c2664f37bc951031);
                if ($e6d4705b1dc50aad$var$isDebug) window.MotionDebug.record($e6d4705b1dc50aad$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $193ab60be7cc4e67$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $023e73907af64bc6$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $5d8a3d44beed707e$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $e0639ab4756e629c$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $2458875d1ef428da$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $2458875d1ef428da$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($e6d4705b1dc50aad$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $e6d4705b1dc50aad$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $7a17718e4062b86e$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $22d0d7d15a4390a5$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $e6d4705b1dc50aad$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $da858f109646e9e4$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($e6d4705b1dc50aad$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $e6d4705b1dc50aad$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($e6d4705b1dc50aad$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($e6d4705b1dc50aad$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($e6d4705b1dc50aad$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($e6d4705b1dc50aad$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($e6d4705b1dc50aad$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $5c713de314b44f1b$export$2da9be4cfdb689b1).now();
            (0, $da858f109646e9e4$export$fff89137e9e818ce).delta = (0, $ff9f9b2b40bb3329$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $da858f109646e9e4$export$fff89137e9e818ce).timestamp);
            (0, $da858f109646e9e4$export$fff89137e9e818ce).timestamp = now;
            (0, $da858f109646e9e4$export$fff89137e9e818ce).isProcessing = true;
            (0, $da858f109646e9e4$export$be3f796aed065412).update.process((0, $da858f109646e9e4$export$fff89137e9e818ce));
            (0, $da858f109646e9e4$export$be3f796aed065412).preRender.process((0, $da858f109646e9e4$export$fff89137e9e818ce));
            (0, $da858f109646e9e4$export$be3f796aed065412).render.process((0, $da858f109646e9e4$export$fff89137e9e818ce));
            (0, $da858f109646e9e4$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $8f61580f0f073a44$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($e6d4705b1dc50aad$var$clearSnapshot);
            this.sharedNodes.forEach($e6d4705b1dc50aad$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $da858f109646e9e4$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $da858f109646e9e4$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $7a17718e4062b86e$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $f41e5d312a9deb57$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $e6d4705b1dc50aad$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($e6d4705b1dc50aad$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $b8f106d55ad9bbd4$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $b8f106d55ad9bbd4$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $b8f106d55ad9bbd4$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $b8f106d55ad9bbd4$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $b8f106d55ad9bbd4$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $f41e5d312a9deb57$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $b8f106d55ad9bbd4$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $f41e5d312a9deb57$export$a545127cf1fbb600)(this.latestValues)) (0, $b8f106d55ad9bbd4$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $f41e5d312a9deb57$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $f41e5d312a9deb57$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $84ac64189401d016$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $f41e5d312a9deb57$export$a545127cf1fbb600)(this.latestValues)) (0, $84ac64189401d016$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $da858f109646e9e4$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $da858f109646e9e4$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                    (0, $f55d90ca3a5731fa$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $f55d90ca3a5731fa$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $b8f106d55ad9bbd4$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                    (0, $f55d90ca3a5731fa$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($e6d4705b1dc50aad$var$isDebug) $e6d4705b1dc50aad$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $f41e5d312a9deb57$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $f41e5d312a9deb57$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $da858f109646e9e4$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $b8f106d55ad9bbd4$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $bb01e9983277152b$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $bb01e9983277152b$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $f55d90ca3a5731fa$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $7a17718e4062b86e$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $7a17718e4062b86e$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($e6d4705b1dc50aad$var$isDebug) $e6d4705b1dc50aad$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $47f4d2defa8e216f$export$3d227df54007d73a)();
            this.projectionDelta = (0, $47f4d2defa8e216f$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $47f4d2defa8e216f$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $47f4d2defa8e216f$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($e6d4705b1dc50aad$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $e6d4705b1dc50aad$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $e6d4705b1dc50aad$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $f55d90ca3a5731fa$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $e6d4705b1dc50aad$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $7a17718e4062b86e$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                    (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $dadecba60ed33882$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $da858f109646e9e4$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $da858f109646e9e4$export$2cef06c20297c17d).update(()=>{
                (0, $2458875d1ef428da$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $eb52a6c96d0fa199$export$335a17c977067b99)(0, $e6d4705b1dc50aad$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($e6d4705b1dc50aad$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $e6d4705b1dc50aad$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                const xLength = (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $bb01e9983277152b$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $b8f106d55ad9bbd4$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $f55d90ca3a5731fa$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $94f8ca6cfe7f082c$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $e6d4705b1dc50aad$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $e6d4705b1dc50aad$var$transformAxes.length; i++){
                $e6d4705b1dc50aad$var$resetDistortingTransform(`rotate${$e6d4705b1dc50aad$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $e6d4705b1dc50aad$var$resetDistortingTransform(`skew${$e6d4705b1dc50aad$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $e6d4705b1dc50aad$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $d54487322d67fb88$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $d54487322d67fb88$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $f41e5d312a9deb57$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $fa062ec6aa153a59$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $cf22175a737a0f8a$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $cf22175a737a0f8a$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $d54487322d67fb88$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($e6d4705b1dc50aad$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $e6d4705b1dc50aad$var$updateLayout(node) {
    node.updateLayout();
}
function $e6d4705b1dc50aad$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($e6d4705b1dc50aad$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $871a91479be541f5$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $f55d90ca3a5731fa$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $47f4d2defa8e216f$export$3d227df54007d73a)();
        (0, $f55d90ca3a5731fa$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $47f4d2defa8e216f$export$3d227df54007d73a)();
        if (isShared) (0, $f55d90ca3a5731fa$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $f55d90ca3a5731fa$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $7a17718e4062b86e$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                    (0, $f55d90ca3a5731fa$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
                    (0, $f55d90ca3a5731fa$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $7a17718e4062b86e$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $e6d4705b1dc50aad$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($e6d4705b1dc50aad$var$isDebug) $e6d4705b1dc50aad$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $e6d4705b1dc50aad$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $e6d4705b1dc50aad$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $e6d4705b1dc50aad$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $e6d4705b1dc50aad$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $e6d4705b1dc50aad$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $e6d4705b1dc50aad$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $e6d4705b1dc50aad$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $e6d4705b1dc50aad$var$calcProjection(node) {
    node.calcProjection();
}
function $e6d4705b1dc50aad$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $e6d4705b1dc50aad$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $e6d4705b1dc50aad$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $e6d4705b1dc50aad$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $41f7600f89d72ce6$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $e6d4705b1dc50aad$export$6ffd3e6ae339a132(output, from, to, p) {
    $e6d4705b1dc50aad$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $e6d4705b1dc50aad$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $e6d4705b1dc50aad$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $e6d4705b1dc50aad$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $e6d4705b1dc50aad$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $e6d4705b1dc50aad$var$roundPoint = $e6d4705b1dc50aad$var$userAgentContains("applewebkit/") && !$e6d4705b1dc50aad$var$userAgentContains("chrome/") ? Math.round : (0, $bdd2758ba14e7fc4$export$8793edee2d425525);
function $e6d4705b1dc50aad$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $e6d4705b1dc50aad$var$roundPoint(axis.min);
    axis.max = $e6d4705b1dc50aad$var$roundPoint(axis.max);
}
function $e6d4705b1dc50aad$var$roundBox(box) {
    $e6d4705b1dc50aad$var$roundAxis(box.x);
    $e6d4705b1dc50aad$var$roundAxis(box.y);
}
function $e6d4705b1dc50aad$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $f55d90ca3a5731fa$export$28d0384c4b79bde2)((0, $7a17718e4062b86e$export$c5706146bc63213)(snapshot), (0, $7a17718e4062b86e$export$c5706146bc63213)(layout), 0.2);
}
function $e6d4705b1dc50aad$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $d4cb59cae5f47753$export$2d029a49a09b6177 = (0, $e6d4705b1dc50aad$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $30b07f782189bf37$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a507d6aeff695f82$export$b91509fcf893b648 = {
    current: undefined
};
const $a507d6aeff695f82$export$b61a9eb3dbde8858 = (0, $e6d4705b1dc50aad$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a507d6aeff695f82$export$b91509fcf893b648.current) {
            const documentNode = new (0, $d4cb59cae5f47753$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a507d6aeff695f82$export$b91509fcf893b648.current = documentNode;
        }
        return $a507d6aeff695f82$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $99ec882e922d4645$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $96851d357334f4f7$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $7fcec4ca741e597a$export$5d97dc2872682820),
        ProjectionNode: (0, $a507d6aeff695f82$export$b61a9eb3dbde8858),
        MeasureLayout: $35b3b1bdc30ff89c$export$779f5fb01ad751cd
    }
};



var $aqdBs = parcelRequire("aqdBs");








// Does this device prefer reduced motion? Returns `null` server-side.
const $3e7635c759a1b50e$export$ff7706047246b98b = {
    current: null
};
const $3e7635c759a1b50e$export$6476d16e2fd2d0db = {
    current: false
};


function $c5e2e3de62478095$export$ca9f41fb23dded3d() {
    (0, $3e7635c759a1b50e$export$6476d16e2fd2d0db).current = true;
    if (!(0, $201dce3b0ffc9438$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $3e7635c759a1b50e$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $3e7635c759a1b50e$export$ff7706047246b98b).current = false;
}












function $5e53aaa3e206d923$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $b174766382de4d58$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $b174766382de4d58$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $1f19417e03f49a81$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $1f19417e03f49a81$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $dd465c3a87ba478c$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $17534fa1cf0adba0$var$valueTypes = [
    ...(0, $a951967510396e1e$export$d176691c1998a1f5),
    (0, $adaeaefd70ded231$export$35e9368ef982300f),
    (0, $7384eba00d1ce525$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $17534fa1cf0adba0$export$950e7e59ea1ffed7 = (v)=>$17534fa1cf0adba0$var$valueTypes.find((0, $2ba8617457534c99$export$6eae4d0a6a7ca7cd)(v));






const $e8aff6d61c2f538b$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e8aff6d61c2f538b$var$numVariantProps = (0, $82d627d5aca8db85$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e8aff6d61c2f538b$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $2121b659d6ab5da6$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            this.isRenderScheduled = false;
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.isRenderScheduled = false;
        this.scheduleRender = ()=>{
            if (!this.isRenderScheduled) {
                this.isRenderScheduled = true;
                (0, $da858f109646e9e4$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $0f71c5f58aee6d21$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $0f71c5f58aee6d21$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $b174766382de4d58$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $dd465c3a87ba478c$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $3e7635c759a1b50e$export$6476d16e2fd2d0db).current) (0, $c5e2e3de62478095$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $3e7635c759a1b50e$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $dd465c3a87ba478c$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $da858f109646e9e4$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $da858f109646e9e4$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $da858f109646e9e4$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $fb7b4da6dbbf0981$export$65570e08d843624d){
            const featureDefinition = (0, $fb7b4da6dbbf0981$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $47f4d2defa8e216f$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e8aff6d61c2f538b$var$propEventHandlers.length; i++){
            const key = $e8aff6d61c2f538b$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $5e53aaa3e206d923$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e8aff6d61c2f538b$var$numVariantProps; i++){
            const name = (0, $82d627d5aca8db85$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $4b6a123e70fc63fa$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $1f19417e03f49a81$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $b9f09cf5c3b837af$export$65583ed5a868f2d9)(value) || (0, $327614556bc46d16$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $17534fa1cf0adba0$export$950e7e59ea1ffed7)(value) && (0, $7384eba00d1ce525$export$83a0e34f1302825b).test(target)) value = (0, $5d6b90ee59d1f7cf$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $b174766382de4d58$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $b174766382de4d58$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $a3af003fe383772a$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $b174766382de4d58$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $023e73907af64bc6$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $dfbfc3a911850ba8$export$e49735c2a366bdc7 extends (0, $e8aff6d61c2f538b$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $f42804f83f4371ca$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $390a661d9c89920e$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $390a661d9c89920e$export$23fea75b03ac16b3 extends (0, $dfbfc3a911850ba8$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
        this.renderInstance = (0, $790745892039e685$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $94410fa53221ef8d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $390a661d9c89920e$export$3735103072e4a80(instance);
            const value = ((0, $fc7f1298786c2ca0$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $8b6f4744289dca53$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $bb944cc56ea095cf$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $5483e8e2203edd76$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $b174766382de4d58$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}












class $1d8e9f53154a18af$export$86bcdffbaf733d84 extends (0, $dfbfc3a911850ba8$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $47f4d2defa8e216f$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $032a8b903b1240cf$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $94410fa53221ef8d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $fe0d5c55833ee0a7$export$28931db5d57958e5).has(key) ? (0, $121800c2821ef5f8$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $00d5dc0c9386a00b$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $dc9b5a4ef8e0098e$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $594e41917d2e7fd4$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $2fa760979a79cd54$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $9e941c9f55606c3b$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ab69ffa832b458c8$export$88f3fc2fd3766989)(Component) ? new (0, $1d8e9f53154a18af$export$86bcdffbaf733d84)(options) : new (0, $390a661d9c89920e$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $aqdBs.Fragment)
    });
};




const $a81a73caf88dfbb5$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a507d6aeff695f82$export$b61a9eb3dbde8858),
        MeasureLayout: $35b3b1bdc30ff89c$export$779f5fb01ad751cd
    }
};


const $ff2432f5bc6a7b59$var$preloadedFeatures = {
    ...(0, $f256603ffeeb107d$export$7f9953c70dacfd7f),
    ...(0, $73324faa6a2e8a7c$export$e5b72898e5a201f1),
    ...(0, $99ec882e922d4645$export$d7d5d435647ed5a0),
    ...(0, $a81a73caf88dfbb5$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $ff2432f5bc6a7b59$export$e25e478948902b8b = /*@__PURE__*/ (0, $4db221893ad49f6d$export$a28d6df673050e18)((Component, config)=>(0, $b80137b18c8ab85b$export$732916c0e88175fb)(Component, config, $ff2432f5bc6a7b59$var$preloadedFeatures, (0, $9e941c9f55606c3b$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $ff2432f5bc6a7b59$export$546614c4a05701f9(key) {
    return (0, $8df54ac2a962c382$export$46b7e4b9dc6110c3)((0, $b80137b18c8ab85b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $ff2432f5bc6a7b59$var$preloadedFeatures, (0, $9e941c9f55606c3b$export$56ba0183203348f5)));
}




parcelRequire("aqdBs");
const $553c0384bcc268e8$export$ceaf35c25d4b1fe2 = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: `flex flex-col flex-1 overflow-hidden ${className}`,
        children: children
    });
};



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $172d8be976204b2c$var$extendStatics = function(d, b) {
    $172d8be976204b2c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $172d8be976204b2c$var$extendStatics(d, b);
};
function $172d8be976204b2c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $172d8be976204b2c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $172d8be976204b2c$export$18ce0697a983be9b = function() {
    $172d8be976204b2c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $172d8be976204b2c$export$18ce0697a983be9b.apply(this, arguments);
};
function $172d8be976204b2c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $172d8be976204b2c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $172d8be976204b2c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $172d8be976204b2c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $172d8be976204b2c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $172d8be976204b2c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $172d8be976204b2c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $172d8be976204b2c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $172d8be976204b2c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $172d8be976204b2c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $172d8be976204b2c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $172d8be976204b2c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $172d8be976204b2c$export$45d3717a4c69092e(o, m, p);
}
function $172d8be976204b2c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $172d8be976204b2c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $172d8be976204b2c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($172d8be976204b2c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $172d8be976204b2c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $172d8be976204b2c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $172d8be976204b2c$export$10c90e4f7922046c(v) {
    return this instanceof $172d8be976204b2c$export$10c90e4f7922046c ? (this.v = v, this) : new $172d8be976204b2c$export$10c90e4f7922046c(v);
}
function $172d8be976204b2c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $172d8be976204b2c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $172d8be976204b2c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $172d8be976204b2c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $172d8be976204b2c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $172d8be976204b2c$export$19a8beecd37a4c45 === "function" ? $172d8be976204b2c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $172d8be976204b2c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $172d8be976204b2c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $172d8be976204b2c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $172d8be976204b2c$export$45d3717a4c69092e(result, mod, k);
    }
    $172d8be976204b2c$var$__setModuleDefault(result, mod);
    return result;
}
function $172d8be976204b2c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $172d8be976204b2c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $172d8be976204b2c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $172d8be976204b2c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $172d8be976204b2c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $172d8be976204b2c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $172d8be976204b2c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $172d8be976204b2c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $172d8be976204b2c$export$2e2bcd8739ae039 = {
    __extends: $172d8be976204b2c$export$a8ba968b8961cb8a,
    __assign: $172d8be976204b2c$export$18ce0697a983be9b,
    __rest: $172d8be976204b2c$export$3c9a16f847548506,
    __decorate: $172d8be976204b2c$export$29e00dfd3077644b,
    __param: $172d8be976204b2c$export$d5ad3fd78186038f,
    __metadata: $172d8be976204b2c$export$f1db080c865becb9,
    __awaiter: $172d8be976204b2c$export$1050f835b63b671e,
    __generator: $172d8be976204b2c$export$67ebef60e6f28a6,
    __createBinding: $172d8be976204b2c$export$45d3717a4c69092e,
    __exportStar: $172d8be976204b2c$export$f33643c0debef087,
    __values: $172d8be976204b2c$export$19a8beecd37a4c45,
    __read: $172d8be976204b2c$export$8d051b38c9118094,
    __spread: $172d8be976204b2c$export$afc72e2116322959,
    __spreadArrays: $172d8be976204b2c$export$6388937ca91ccae8,
    __spreadArray: $172d8be976204b2c$export$1216008129fb82ed,
    __await: $172d8be976204b2c$export$10c90e4f7922046c,
    __asyncGenerator: $172d8be976204b2c$export$e427f37a30a4de9b,
    __asyncDelegator: $172d8be976204b2c$export$bbd80228419bb833,
    __asyncValues: $172d8be976204b2c$export$e3b29a3d6162315f,
    __makeTemplateObject: $172d8be976204b2c$export$4fb47efe1390b86f,
    __importStar: $172d8be976204b2c$export$c21735bcef00d192,
    __importDefault: $172d8be976204b2c$export$da59b14a69baef04,
    __classPrivateFieldGet: $172d8be976204b2c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $172d8be976204b2c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $172d8be976204b2c$export$81fdc39f203e4e04,
    __addDisposableResource: $172d8be976204b2c$export$88ac25d8e944e405,
    __disposeResources: $172d8be976204b2c$export$8f076105dc360e92
};



function $05f5778c5ab0b450$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}




function $3cef9e42331fd3f7$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $00a1b410f3b260db$export$c9648b76fd580c34 = (0, $3cef9e42331fd3f7$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $e8e876cb550757fc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $b41b6919b06a9c7a$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $172d8be976204b2c$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $00a1b410f3b260db$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $172d8be976204b2c$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $b41b6919b06a9c7a$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $00a1b410f3b260db$export$c9648b76fd580c34)) errors = (0, $172d8be976204b2c$export$1216008129fb82ed)((0, $172d8be976204b2c$export$1216008129fb82ed)([], (0, $172d8be976204b2c$export$8d051b38c9118094)(errors)), (0, $172d8be976204b2c$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $00a1b410f3b260db$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $b41b6919b06a9c7a$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $e8e876cb550757fc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $e8e876cb550757fc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $b41b6919b06a9c7a$export$610f9c3ca1a38dd8 = $b41b6919b06a9c7a$export$f55210826850c514.EMPTY;
function $b41b6919b06a9c7a$export$4f9221cbada3c4fc(value) {
    return value instanceof $b41b6919b06a9c7a$export$f55210826850c514 || value && "closed" in value && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.remove) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.add) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $b41b6919b06a9c7a$var$execFinalizer(finalizer) {
    if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $3b16620d824f520f$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $eb8a668ebc96aefa$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $eb8a668ebc96aefa$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $172d8be976204b2c$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $172d8be976204b2c$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $172d8be976204b2c$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $172d8be976204b2c$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $eb8a668ebc96aefa$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $e86a9a0e6142ea8b$export$ebf645db02d3e99f(err) {
    (0, $eb8a668ebc96aefa$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $3b16620d824f520f$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $31dab41fe7fd17f2$export$8793edee2d425525() {}


var $3d7cb8da4549b798$export$b7f97edb34bc1f87 = function() {
    return $3d7cb8da4549b798$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $3d7cb8da4549b798$export$dd472c3d8fe5a85a(error) {
    return $3d7cb8da4549b798$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $3d7cb8da4549b798$export$ff9346b0d1d30313(value) {
    return $3d7cb8da4549b798$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $3d7cb8da4549b798$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $380bcfb1f3db1eaa$var$context = null;
function $380bcfb1f3db1eaa$export$d974811edc77eafa(cb) {
    if ((0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$380bcfb1f3db1eaa$var$context;
        if (isRoot) $380bcfb1f3db1eaa$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $380bcfb1f3db1eaa$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $380bcfb1f3db1eaa$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $380bcfb1f3db1eaa$export$3e205fbb5df021e0(err) {
    if ((0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $380bcfb1f3db1eaa$var$context) {
        $380bcfb1f3db1eaa$var$context.errorThrown = true;
        $380bcfb1f3db1eaa$var$context.error = err;
    }
}


var $70b98591e108978e$export$60959659b2c22881 = function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $b41b6919b06a9c7a$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $70b98591e108978e$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $70b98591e108978e$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $70b98591e108978e$var$handleStoppedNotification((0, $3d7cb8da4549b798$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $70b98591e108978e$var$handleStoppedNotification((0, $3d7cb8da4549b798$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $70b98591e108978e$var$handleStoppedNotification((0, $3d7cb8da4549b798$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $b41b6919b06a9c7a$export$f55210826850c514));
var $70b98591e108978e$var$_bind = Function.prototype.bind;
function $70b98591e108978e$var$bind(fn, thisArg) {
    return $70b98591e108978e$var$_bind.call(fn, thisArg);
}
var $70b98591e108978e$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $70b98591e108978e$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $70b98591e108978e$var$handleUnhandledError(error);
        }
        else $70b98591e108978e$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $70b98591e108978e$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $70b98591e108978e$export$94eeb6a328cab6c7 = function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $70b98591e108978e$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $70b98591e108978e$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $70b98591e108978e$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $70b98591e108978e$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($70b98591e108978e$export$60959659b2c22881);
function $70b98591e108978e$var$handleUnhandledError(error) {
    if ((0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $380bcfb1f3db1eaa$export$3e205fbb5df021e0)(error);
    else (0, $e86a9a0e6142ea8b$export$ebf645db02d3e99f)(error);
}
function $70b98591e108978e$var$defaultErrorHandler(err) {
    throw err;
}
function $70b98591e108978e$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $3b16620d824f520f$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $eb8a668ebc96aefa$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $70b98591e108978e$export$88d395d20619a0af = {
    closed: true,
    next: (0, $31dab41fe7fd17f2$export$8793edee2d425525),
    error: $70b98591e108978e$var$defaultErrorHandler,
    complete: (0, $31dab41fe7fd17f2$export$8793edee2d425525)
};



var $0dff8e331e378c71$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $eca44be9bcf850b6$export$f0954fd7d5368655(x) {
    return x;
}


function $93a55b0ddb948a0e$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $93a55b0ddb948a0e$export$71f88a61afaa14d7(fns);
}
function $93a55b0ddb948a0e$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $eca44be9bcf850b6$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $e3c0f2c8393ef6d6$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $e3c0f2c8393ef6d6$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $70b98591e108978e$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $e3c0f2c8393ef6d6$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $70b98591e108978e$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $0dff8e331e378c71$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $93a55b0ddb948a0e$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $e3c0f2c8393ef6d6$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $e3c0f2c8393ef6d6$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $3b16620d824f520f$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $e3c0f2c8393ef6d6$var$isObserver(value) {
    return value && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.next) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.error) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.complete);
}
function $e3c0f2c8393ef6d6$var$isSubscriber(value) {
    return value && value instanceof (0, $70b98591e108978e$export$60959659b2c22881) || $e3c0f2c8393ef6d6$var$isObserver(value) && (0, $b41b6919b06a9c7a$export$4f9221cbada3c4fc)(value);
}




var $d3b8ea83756f8399$export$f708eee25634bc80 = (0, $3cef9e42331fd3f7$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $22e3718eb0fb14a8$export$b6bbab5a9b109038 = function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $22e3718eb0fb14a8$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $d3b8ea83756f8399$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $172d8be976204b2c$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $b41b6919b06a9c7a$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $b41b6919b06a9c7a$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $e8e876cb550757fc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $22e3718eb0fb14a8$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4));
var $22e3718eb0fb14a8$export$155189cde295587d = function(_super) {
    (0, $172d8be976204b2c$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $b41b6919b06a9c7a$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($22e3718eb0fb14a8$export$b6bbab5a9b109038);


const $9b74fde4346260a9$var$commandFlow = new (0, $22e3718eb0fb14a8$export$b6bbab5a9b109038)();
var $9b74fde4346260a9$export$8edb9eb018a796b3;
(function(RxCommand) {
    function sendCommand(name, data) {
        $9b74fde4346260a9$var$commandFlow.next({
            name: name,
            data: data
        });
    }
    RxCommand.sendCommand = sendCommand;
    function listenCommand(name, callback) {
        return $9b74fde4346260a9$var$commandFlow.subscribe((command)=>{
            if (command.name === name) callback(command.data);
        });
    }
    RxCommand.listenCommand = listenCommand;
    function useCommandHandler(name, callback, dependencies) {
        $aqdBs.useEffect(()=>{
            const subscription = listenCommand(name, (data)=>{
                callback(data);
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }, dependencies ?? []);
    }
    RxCommand.useCommandHandler = useCommandHandler;
})($9b74fde4346260a9$export$8edb9eb018a796b3 || ($9b74fde4346260a9$export$8edb9eb018a796b3 = {}));


const $e19d3c3a0bfabdbe$var$appState = {};
var $e19d3c3a0bfabdbe$export$a0e153c73743701a;
(function(AppState) {
    function pushState(key, value) {
        $e19d3c3a0bfabdbe$var$appState[key] = value;
        (0, $9b74fde4346260a9$export$8edb9eb018a796b3).sendCommand("app-state-update", {
            key: key,
            value: value
        });
    }
    AppState.pushState = pushState;
    function getState(name) {
        return $e19d3c3a0bfabdbe$var$appState[name];
    }
    AppState.getState = getState;
    function useState(name, initialValue) {
        const initializing = initialValue && !$e19d3c3a0bfabdbe$var$appState[name];
        if (initializing) $e19d3c3a0bfabdbe$var$appState[name] = initialValue;
        const [value, setValue] = $aqdBs.useState($e19d3c3a0bfabdbe$var$appState[name]);
        $aqdBs.useEffect(()=>{
            const subscription = (0, $9b74fde4346260a9$export$8edb9eb018a796b3).listenCommand("app-state-update", (data)=>{
                if (data.key === name) setValue(data.value);
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }, []);
        if (initializing) setTimeout(()=>{
            AppState.pushState(name, initialValue);
        }, 50);
        return [
            value,
            (newValue)=>{
                pushState(name, newValue);
            }
        ];
    }
    AppState.useState = useState;
})($e19d3c3a0bfabdbe$export$a0e153c73743701a || ($e19d3c3a0bfabdbe$export$a0e153c73743701a = {}));


var $62120ae8b5cc05ef$export$15520f29d5e18294;
(function(ServerApi) {
    async function postJson(endpoint, payload, auth) {
        const results = await fetch(endpoint, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "Token": auth
            },
            body: JSON.stringify(payload)
        });
        if (results.ok) try {
            const data = await results.json();
            return {
                status: results.status,
                data: data
            };
        } catch (e) {
            return null;
        }
        else {
            console.log(`Request failed ${results.status} -> ${results.statusText}`);
            return {
                status: results.status,
                statusText: results.statusText
            };
        }
    }
    ServerApi.postJson = postJson;
    async function getJson(endpoint, auth) {
        const results = await fetch(endpoint, {
            method: "GET",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "Token": auth
            }
        });
        if (results.ok) {
            const data = await results.json();
            return {
                status: results.status,
                data: data
            };
        } else {
            console.log(`Request failed ${results.status} -> ${results.statusText}`);
            return {
                status: results.status,
                statusText: results.statusText
            };
        }
    }
    ServerApi.getJson = getJson;
})($62120ae8b5cc05ef$export$15520f29d5e18294 || ($62120ae8b5cc05ef$export$15520f29d5e18294 = {}));


const $67d770f471077c69$export$21a94553ffa41578 = ({ defaultRoute: defaultRoute, children: children })=>{
    const [user, setUser] = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).useState("current-user", null);
    const [username, setUsername] = $aqdBs.useState("");
    const [password, setPassword] = $aqdBs.useState("");
    const [stayConnected, setStayConnected] = $aqdBs.useState(true);
    const [shake, setShake] = $aqdBs.useState(false);
    const navigate = (0, $3e7e4c969b7540c8$export$9770f232ac06a008)();
    $aqdBs.useEffect(()=>{
        if (!user) {
            const storedUser = $67d770f471077c69$export$1e060e77a27c83ed();
            setUser(storedUser);
        }
    }, []);
    $aqdBs.useEffect(()=>{
        if (user) navigate(defaultRoute);
    }, [
        user
    ]);
    const performLogin = async ()=>{
        if (username && password) {
            const response = await (0, $62120ae8b5cc05ef$export$15520f29d5e18294).postJson("/api/login", {
                login: username,
                password: password
            });
            if (response.status === 200) {
                const userProfile = response.data;
                setUser(userProfile);
                if (stayConnected) {
                    const userJSON = JSON.stringify(userProfile);
                    localStorage.setItem("current-user", userJSON);
                }
            } else if (response.status === 403) {
                // Failed
                setShake(true);
                setTimeout(()=>{
                    setShake(false);
                }, 1000);
            } else console.log(response.status, response.statusText);
        }
    };
    const captureEnter = (event)=>{
        if (event.key === "Enter") {
            // Cancel the default action, if needed
            event.preventDefault();
            performLogin();
        }
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $553c0384bcc268e8$export$ceaf35c25d4b1fe2), {
        className: "items-center justify-center p-4",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $ff2432f5bc6a7b59$export$e25e478948902b8b).div, {
            className: "flex flex-col p-4 rounded-md bg-base-200 w-full max-w-md",
            animate: shake ? {
                x: [
                    0,
                    -10,
                    10,
                    -10,
                    10,
                    0
                ]
            } : {},
            transition: {
                duration: 0.5
            },
            onKeyDown: captureEnter,
            children: [
                children,
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("label", {
                    className: "flex flex-col space-y-1 my-1",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "text-xs",
                            children: "Nom d'utilisateur"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                            className: "input input-sm",
                            value: username,
                            onChange: (e)=>setUsername(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("label", {
                    className: "flex flex-col space-y-1 my-1",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "text-xs",
                            children: "Mot de passe"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                            className: "input input-sm",
                            type: "password",
                            value: password,
                            onChange: (e)=>setPassword(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("label", {
                    className: "cursor-pointer label",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "label-text",
                            children: "Rester connect\xe9"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                            type: "checkbox",
                            className: "checkbox checkbox-sm",
                            checked: stayConnected,
                            onChange: (e)=>setStayConnected(e.target.checked)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    className: "flex justify-center mt-4",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                        className: "btn btn-sm btn-accent",
                        onClick: performLogin,
                        disabled: username.length === 0 || password.length === 0,
                        children: "Se Connecter"
                    })
                })
            ]
        })
    });
};
function $67d770f471077c69$export$464881f0a7cf0212() {
    localStorage.setItem("current-user", null);
    (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).pushState("current-user", null);
}
function $67d770f471077c69$export$1e060e77a27c83ed() {
    const userJSON = localStorage.getItem("current-user");
    if (userJSON) {
        const storedUser = JSON.parse(userJSON);
        return storedUser;
    } else return null;
}
function $67d770f471077c69$export$e5432d4c8eb97ea7() {
    return (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).getState("current-user");
}
function $67d770f471077c69$export$3901076af3749fa9() {
    let savedUser = $67d770f471077c69$export$1e060e77a27c83ed();
    let currentUser = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).getState("current-user");
    if (!currentUser && savedUser) $67d770f471077c69$export$c542b5e295206b2a(savedUser);
    const [user] = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).useState("current-user", savedUser);
    return user;
}
function $67d770f471077c69$export$aae23f3a65fbe750() {
    const navigate = (0, $3e7e4c969b7540c8$export$9770f232ac06a008)();
    let savedUser = $67d770f471077c69$export$1e060e77a27c83ed();
    let currentUser = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).getState("current-user");
    if (!currentUser && savedUser) $67d770f471077c69$export$c542b5e295206b2a(savedUser);
    const [user] = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).useState("current-user", savedUser);
    $aqdBs.useEffect(()=>{
        if (!user) navigate("/login");
    }, [
        user
    ]);
    return user;
}
async function $67d770f471077c69$export$c542b5e295206b2a(user) {
    const response = await (0, $62120ae8b5cc05ef$export$15520f29d5e18294).postJson("/api/refresh_token", null, user.token);
    if (response.status === 200) {
        const userProfile = response.data;
        (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).pushState("current-user", userProfile);
        const userJSON = JSON.stringify(userProfile);
        localStorage.setItem("current-user", userJSON);
        return userProfile;
    } else if (response.status === 403) $67d770f471077c69$export$464881f0a7cf0212();
    else console.log(response.status, response.statusText);
}




parcelRequire("aqdBs");

const $4bad2c2a8da0c8b1$var$DEFAULT_THEME = "dark";
const $4bad2c2a8da0c8b1$export$e2e9b8b5e72b52f3 = ({ children: children })=>{
    const [theme, setTheme] = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).useState("app-theme", $4bad2c2a8da0c8b1$var$DEFAULT_THEME);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        "data-theme": theme,
        className: "h-full w-full overflow-hidden flex flex-col",
        children: children
    });
};



parcelRequire("aqdBs");


parcelRequire("aqdBs");
const $8c7829e031d70fc4$export$6c0524ba53950d9f = ({ userName: userName })=>{
    const initials = $8c7829e031d70fc4$var$getInitials(userName);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "avatar placeholder",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: "bg-neutral text-neutral-content w-8 rounded-full",
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "text-xs",
                children: initials
            })
        })
    });
};
function $8c7829e031d70fc4$var$getInitials(fullName) {
    if (typeof fullName !== "string" || fullName.trim().length === 0) return "U";
    const names = fullName.trim().split(" ");
    if (names.length === 1) return names[0].slice(0, 2).toUpperCase();
    const firstNameInitial = names[0][0].toUpperCase();
    const lastNameInitial = names[names.length - 1][0].toUpperCase();
    return firstNameInitial + lastNameInitial;
}



parcelRequire("aqdBs");
const $a08cbfd5fbb669e2$export$2c9e30524eeaa42e = ({})=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: "h-4 w-4",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
            d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C15.2713 2 18.1757 3.57078 20.0002 5.99923L17.2909 5.99931C15.8807 4.75499 14.0285 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C14.029 20 15.8816 19.2446 17.2919 17.9998L20.0009 17.9998C18.1765 20.4288 15.2717 22 12 22ZM19 16V13H11V11H19V8L24 12L19 16Z"
        })
    });
};


parcelRequire("aqdBs");



parcelRequire("aqdBs");

parcelRequire("aqdBs");
const $5c43d685ae3a2c4f$export$46e1d66043f363e6 = ({})=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: "h-4 w-4",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("path", {
            d: "M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"
        })
    });
};



const $d64748ac5168d5a0$export$e22848205b1fd6dc = ({})=>{
    const openDrawer = ()=>{
        (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).pushState(`nav-drawer-visible`, true);
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "md:hidden",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
            className: "btn btn-square btn-sm btn-ghost",
            onClick: openDrawer,
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5c43d685ae3a2c4f$export$46e1d66043f363e6), {})
        })
    });
};



parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $abc38e5265a12261$var$PopChildMeasure extends $aqdBs.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $abc38e5265a12261$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $aqdBs.useId)();
    const ref = (0, $aqdBs.useRef)(null);
    const size = (0, $aqdBs.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $aqdBs.useContext)((0, $e2cb17888fa727a9$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $aqdBs.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $14024a6d51999040$exports.jsx)($abc38e5265a12261$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $aqdBs.cloneElement(children, {
            ref: ref
        })
    });
}


const $2517801d54d83c9d$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $ca8730202900f961$export$fe4300aa8eebea86)($2517801d54d83c9d$var$newChildrenMap);
    const id = (0, $aqdBs.useId)();
    const context = (0, $aqdBs.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $aqdBs.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $aqdBs.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $14024a6d51999040$exports.jsx)((0, $abc38e5265a12261$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $14024a6d51999040$exports.jsx)((0, $ec2595e9e9997037$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $2517801d54d83c9d$var$newChildrenMap() {
    return new Map();
}






var $aqdBs = parcelRequire("aqdBs");
const $1cf448ee4c84b0bb$export$10e61aed958678dd = (child)=>child.key || "";
function $1cf448ee4c84b0bb$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $aqdBs.Children).forEach(children, (child)=>{
        if ((0, $aqdBs.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $017ab3fd80b2aee3$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $f63b64e92c2a19e4$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $aqdBs.useMemo)(()=>(0, $1cf448ee4c84b0bb$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $1cf448ee4c84b0bb$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $aqdBs.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $aqdBs.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $ca8730202900f961$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $aqdBs.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $aqdBs.useState)(presentChildren);
    (0, $d0769678dab3d9d0$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $1cf448ee4c84b0bb$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $1cf448ee4c84b0bb$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $1cf448ee4c84b0bb$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $aqdBs.useContext)((0, $29b76a43c78cea20$export$a3579ca508007a95));
    return (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $1cf448ee4c84b0bb$export$10e61aed958678dd)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $14024a6d51999040$exports.jsx)((0, $2517801d54d83c9d$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};


parcelRequire("aqdBs");

const $12fef15ce11c4fef$export$7b98f7b2abd01120 = ({ children: children, className: className })=>{
    const [status, setStatus] = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).useState(`nav-drawer-visible`);
    const toggleCheckbox = ()=>{
        setStatus(!status);
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $017ab3fd80b2aee3$export$3ae376d12526dd6f), {
            children: status && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $ff2432f5bc6a7b59$export$e25e478948902b8b).div, {
                initial: {
                    translateX: "-100%"
                },
                animate: {
                    translateX: "0%"
                },
                exit: {
                    translateX: "-100%"
                },
                transition: {
                    ease: "easeInOut"
                },
                className: `fixed z-50 md:hidden w-full h-full rounded-lg top-0 left-0 backdrop-blur-sm`,
                onClick: toggleCheckbox,
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "fixed w-full h-full bg-black opacity-50 rounded-lg top-0 left-0 "
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "relative z-50 py-2 px-4 w-8/12 h-full bg-base-200 opacity-100 flex flex-col p-2",
                        children: children
                    })
                ]
            })
        })
    });
};







const $737fd4f1105c3470$export$8e6816940d167d02 = ({})=>{
    const [user] = (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).useState("current-user");
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $12fef15ce11c4fef$export$7b98f7b2abd01120), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "flex space-x-2 my-4",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                        className: "h-8 w-8 rounded-full",
                        src: "/resources/profile.jpeg"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "text-lg font-bold",
                        children: [
                            "ZebraLab - ",
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                className: "font-normal permanent-marker-regular",
                                children: "MVP as a Service"
                            })
                        ]
                    })
                ]
            }),
            user && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "flex items-center space-x-2 p-2 border rounded-md my-4",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $8c7829e031d70fc4$export$6c0524ba53950d9f), {
                        userName: user.full_name
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "flex-1 text-sm line-clamp-1",
                        children: user.full_name
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                        className: "btn btn-sm btn-square btn-ghost",
                        onClick: (0, $67d770f471077c69$export$464881f0a7cf0212),
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $a08cbfd5fbb669e2$export$2c9e30524eeaa42e), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "flex-1 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: "p-2 m-1 cursor-pointer hover:text-primary",
                        children: "Pr\xe9sentation"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                        to: "/submit_project",
                        className: "p-2 m-1 cursor-pointer hover:text-primary",
                        children: "Proposer mon MVP"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                        to: "/client",
                        className: "p-2 m-1 cursor-pointer hover:text-primary",
                        children: "Espace Client"
                    })
                ]
            }),
            user && user.roles.includes("Admin") && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "flex",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                    to: "/analytics",
                    className: "p-2 m-1 cursor-pointer btn btn-sm btn-primary w-full",
                    children: "Admin"
                })
            })
        ]
    });
};


const $29107ba4c3f6101a$export$9bd256435c34a030 = ({})=>{
    const user = (0, $67d770f471077c69$export$3901076af3749fa9)();
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "fixed z-10 w-full flex items-center p-4 space-x-2 bg-base-100 bg-opacity-50 backdrop-blur-sm",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d64748ac5168d5a0$export$e22848205b1fd6dc), {}),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                        className: "h-8 w-8 rounded-full",
                        src: "/resources/profile.jpeg"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "text-lg font-bold",
                        children: [
                            "ZebraLab - ",
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                className: "font-normal permanent-marker-regular",
                                children: "MVP as a Service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "space-x-2 hidden md:flex",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                                to: "/",
                                className: "btn btn-sm btn-primary btn-ghost",
                                children: "Pr\xe9sentation"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                                to: "/submit_project",
                                className: "btn btn-sm btn-primary btn-ghost",
                                children: "Proposer mon MVP"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                                to: "/client",
                                className: "btn btn-sm btn-primary btn-ghost",
                                children: "Espace Client"
                            })
                        ]
                    }),
                    user && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "flex items-center space-x-2 hidden md:flex",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $8c7829e031d70fc4$export$6c0524ba53950d9f), {
                                userName: user.full_name
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                className: "btn btn-sm btn-square btn-ghost",
                                onClick: (0, $67d770f471077c69$export$464881f0a7cf0212),
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $a08cbfd5fbb669e2$export$2c9e30524eeaa42e), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $737fd4f1105c3470$export$8e6816940d167d02), {})
        ]
    });
};



const $5d2335bbc3ebe33e$export$b94310965bed44e6 = ({})=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: "flex flex-col flex-1 overflow-auto",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $29107ba4c3f6101a$export$9bd256435c34a030), {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "hero bg-base-200 min-h-screen pt-8",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    className: "hero-content text-center",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "max-w-prose",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                                className: "text-3xl sm:text-5xl  font-bold my-2",
                                children: "Construisons ensemble"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                                className: "text-3xl sm:text-5xl font-bold my-2",
                                children: "votre"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                                className: "text-3xl sm:text-5xl font-bold my-2",
                                children: "MVP \uD83D\uDE80 boost\xe9 par l'IA \uD83E\uDD16"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                className: "py-6 text-xl sm:text-2xl",
                                children: "Votre vision, notre expertise : d\xe9veloppez des MVP intelligents gr\xe2ce au Machine Learning et \xe0 l'IA, en un temps record !"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$a6c7ac8248d6e38a), {
                                to: "/submit_project",
                                className: "btn btn-primary",
                                children: "Proposer mon MVP"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "hero bg-base-200 sm:min-h-screen",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "hero-content flex flex-col text-center gap-0 p-4",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                            className: "text-3xl sm:text-5xl font-bold  my-4",
                            children: "Notre Offre"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row items-stretch",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                    className: "card bg-base-100 md:w-96 shadow-xl m-2",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                                                className: "text-2xl font-bold text-primary text-center",
                                                children: "Validation de la vision"
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                children: "Nous \xe9valuons le march\xe9 ainsi que les attentes de vos utilisateurs, et surtout la bonne int\xe9gration de votre MVP dans les usages existants."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                    className: "card bg-base-100 md:w-96 shadow-xl m-2",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                                                className: "text-2xl font-bold text-primary text-center",
                                                children: "Validation Op\xe9rationnelle"
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                children: "Nous \xe9valuons les int\xe9grations techniques avec vos syst\xe8mes, les donn\xe9es \xe0 exploiter, et envisageons les diff\xe9rents mod\xe8les de ML/IA compatibles avec votre budget d'exploitation."
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row items-stretch",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                    className: "card bg-base-100 md:w-96 shadow-xl m-2",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                                                className: "text-2xl font-bold text-primary text-center",
                                                children: "R\xe9alisation Incr\xe9mentale"
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                children: "Nous r\xe9alisons et validons \xe0 chaque \xe9tape l'ad\xe9quation du MVP avec la r\xe9alit\xe9 de vos utilisateurs ainsi que la bonne int\xe9gration technique."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                    className: "card bg-base-100 md:w-96 shadow-xl m-2",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                                                className: "text-2xl font-bold text-primary text-center",
                                                children: "D\xe9ploiement Fluide"
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                children: "Nous avons la possibilit\xe9 d'h\xe9berger votre MVP ou de vous assister pour un d\xe9ploiement sur votre propre infrastructure. Nous fournissons \xe9galement les moyens d'\xe9valuer l'utilisation et l'utilisabilit\xe9 de votre MVP."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "hero bg-base-200 min-h-screen    md:my-0",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    className: "hero-content text-center",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "max-w-prose",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                                className: "text-3xl sm:text-5xl font-bold my-2",
                                children: "Qui sommes nous?"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                                className: "py-6 text-xl sm:text-2xl",
                                children: [
                                    "Notre Equipe est compos\xe9e d'",
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                        className: "text-primary",
                                        children: "experts avec plus de 10 ans d'exp\xe9rience"
                                    }),
                                    " dans leurs domaines respectifs. Chaque membre est passionn\xe9 par la ",
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                        className: "text-primary",
                                        children: "cr\xe9ation de produits intelligents"
                                    }),
                                    " au service de l'",
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                        className: "text-primary",
                                        children: "utilisateur final"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};





var $aqdBs = parcelRequire("aqdBs");


var $h5Z1H = parcelRequire("h5Z1H");

const $57a5fc54fe611932$export$5446f0d249e230ac = ({})=>{
    const [project, setProject] = $aqdBs.useState({
        id: $h5Z1H().toISOString(),
        date: $h5Z1H().toISOString(),
        kind: "ProjectSubmission",
        email: "",
        description: ""
    });
    const submit = async ()=>{
        project.id = $h5Z1H().toISOString();
        const response = await (0, $62120ae8b5cc05ef$export$15520f29d5e18294).postJson("/api/submit_project", project);
        setProject({
            id: $h5Z1H().toISOString(),
            date: $h5Z1H().toISOString(),
            kind: "ProjectSubmission",
            email: "",
            description: ""
        });
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $553c0384bcc268e8$export$ceaf35c25d4b1fe2), {
        className: "overflow-auto",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $29107ba4c3f6101a$export$9bd256435c34a030), {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "hero bg-base-200 min-h-screen",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                    className: "hero-content text-center",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "max-w-prose space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h1", {
                                className: "text-3xl font-bold my-2 mb-6",
                                children: "Proposer mon MVP"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                                type: "text",
                                placeholder: "Email",
                                className: "input input-md input-bordered w-full",
                                itemType: "email",
                                value: project.email,
                                onChange: (e)=>setProject(Object.assign({}, project, {
                                        email: e.target.value
                                    }))
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("textarea", {
                                placeholder: "Description",
                                rows: 8,
                                value: project.description,
                                className: "textarea textarea-bordered textarea-md w-full",
                                onChange: (e)=>setProject(Object.assign({}, project, {
                                        description: e.target.value
                                    }))
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                className: "btn btn-primary",
                                disabled: project.email.length === 0 || project.description.length === 0,
                                onClick: submit,
                                children: "Soumettre"
                            })
                        ]
                    })
                })
            })
        ]
    });
};






parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");


class $26062f1c7774a86a$export$95da54968687a43b {
    constructor(endpoint, authToken){
        this.endpoint = endpoint;
        this.authToken = authToken;
    }
    async getEntities(kind, ids) {
        const response = await this.post("query", {
            kind: kind,
            ids: ids
        });
        if (response.status === "success") return response.data;
        else throw Error(`"Request failed" ${response.message}`);
    }
    async updateEntities(data) {
        const response = await this.post("update", data);
        if (response.status === "success") return response.data;
        else throw Error(`"Request failed" ${response.message}`);
    }
    async queryProperty(kind, name, expression) {
        const response = await this.post("query_property", {
            kind: kind,
            name: name,
            expression: expression
        });
        if (response.status === "success") return response.data;
        else throw Error(`"Request failed" ${response.message}`);
    }
    async deleteEntities(data) {
        const entity_ids = data.map((d)=>{
            return d.id;
        });
        const entityRef = {
            kind: data[0].kind,
            ids: entity_ids
        };
        const response = await this.post("delete", entityRef);
        if (response.status === "success") return response.data;
        else throw Error(`"Request failed" ${response.message}`);
    }
    async signal(data) {
        try {
            const response = await this.post("signal", data);
            console.log(response);
            // if (response.status === 'success') {
            return response.data;
        // } else {
        //     throw Error(`"Request failed" ${response.message}`)
        // }
        } catch (e) {
            throw Error(`"Request failed" ${e}`);
        }
    }
    async post(action, payload) {
        const resp = await fetch(this.endpoint, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "Token": this.authToken
            },
            body: JSON.stringify({
                action: action,
                data: payload
            })
        });
        return await resp.json();
    }
    openSocket(path, handler) {
        const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
        const host = window.location.host;
        const url = `${protocol}//${host}/${path}`;
        const socket = new WebSocket(url);
        socket.onmessage = (event)=>{
            const payload = JSON.parse(event.data);
            handler(payload);
        };
        const closer = {
            close () {
                socket.close();
            }
        };
        return closer;
    }
}




parcelRequire("aqdBs");


parcelRequire("aqdBs");
const $825610a36648f16d$var$bounceTransition = {
    duration: 0.8,
    repeat: Infinity,
    ease: "easeInOut"
};
const $825610a36648f16d$export$2b776f7e7ee60dbd = ({ visible: visible })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "flex justify-center w-full",
        children: visible && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "flex justify-around items-center w-12 h-6 opacity-50 m-4 mt-8",
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ff2432f5bc6a7b59$export$e25e478948902b8b).div, {
                    className: "w-3 h-3 bg-base-content rounded-full",
                    transition: $825610a36648f16d$var$bounceTransition,
                    animate: {
                        translateY: [
                            "75%",
                            "-75%",
                            "75%"
                        ]
                    }
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ff2432f5bc6a7b59$export$e25e478948902b8b).div, {
                    className: "w-3 h-3 bg-base-content rounded-full",
                    transition: {
                        ...$825610a36648f16d$var$bounceTransition,
                        delay: 0.3
                    },
                    animate: {
                        translateY: [
                            "75%",
                            "-75%",
                            "75%"
                        ]
                    }
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ff2432f5bc6a7b59$export$e25e478948902b8b).div, {
                    className: "w-3 h-3 bg-base-content rounded-full",
                    transition: {
                        ...$825610a36648f16d$var$bounceTransition,
                        delay: 0.6
                    },
                    animate: {
                        translateY: [
                            "75%",
                            "-75%",
                            "75%"
                        ]
                    }
                })
            ]
        })
    });
};



const $181dca5ee5080ece$export$54c2e3dc7acea9f5 = ({ hideBorders: hideBorders, items: items, emptyMessage: emptyMessage, emptyMessageDetails: emptyMessageDetails, emptyActions: emptyActions, renderItem: renderItem, emptyIllustration: emptyIllustration, loading: loading, loadingMessage: loadingMessage, className: className })=>{
    const bordersStyle = hideBorders ? "" : "border";
    const displayedItems = items ? items : [];
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `flex-1 flex flex-col overflow-auto ${bordersStyle} border-neutral-700 rounded-lg p-2 ${className}`,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $017ab3fd80b2aee3$export$3ae376d12526dd6f), {
                children: !loading && displayedItems.length > 0 && displayedItems.map((item, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ff2432f5bc6a7b59$export$e25e478948902b8b).div, {
                        initial: {
                            opacity: 0,
                            x: -20
                        },
                        animate: {
                            opacity: 1,
                            x: 0
                        },
                        exit: {
                            opacity: 0,
                            x: -20
                        },
                        children: renderItem(item)
                    }, item.id))
            }),
            !loading && displayedItems.length === 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "flex-1 flex flex-col items-center justify-center",
                children: [
                    emptyIllustration && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "p-8",
                        children: emptyIllustration()
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "font-bold mb-1 text-center",
                        children: emptyMessage
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "font-thin mb-1 text-center",
                        children: emptyMessageDetails
                    }),
                    emptyActions && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "p-2",
                        children: emptyActions()
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "flex-1 flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $825610a36648f16d$export$2b776f7e7ee60dbd), {
                        visible: loading
                    }),
                    loadingMessage && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "font-thin m-2",
                        children: loadingMessage
                    })
                ]
            })
        ]
    });
};



var $h5Z1H = parcelRequire("h5Z1H");

const $60f4a28bcd6e3a84$export$6268df79f24c119b = ({})=>{
    const navigate = (0, $3e7e4c969b7540c8$export$9770f232ac06a008)();
    const user = (0, $67d770f471077c69$export$aae23f3a65fbe750)();
    const [userEnterEvents, setUserEnterEvents] = $aqdBs.useState([]);
    const [visitorEnterEvent, setVisitorEnterEvent] = $aqdBs.useState([]);
    const [projectSubmission, setProjectSubmission] = $aqdBs.useState([]);
    $aqdBs.useEffect(()=>{
        if (user) {
            loadEvents(user);
            loadVisitorEvents(user);
            loadProjectsEvents(user);
        }
    }, [
        user
    ]);
    const loadEvents = async (user)=>{
        const flowave = new (0, $26062f1c7774a86a$export$95da54968687a43b)(`/api/analytics`, user.token);
        try {
            const events = await flowave.getEntities("UserEnterEvent");
            events.sort((a, b)=>b.date.localeCompare(a.date));
            setUserEnterEvents(events);
        // console.log(events);
        } catch (e) {
            navigate("/login");
        // console.log(e);
        }
    };
    const loadVisitorEvents = async (user)=>{
        const flowave = new (0, $26062f1c7774a86a$export$95da54968687a43b)(`/api/analytics`, user.token);
        try {
            const events = await flowave.getEntities("VisitorEnterEvent");
            events.sort((a, b)=>b.date.localeCompare(a.date));
            setVisitorEnterEvent(events);
        // console.log(events);
        } catch (e) {
            navigate("/login");
        // console.log(e);
        }
    };
    const loadProjectsEvents = async (user)=>{
        try {
            const response = await (0, $62120ae8b5cc05ef$export$15520f29d5e18294).getJson(`/api/projects_subdmissions`, user.token);
            console.log(response.data);
            setProjectSubmission(response.data);
        } catch (e) {
            navigate("/login");
        // console.log(e);
        }
    };
    const visibleEvents = [].concat(userEnterEvents, visitorEnterEvent, projectSubmission);
    visibleEvents.sort((a, b)=>b.date.localeCompare(a.date));
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $553c0384bcc268e8$export$ceaf35c25d4b1fe2), {
        className: "p-4",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $181dca5ee5080ece$export$54c2e3dc7acea9f5), {
            hideBorders: true,
            items: visibleEvents,
            renderItem: (item)=>{
                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "my-1 space-x-2 p-2 border",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: $h5Z1H(item.date).format("DD/MM/YYYY - HH:mm")
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.kind
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.user_id
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.ip
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.host
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.user_agent
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.referer
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.accept_language
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.email
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            children: item.description
                        })
                    ]
                });
            }
        })
    });
};


const $6a929edcafb6f734$export$b21b01224ac8e558 = ({})=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $553c0384bcc268e8$export$ceaf35c25d4b1fe2), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $29107ba4c3f6101a$export$9bd256435c34a030), {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "flex-1 flex flex-col overflow-hidden mt-12",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $60f4a28bcd6e3a84$export$6268df79f24c119b), {})
            })
        ]
    });
};


const $cd93687958c8007e$var$router = (0, $3ad25f07d94ec634$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5d2335bbc3ebe33e$export$b94310965bed44e6), {})
    },
    {
        path: "/submit_project",
        element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $57a5fc54fe611932$export$5446f0d249e230ac), {})
    },
    {
        path: "/client",
        element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $553c0384bcc268e8$export$ceaf35c25d4b1fe2), {
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $29107ba4c3f6101a$export$9bd256435c34a030), {}),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $67d770f471077c69$export$21a94553ffa41578), {
                    defaultRoute: "/client",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center font-bold",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "text-2xl my-4",
                                children: "Espace Client"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                                className: "h-24 w-24 rounded-full",
                                src: "/resources/profile.jpeg"
                            })
                        ]
                    })
                })
            ]
        })
    },
    {
        path: "/login",
        element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $553c0384bcc268e8$export$ceaf35c25d4b1fe2), {
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $29107ba4c3f6101a$export$9bd256435c34a030), {}),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $67d770f471077c69$export$21a94553ffa41578), {
                    defaultRoute: "/",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "flex flex-col items-center justify-center font-bold",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                className: "text-2xl my-4",
                                children: "Espace Client"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                                className: "h-24 w-24 rounded-full",
                                src: "/resources/profile.jpeg"
                            })
                        ]
                    })
                })
            ]
        })
    },
    {
        path: "/analytics",
        element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a929edcafb6f734$export$b21b01224ac8e558), {})
    }
]);
const $cd93687958c8007e$export$86fbec116b87613f = ({})=>{
    // AppState.pushState('app-theme', 'light');
    (0, $e19d3c3a0bfabdbe$export$a0e153c73743701a).pushState("app-theme", "dim");
    // AppState.pushState('app-theme', 'dark');
    // AppState.pushState('app-theme', 'synthwave');
    // AppState.pushState('app-theme', 'night');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4bad2c2a8da0c8b1$export$e2e9b8b5e72b52f3), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($aqdBs.StrictMode, {
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3ad25f07d94ec634$export$323e4fc2fa4753fb), {
                router: $cd93687958c8007e$var$router
            })
        })
    });
};


const $70fc9a727fa662ae$var$root = (0, $c920eedc27eaef64$export$882461b6382ed46c)(document.getElementById("app"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.e65d5074.js.map
